webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSlotContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStringTypeAttr; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Common__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Muse_UI__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Mint_UI__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__iView_UI__ = __webpack_require__(220);







var getTemplate = function getTemplate(info) {
    var _attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _slots = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var component = void 0;
    switch (info.ui) {
        case 'Muse-UI':
            component = __WEBPACK_IMPORTED_MODULE_3__Muse_UI__["a" /* default */][info.name](_attr, _slots, info);
            break;
        case 'Mint-UI':
            component = __WEBPACK_IMPORTED_MODULE_4__Mint_UI__["a" /* default */][info.name](_attr, _slots, info);
            break;
        case 'iView-UI':
            component = __WEBPACK_IMPORTED_MODULE_5__iView_UI__["a" /* default */][info.name](_attr, _slots, info);
            break;
        case 'Common':
            component = __WEBPACK_IMPORTED_MODULE_2__Common__["a" /* default */][info.name](_attr, _slots, info);
            break;
    }

    //为了不让二次获取模板时丢失slot信息
    component.slot = component.attributes.slot.value;

    //为了不让slot出现在属性面板
    delete component.attributes.slot;

    //没有class属性的，添加class属性
    if (!component.attributes.class) {
        component.attributes.class = {
            type: 'text',
            value: ''
        };
    }

    //添加组件标识 (info.id是唯一标识)
    component.template = component.template.replace(' ', ' data-component-active tabIndex="0" ');

    component.info = info;

    return component;
};

var getSlotContent = function getSlotContent(slots) {
    var inner = '';
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(slots).forEach(function (slot) {
        slots[slot].forEach(function (_ref) {
            var id = _ref.id;

            var component = components.find(function (component) {
                return component.info.id === id;
            });
            var children = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(component.slots).forEach(function (slot) {
                component.slots[slot].forEach(function (item) {
                    return children.push(item);
                });
            });

            component.attributes.slot = component.slot; //设置当前组件的slot ，getTemplate中根据这个属性设置模板的slot，不存在则不设置
            component = getTemplate(component.info, component.attributes, component.slots);

            //为嵌套的组件添加id属性 具备id属性 才能选中后属性视图内容变更
            if (component.template.indexOf('id="' + id + '"') == -1) component.template = component.template.replace(' ', ' id="' + id + '" ');

            inner += component.template;
        });
    });
    return inner;
};
var getStringTypeAttr = function getStringTypeAttr(attributes) {

    // value为空的不添加到模板中
    var stringAttr = '';
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(attributes).forEach(function (key) {
        var attrKey = void 0;
        var arr = ['text', 'selection', 'icon', 'ionicon', 'color']; //这些类型都不用加bind
        if (arr.includes(attributes[key].type) || attributes[key].notBind) {
            attrKey = key;
        } else {
            attrKey = ':' + key;
        }
        var attr = attributes[key].value ? attrKey + '="' + attributes[key].value + '"\n' : '';
        stringAttr += attr;
    });
    return stringAttr;
};


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var guid = function guid() {
    //获取随机ID，组件拖到预览视图后就会被设置个ID
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4();
};
/* harmony default export */ __webpack_exports__["a"] = (guid);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeDeep;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);



/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
function isObject(item) {
    return item && (typeof item === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(item)) === 'object' && !Array.isArray(item);
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
function mergeDeep(target) {
    for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
    }

    if (!sources.length) return target;
    var source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (var key in source) {
            if (isObject(source[key])) {
                if (!target[key]) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(target, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, {}));
                mergeDeep(target[key], source[key]);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(target, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key, source[key]));
            }
        }
    }

    return mergeDeep.apply(undefined, [target].concat(sources));
}

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__preview__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__preview__);




//给定模板，和要挂载的元素id，挂载组件   
var mount = function mount(id, _component) {
    var components = _Vue.$store.state.components;
    var component = components.find(function (c) {
        return c.info.id === id;
    });
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        //需要延迟才能取到document.getElementById(id)
        setTimeout(function () {
            var _data = {};
            if (_component.attributes) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_component.attributes).forEach(function (key) {
                    _data[key] = _component.attributes[key].value;
                });
            }

            if (component.uid) {//销毁旧实例

            }
            var vm = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
                name: id.toString(),
                data: function data() {
                    return _data;
                },

                template: _component.template,
                el: document.getElementById(id),
                mounted: function mounted() {
                    this.$el.id = id;
                    if (component) {
                        component.uid = this._uid;
                    }

                    //添加选中效果
                    var info = _Vue.$store.state.currentComponent.info;
                    if (!info) this.$el.click();
                }
            });
            resolve(vm);
        }, 200);
    });
};

/* harmony default export */ __webpack_exports__["a"] = (mount);

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(283)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(566),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7ed7cb0c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(281)
  __webpack_require__(280)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(548),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3af997ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(275)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(530),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1acf11f7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(576);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'main',
        component: __webpack_require__(69)
    }, {
        path: '/share/:id', //布局分享
        name: 'share',
        component: __webpack_require__(69)
    }, {
        path: '/preview/mobile', //手机预览
        name: 'preview_mobile',
        component: __webpack_require__(522)
    }, {
        path: '/preview/pc/', //正常pc浏览
        name: 'preview_product',
        component: __webpack_require__(49)
    }, {
        path: '/preview/pc/:id', //指定布局的正常pc浏览
        component: __webpack_require__(49)
    }, {
        path: '*',
        redirect: '/'
    }]
}));

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_mergeDeep__ = __webpack_require__(5);







// 深度合并


__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */].Store({
    state: {
        width: [{
            attr: '15',
            preview: '70',
            components: '15'
        }, {
            attr: '20',
            preview: '60',
            components: '20'
        }, {
            attr: '25',
            preview: '50',
            components: '25'
        }],
        css: '', //用户编辑的自定义css字符串
        activeUI: 'Muse-UI',
        currentComponent: {}, //预览视图的选中组件
        components: [], //预览视图的组件树
        backupComponents: [], //删除组件时备份的
        copiedComponents: [] //复制的组件
    },
    mutations: {
        setState: function setState(state, obj) {
            // obj = mergeDeep(JSON.parse(JSON.stringify(state)), obj)
            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(state, obj);

            //保存本地
            localStorage.store = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(state);
        }
    },
    actions: {
        delComponent: function delComponent(context, id) {
            //删除前备份一份
            context.commit('setState', { backupComponents: JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(context.state.components)) });

            var components = context.state.components;
            var index = components.findIndex(function (c) {
                return c.info.id === id;
            });
            var component = components[index];
            //从父组件的slots中删除
            if (component.parentId) {
                var parent = components.find(function (c) {
                    return c.info.id === component.parentId;
                });
                var slot = parent.slots[component.slot || component.attributes.slot || 'default'];
                var i = slot.findIndex(function (item) {
                    return item.id === component.info.id;
                });
                //删除
                slot.splice(i, 1);

                //递归获取最父级组件
                var getTop = function getTop(_component) {
                    if (_component.parentId) {
                        var c = components.find(function (c) {
                            return c.info.id === _component.parentId;
                        });
                        return getTop(c);
                    } else {
                        return _component;
                    }
                };

                //更新模板
                var top = getTop(parent);
                top.template = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__components_template__["a" /* getTemplate */])(top.info, top.attributes, top.slots).template;
            }
            //删除当前组件所有子组件
            function delChildren(component) {
                var slots = component.slots;
                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(slots).forEach(function (slot) {
                    if (component.slots[slot].length) {
                        component.slots[slot].forEach(function (val) {
                            var childIndex = components.findIndex(function (c) {
                                return c.info.id === val.id;
                            });
                            var hasChild = void 0;
                            if (childIndex >= 0) hasChild = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(components[childIndex].slots).every(function (slot) {
                                return components[childIndex].slots[slot].length > 0;
                            });
                            if (hasChild) delChildren(components[childIndex]);
                            components.splice(childIndex, 1);
                        });
                    }
                });
            }
            delChildren(component);

            //删除自身
            index = components.findIndex(function (c) {
                return c.info.id === id;
            }); //components已被更新 重新获取索引
            components.splice(index, 1);

            //更新
            context.commit('setState', { currentComponent: {}, components: components });

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(components);
        }
    }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leancloud_storage__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leancloud_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leancloud_storage__);

var APP_ID = 'jtP7IlVD1aOBkUvgoue8BsWG-gzGzoHsz';
var APP_KEY = 'SQbJtem0VkQlb1VGc4RiaI2u';

__WEBPACK_IMPORTED_MODULE_0_leancloud_storage___default.a.init({
  appId: APP_ID,
  appKey: APP_KEY
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_leancloud_storage___default.a);

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(528),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {}
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mount__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subAttribute__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subAttribute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__subAttribute__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mergeDeep__ = __webpack_require__(5);


//
//
//
//
//




// 深度合并

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'attributes',
    data: function data() {
        return {};
    },

    computed: {
        current: {
            //当前选中组件
            get: function get(value) {
                return this.$store.state.currentComponent;
            }
        }
    },
    methods: {
        updateAttribute: function updateAttribute(attr) {
            var _this = this;

            //属性值输入事件
            var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.components));
            var index = components.findIndex(function (component) {
                return component.info.id === _this.current.info.id;
            });
            var info = this.current.info;

            attr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_mergeDeep__["a" /* default */])(this.current.attributes, attr);
            if (components[index].slot) {
                //对于嵌入组件 需要传入slot 才会在模板上带上slot属性
                attr.slot = components[index].slot;
            }
            var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__template__["a" /* getTemplate */])(info, attr, components[index].slots),
                //更新模板
            attributes = component.attributes;

            //getTemplate中可能修改了components，所以重新获取
            components = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.components));
            index = components.findIndex(function (component) {
                return component.info.id === _this.current.info.id;
            });

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(components[index]['attributes'], attributes); //更新从getTemplate获取到的最新属性
            components[index]['slots'] = component.slots;
            components[index].template = component.template;
            this.$store.commit('setState', {
                components: components
            });
            this.$store.commit('setState', {
                currentComponent: components[index]
            });

            //更新数据到vuex完毕

            //下面触发视图层变化
            if (!components[index].parentId) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__mount__["a" /* default */])(component.info.id, component, this);
            } else {
                //对于嵌套组件，更新其顶级父组件
                var topComponent = this.getParentComponent(components[index]);
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(topComponent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__template__["a" /* getTemplate */])(topComponent.info, topComponent.attributes, topComponent.slots));
                var i = components.findIndex(function (c) {
                    return c.info.id === topComponent.info.id;
                });
                components[i] = topComponent;
                this.$store.commit('setState', {
                    components: components
                });

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__mount__["a" /* default */])(topComponent.info.id, topComponent, this);
            }

            //有数据更新操作，就删除之前被删除的备份。只提供撤销删除的撤销功能
            this.$store.commit('setState', { backupComponents: [] });
        },
        getParentComponent: function getParentComponent(component) {
            var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.components));
            if (component.parentId) {
                return this.getParentComponent(components.find(function (c) {
                    return c.info.id === component.parentId;
                }));
            } else {
                return component;
            }
        }
    },
    components: {
        subAttribute: __WEBPACK_IMPORTED_MODULE_4__subAttribute___default.a
    }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorList__ = __webpack_require__(129);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'colorPicker',
    data: function data() {
        return {
            searchValue: '',
            color: this.value,
            open: false,
            trigger: null,
            colorList: __WEBPACK_IMPORTED_MODULE_0__colorList__["a" /* default */].slice(0, 50),
            scroller: null,
            loading: false

        };
    },
    mounted: function mounted() {
        this.trigger = this.$refs.button.$el;
    },

    props: {
        value: {
            default: {}
        },
        name: {
            default: ''
        }
    },
    watch: {
        value: {
            deep: true,
            handler: function handler(val, oldVal) {
                this.color = this.value;
            }
        }
    },
    methods: {
        search: function search(value) {
            if (value === '') return this.colorList = __WEBPACK_IMPORTED_MODULE_0__colorList__["a" /* default */].slice(0, 50);
            this.colorList = __WEBPACK_IMPORTED_MODULE_0__colorList__["a" /* default */].filter(function (color) {
                return color.name.indexOf(value) !== -1;
            });
        },
        changeMenu: function changeMenu(value) {
            this.closePopover();
            this.color = value;
            this.$emit('input', value);
            this.$emit('change', value);
        },
        change: function change(value) {
            this.$emit('input', value);
            this.$emit('change', value);
        },
        loadMoreMaterialIcon: function loadMoreMaterialIcon() {
            if (this.searchValue === '') this.colorList.push.apply(this.colorList, __WEBPACK_IMPORTED_MODULE_0__colorList__["a" /* default */].slice(this.colorList.length - 1, this.colorList.length - 1 + 50));
        },
        openPopover: function openPopover() {
            var _this = this;

            this.open = !this.open;
            if (this.open) setTimeout(function () {
                _this.scroller = _this.$refs.content.$el;
            }, 0);
        },
        closePopover: function closePopover() {
            this.open = false;
            this.colorList = __WEBPACK_IMPORTED_MODULE_0__colorList__["a" /* default */].slice(0, 50);
        }
    }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'componentTree',

    data: function data() {
        return {
            show: true
        };
    },

    props: {
        components: {
            type: Array,
            default: null
        }
    },
    methods: {
        slotToComponents: function slotToComponents(slot) {
            return this.$store.state.components.filter(function (c) {
                return slot.findIndex(function (item) {
                    return item.id === c.info.id;
                }) !== -1;
            });
        },
        click: function click(id) {
            var el = document.getElementById(id);
            el.click();
        }
    }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__list_muse_ui__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__list_mint_ui__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__list_iview_ui__ = __webpack_require__(132);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'components',
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    methods: {
        handleTabChange: function handleTabChange(val) {
            this.activeUI = val;
        },
        getComponent: function getComponent(e) {
            if (!e) return;
            if (e.localName !== 'li') return this.getComponent(e.parentElement);else return e;
        },
        removeDom: function removeDom(e) {
            if (e && e.parentElement) e.parentElement.removeChild(e);
        },
        dragStart: function dragStart(e) {
            var componentName = e.target.getAttribute('data-name');
            var info = {
                name: componentName,
                ui: this.activeUI
            };
            e.dataTransfer.setData('info', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(info));
        }
    },
    computed: {
        activeUI: {
            get: function get() {
                return this.$store.state.activeUI;
            },
            set: function set(val) {
                this.$store.commit('setState', {
                    activeUI: val
                });
            }
        }
    },
    components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_2__list_muse_ui__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__list_mint_ui__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__list_iview_ui__["a" /* default */])
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__iconList__ = __webpack_require__(130);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'iconPicker',
    data: function data() {
        return {
            searchValue: '',
            iconName: this.value,
            open: false,
            trigger: null,
            iconList: __WEBPACK_IMPORTED_MODULE_0__iconList__["a" /* default */].slice(0, 50),
            scroller: null,
            loading: false

        };
    },
    mounted: function mounted() {
        this.trigger = this.$refs.button.$el;
    },

    props: {
        value: {
            default: {}
        },
        name: {
            default: ''
        }
    },
    watch: {
        value: {
            deep: true,
            handler: function handler(val, oldVal) {
                this.iconName = this.value;
            }
        }
    },
    methods: {
        search: function search(value) {
            if (value === '') return this.iconList = __WEBPACK_IMPORTED_MODULE_0__iconList__["a" /* default */].slice(0, 50);
            this.iconList = __WEBPACK_IMPORTED_MODULE_0__iconList__["a" /* default */].filter(function (icon) {
                return icon.indexOf(value) !== -1;
            });
        },
        changeMenu: function changeMenu(value) {
            this.closePopover();
            this.iconName = value;
            this.$emit('input', value);
            this.$emit('change', value);
        },
        change: function change(value) {
            this.$emit('input', value);
            this.$emit('change', value);
        },
        loadMoreMaterialIcon: function loadMoreMaterialIcon() {
            if (this.searchValue === '') this.iconList.push.apply(this.iconList, __WEBPACK_IMPORTED_MODULE_0__iconList__["a" /* default */].slice(this.iconList.length - 1, this.iconList.length - 1 + 50));
        },
        openPopover: function openPopover() {
            var _this = this;

            this.open = !this.open;
            if (this.open) setTimeout(function () {
                _this.scroller = _this.$refs.content.$el;
            }, 0);
        },
        closePopover: function closePopover() {
            this.open = false;
            this.iconList = __WEBPACK_IMPORTED_MODULE_0__iconList__["a" /* default */].slice(0, 50);
        }
    }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ioniconList__ = __webpack_require__(131);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'iconPicker',
    data: function data() {
        return {
            searchValue: '',
            iconName: this.value,
            open: false,
            trigger: null,
            ioniconList: __WEBPACK_IMPORTED_MODULE_0__ioniconList__["a" /* default */].slice(0, 50),
            scroller: null,
            loading: false

        };
    },
    mounted: function mounted() {
        this.trigger = this.$refs.button.$el;
    },

    props: {
        value: {
            default: {}
        },
        name: {
            default: ''
        }
    },
    watch: {
        value: {
            deep: true,
            handler: function handler(val, oldVal) {
                this.iconName = this.value;
            }
        }
    },
    methods: {
        search: function search(value) {
            if (value === '') return this.ioniconList = __WEBPACK_IMPORTED_MODULE_0__ioniconList__["a" /* default */].slice(0, 50);
            this.ioniconList = __WEBPACK_IMPORTED_MODULE_0__ioniconList__["a" /* default */].filter(function (icon) {
                return icon.indexOf(value) !== -1;
            });
        },
        changeMenu: function changeMenu(value) {
            this.closePopover();
            this.iconName = value;
            this.$emit('input', value);
            this.$emit('change', value);
        },
        change: function change(value) {
            this.$emit('input', value);
            this.$emit('change', value);
        },
        loadMoreMaterialIcon: function loadMoreMaterialIcon() {
            if (this.searchValue === '') this.ioniconList.push.apply(this.ioniconList, __WEBPACK_IMPORTED_MODULE_0__ioniconList__["a" /* default */].slice(this.ioniconList.length - 1, this.ioniconList.length - 1 + 50));
        },
        openPopover: function openPopover() {
            var _this = this;

            this.open = !this.open;
            if (this.open) setTimeout(function () {
                _this.scroller = _this.$refs.content.$el;
            }, 0);
        },
        closePopover: function closePopover() {
            this.open = false;
            this.ioniconList = __WEBPACK_IMPORTED_MODULE_0__ioniconList__["a" /* default */].slice(0, 50);
        }
    }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            formInline: {
                user: '',
                password: ''
            },
            ruleInline: {
                user: [{ required: true, message: '请填写用户名', trigger: 'blur' }],
                password: [{ required: true, message: '请填写密码', trigger: 'blur' }, { type: 'string', min: 6, message: '密码长度不能小于6位', trigger: 'blur' }]
            }
        };
    }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            cityList: [{
                value: '1',
                label: 'Select '
            }, {
                value: '2',
                label: 'Select 2'
            }, {
                value: '3',
                label: 'Select 3'
            }],
            model1: '1'
        };
    }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'FlatButton'
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'FlatButton'
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'appbar'
    // render() {
    // 	console.log(this.$compile(`<h1></h1>`).render)
    //     return this.$compile(`<h1></h1>`).render
    // },
    // staticRenderFns(){
    // 	return this.$compile(`<h1></h1>`).staticRenderFns
    // }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'avatar'
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'backTop'
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'badge'
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'breadcrumb'
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'card'
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'cardHeader'
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'checkBox'
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'chip'
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'circularProgress'
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'datePicker'
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'divider'
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'floatingActionButton'
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'grid'
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'icon'
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'IconButton'
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'progress'
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'list'
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'listItem'
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'nav'
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pagination'
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'paper'
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'radio'
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'selectField'
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'shanGe'
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'slider'
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'badge'
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'switch'
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'tab'
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'textField'
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'timePicker'
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attributes__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attributes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__attributes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preview__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__componentTree_vue__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__componentTree_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__componentTree_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            setting: {
                open: false,
                selectEffect: true
            },
            share: {
                open: false,
                url: '',
                experience: ''
            },
            selectField: {
                value: '属性'
            }
        };
    },
    mounted: function mounted() {
        this.setSelectEffect(this.setting.selectEffect);
    },

    computed: {
        current: {
            //预览视图中选中的组件
            get: function get() {
                return this.$store.state.currentComponent;
            }
        },
        width: {
            //三栏的宽度设置
            get: function get() {
                return this.$store.state.width[0];
            }
        },
        parentComponent: {
            get: function get() {
                var _this = this;

                var component = void 0;
                if (this.current.parentId) component = this.$store.state.components.find(function (c) {
                    return c.info.id === _this.current.parentId;
                });else component = null;
                return component;
            }
        },
        components: {
            get: function get() {
                return this.$store.state.components;
            }
        }
    },
    watch: {
        components: {
            deep: true,
            handler: function handler(val, oldVal) {
                //布局修改后将分享的url设为空
                this.share.url = '';
                this.share.experience = '';
            }
        }
    },
    methods: {
        switchComponent: function switchComponent() {
            var el = document.getElementById(this.parentComponent.info.id);
            el.click();
        },
        oprate: function oprate(e) {
            // let components = await this.$store.dispatch('delComponent', this.current.info.id)
            // this.$refs.preview.fresh()
            this.$refs.preview.rightClick(e);
        },
        openUiDocument: function openUiDocument() {
            switch (this.current.info.ui) {
                case 'Muse-UI':
                    return window.open('http://www.muse-ui.org/#/' + this.current.info.name.replace(' ', ''));
                case 'Mint-UI':
                    return window.open('https://mint-ui.github.io/docs/#/zh-cn/' + this.current.info.name.replace(' ', '-'));
                case 'iView-UI':
                    return window.open('https://www.iviewui.com/components/' + this.current.info.name);
                default:
                    return this.$toast('无文档页');
            }
        },
        setSelectEffect: function setSelectEffect(val) {
            var head = document.head;
            var style = document.getElementById('vue-layout-style');
            if (!style) {
                style = document.createElement('style');
                style.id = 'vue-layout-style';
                style.type = 'text/css';
                head.appendChild(style);
            }

            var cssText = void 0;
            if (val) {
                cssText = '[data-component-active="true"] {\n                              box-shadow: inset 0px 0px 0px 1px pink!important;\n                          }\n                          [data-component-active]:hover {\n                              box-shadow: inset 0px 0px 0px 1px pink!important;\n                          }\n                          [data-component-active]:focus {\n                              box-shadow: inset 0px 0px 0px 1px pink!important;\n                          }';
            } else {
                cssText = '[data-component-active="true"] {\n                              box-shadow: none;\n                              outline:none;\n                          }\n                          [data-component-active]:hover {\n                              box-shadow: none;\n                          }\n                          [data-component-active]:focus {\n                              box-shadow: none;\n                          }';
            }
            var textNode = document.createTextNode(cssText);
            style.innerHTML = '';
            style.appendChild(textNode);
        },
        createShare: function createShare() {
            var _this2 = this;

            var share = new this.$lean.Object('Share');
            share.set('store', this.$store.state);
            share.save().then(function (res) {
                _this2.share.url = location.origin + location.pathname + '#/share/' + res.id;
                _this2.share.experience = location.origin + location.pathname + '#/preview/pc/' + res.id;
            });
        }
    },
    components: {
        components: __WEBPACK_IMPORTED_MODULE_1__components___default.a,
        preview: __WEBPACK_IMPORTED_MODULE_2__preview___default.a,
        attributes: __WEBPACK_IMPORTED_MODULE_0__attributes___default.a,
        componentTree: __WEBPACK_IMPORTED_MODULE_3__componentTree_vue___default.a
    }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mount__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_highlight_default_css__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_css_highlight_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_css_highlight_default_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_highlight_Atom_One_Light_css__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_css_highlight_Atom_One_Light_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_css_highlight_Atom_One_Light_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scopedcss__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scopedcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_scopedcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_mergeDeep__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_guid__ = __webpack_require__(4);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// 代码高亮样式



// scoped style插件 ，解决webkit不支持scoped的问题



// 深度合并

//取随机id

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'preview',
    data: function data() {
        return {
            showType: '预览',
            contextmenu: {
                trigger: null,
                open: false,
                style: {}
            },
            popover: {
                trigger: null,
                open: false
            },
            insertPosition: {
                position: null,
                component: null
            },
            previewMode: 'pc'
        };
    },
    mounted: function mounted() {
        var _this = this;

        //拖动放置位置的虚线框位置计算
        document.ondrag = function (e) {
            var _$refs$preview$getBou = _this.$refs.preview.getBoundingClientRect(),
                left = _$refs$preview$getBou.left,
                top = _$refs$preview$getBou.top;
            //鼠标在预览视图中的相对坐标
            // console.log(e.clientX,e.clientY)


            var preview = _this.$refs.preview;
            var x = e.clientX - left,
                y = e.clientY - top + preview.scrollTop;
            _this.components.filter(function (component) {
                return !component.parentId;
            }).forEach(function (component) {
                var _component$position = component.position,
                    offsetLeft = _component$position.offsetLeft,
                    offsetTop = _component$position.offsetTop,
                    offsetRight = _component$position.offsetRight,
                    offsetBottom = _component$position.offsetBottom;


                var offset = 5;
                //不在当前元素位置内
                if (!(x > offsetLeft && x < offsetRight && y > offsetTop && y < offsetBottom)) {
                    return;
                }
                //上方
                if (y > offsetTop && y < offsetTop + offset) {
                    _this.setPlaceholder('上方', component);
                    return;
                }
                //右方
                if (x < offsetRight && x > offsetRight - offset) {
                    _this.setPlaceholder('右方', component);
                    return;
                }
                //下方
                if (y < offsetBottom && y > offsetBottom - offset) {
                    _this.setPlaceholder('下方', component);
                    return;
                }
                //左方
                if (x > offsetLeft && x < offsetLeft + offset) {
                    _this.setPlaceholder('左方', component);
                    return;
                }
            });
        };

        /*由于启用drag后的元素无法获取到mouseup事件，
        所以监听body的拖拽事件，以便在鼠标松开后，
        删除虚线框占位元素
        */
        document.body.ondragover = function (e) {
            e.preventDefault();
        };

        document.body.ondrop = function (e) {
            _this.removePlaceholder();
            e.preventDefault();
        };

        //读取云端数据
        var id = this.$route.params.id;
        var query = new this.$lean.Query('Share');
        if (id) {
            query.get(id).then(function (share) {
                var store = share.get('store');
                if (store) {
                    _this.$store.commit('setState', store);
                    //dom没有渲染完成 window._Vue为undefined，加个延迟
                    setTimeout(function () {
                        _this.mount();
                    }, 0);
                }
            });
        } else if (localStorage.store) {
            //读取本地数据
            var store = JSON.parse(localStorage.store);
            this.$store.commit('setState', store);
            //dom没有渲染完成 window._Vue为undefined，加个延迟
            setTimeout(function () {
                _this.mount();
            }, 0);
        }
    },

    methods: {
        setWidth: function setWidth() {
            //调整各视图宽度比
            var width = this.width;
            var end = width.shift();
            width.push(end);
            this.width = width;
        },
        dragOver: function dragOver(e) {
            e.preventDefault();
        },
        drop: function drop(e) {
            var _this2 = this;

            //松开拖放,e是容器元素

            //CODE视图的文字拖动也会触发此事件，这里屏蔽掉
            if (e.target.className.indexOf('sound-code') !== -1 || e.target.className.indexOf('hljs') !== -1) return;

            var isNest = e.target.className.indexOf('preview') === -1 && e.target.id !== 'placeholder';
            var info = JSON.parse(e.dataTransfer.getData('info'));
            info.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_guid__["a" /* default */])();
            var name = info.name; //拖动的组件名字
            var component = void 0,
                template = void 0,
                attributes = void 0,
                slots = void 0;

            //true:嵌套行为
            if (isNest) {
                //预览视图中选中组件后，current的值指向选中组件，为空{}就是未选
                if (!this.current.info) return this.$toast('未选中嵌套目标');
                if (!__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.current.slots).length) return this.$toast('无可嵌套');
                this.popover.trigger = e.target;
                this.popover.open = true;
                var selectSlot = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                    _this2.selectedSlot = function (value) {
                        _this2.popover.open = false;
                        resolve(value);
                    };
                });
                selectSlot.then(function (slot) {
                    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this2.components));
                    var index = components.findIndex(function (item) {
                        return item.info.id === _this2.current.info.id;
                    });
                    //嵌套模板
                    var nestComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__template__["a" /* getTemplate */])(info, { //传入{slot}会给获取到的模板添加slot="xxx"
                        slot: slot
                    });

                    nestComponent.attributes.slot = slot;
                    nestComponent.parentId = components[index].info.id;

                    //getTemplate中#可能#修改了components，所以重新获取
                    components = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this2.components));
                    index = components.findIndex(function (item) {
                        return item.info.id === _this2.current.info.id;
                    });

                    //设置组件的slots
                    var slots = components[index].slots || {};
                    slots[slot].push({
                        id: nestComponent.info.id
                    });

                    components.push(nestComponent);

                    //提交一次保存 避免getTemplate中获取nestComponent失败
                    _this2.components = components;

                    //嵌套后的模板
                    component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__template__["a" /* getTemplate */])(_this2.current.info, _this2.current.attributes, slots);
                    if (!component.template) throw '没有这个组件的模板';

                    //最父级模板
                    var topComponent = _this2.getParentComponent(_this2.current);
                    topComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__template__["a" /* getTemplate */])(topComponent.info, topComponent.attributes, topComponent.slots);
                    var topIndex = components.findIndex(function (c) {
                        return c.info.id === topComponent.info.id;
                    });

                    components[topIndex] = topComponent;
                    components[index] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_mergeDeep__["a" /* default */])(components[index], component);
                    //更新模板
                    _this2.components = components;
                    _this2.mount();
                });
            } else {
                //非嵌套操作
                var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_guid__["a" /* default */])();
                component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__template__["a" /* getTemplate */])(info);
                if (!component.template) throw '没有这个组件的模板';

                var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.components));
                if (!this.insertPosition.position) {

                    components.push(component);
                    this.components = components;
                    this.mount();
                } else {
                    var index = components.findIndex(function (component) {
                        return component.info.id === _this2.insertPosition.component.info.id;
                    });
                    var position = this.insertPosition.position;
                    if (position === '下方' || position === '右方') {
                        index++;
                    }
                    components.splice(index, 0, component);

                    //占位虚线框删除后，把这个也重置为null，为null时就是默认将拖动组件添加到components最后
                    this.insertPosition = {
                        component: null,
                        position: null
                    };
                    this.components = components;
                    this.fresh();

                    /*  else end  */
                }
            }
        },
        fresh: function fresh() {
            var _this3 = this;

            /*当 Vue.js 用 v-for 正在更新已渲染过的元素列表时，
            它默认用 “就地复用” 策略。
            如果数据项的顺序被改变，
            Vue将不是移动 DOM 元素来匹配数据项的顺序，
             而是简单复用此处每个元素。
            出于此，每次components顺序变动后，只好使用清空再重新渲染的方式，否则不能成功渲染更新
             */
            var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.components));
            this.components = [];
            this.$refs.preview.innerHTML = '';

            //settimeout会等到dom重绘完成后在执行fn
            setTimeout(function () {
                _this3.components = components;
                _this3.mount();
            }, 0);
        },
        getComponentNode: function getComponentNode(node) {
            if (node && node.getAttribute('data-component-active') !== null) return node;else {
                if (node.parentElement) return this.getComponentNode(node.parentElement);else return false;
            }
        },
        clickPreview: function clickPreview(e) {
            var target = e.target;
            e.preventDefault();
            var componentHTML = this.getComponentNode(target);
            if (componentHTML) {
                //添加选中效果
                var list = document.querySelectorAll('[data-component-active="true"]');
                list.forEach(function (el) {
                    el.setAttribute('data-component-active', '');
                });
                componentHTML.setAttribute('data-component-active', 'true');

                //保存到vuex
                var currentId = componentHTML.id;
                var component = this.components.find(function (component) {
                    return component.info.id === currentId;
                });
                if (component) this.$store.commit('setState', {
                    currentComponent: component
                });
            }
        },
        mount: function mount() {
            var _this4 = this;

            //挂载及更新视图中组件的位置信息
            var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.$store.state.components));
            components.filter(function (component) {
                return !component.parentId;
            }).forEach(function (component) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__mount__["a" /* default */])(component.info.id, component).then(function (vm) {
                    var el = document.getElementById(component.info.id);
                    component.position = {
                        offsetLeft: el.offsetLeft,
                        offsetRight: el.offsetLeft + el.clientWidth,
                        offsetTop: el.offsetTop,
                        offsetBottom: el.offsetTop + el.clientHeight
                        //每次重新挂载后dom变动，更新scoped style
                    };_this4.addUserStyle();
                });
            });
            setTimeout(function () {
                _this4.components = components;
            }, 0);
        },
        setPlaceholder: function setPlaceholder(position, component) {
            //添加前删除
            this.removePlaceholder();
            //创建添加元素
            var placeholder = document.createElement('div');
            placeholder.id = 'placeholder';
            //当前悬停的组件元素
            var el = document.getElementById(component.info.id);
            switch (position) {
                case '上方':
                    this.$refs.preview.insertBefore(placeholder, el);
                    break;
                case '右方':
                    placeholder.classList.add('inline');
                    this.$refs.preview.insertBefore(placeholder, el.nextSibling);
                    break;
                case '下方':
                    this.$refs.preview.insertBefore(placeholder, el.nextSibling);
                    break;
                case '左方':
                    placeholder.classList.add('inline');
                    this.$refs.preview.insertBefore(placeholder, el);
                    break;
            }
            this.insertPosition = {
                position: position,
                component: component
            };
        },
        removePlaceholder: function removePlaceholder() {
            var placeholder = document.getElementById('placeholder');
            if (placeholder) placeholder.parentElement.removeChild(placeholder);
        },
        selectedSlot: function selectedSlot() {
            // 必需，勿删，会在ondrop中被重写
        },
        getSource: function getSource(components) {
            //预览视图中所有组件的代码
            var code = '<template><section>';
            components.filter(function (component) {
                return !component.parentId;
            }).forEach(function (component) {
                code += component.template;
            });
            code += '\n</section></template>';
            //添加用户编辑的css
            var cssText = this.$store.state.css;
            if (cssText) {
                cssText = '\n<style scoped>\n' + cssText;
                cssText += '\n</style>\n';
                code += cssText;
            }
            code = this.$prettyDom(code);

            /*把组件标签中包含的用户不需要的属性删掉，
              因为它只是为了适应预览视图，
              如，组件默认的“position:fixed”会使组件跑到预览视图外
            */
            code = code.replace(/ style=".*?"/g, '');
            code = code.replace(/ tabIndex=".*?"/g, '');
            code = code.replace(/ id=".*?"/g, '');
            code = code.replace(/ data-component-active/g, '');
            code = code.replace(/\n\n/g, '\n');

            return code;
        },
        getParentComponent: function getParentComponent(component) {
            var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.$store.state.components));
            if (component.parentId) {
                return this.getParentComponent(components.find(function (c) {
                    return c.info.id === component.parentId;
                }));
            } else {
                return component;
            }
        },

        del: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var components;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.$store.dispatch('delComponent', this.current.info.id);

                            case 2:
                                components = _context.sent;

                                this.fresh();

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function del() {
                return _ref.apply(this, arguments);
            }

            return del;
        }(),
        showCode: function showCode() {
            if (this.showType === 'CODE') this.showType = '预览';else this.showType = 'CODE';
        },
        editStyle: function editStyle() {
            if (this.showType === '编辑样式') this.showType = '预览';else this.showType = '编辑样式';
        },
        addUserStyle: function addUserStyle() {
            if (!this.css) return;
            //添加用户编辑的css效果到预览视图
            var style = document.getElementById('custom-layout');
            if (!style) {
                style = document.createElement('style');
                style.id = 'custom-layout';
                style.setAttribute('scoped', '');
                style.type = 'text/css';
                this.$refs.preview.appendChild(style);
            }
            var cssText = document.createTextNode(this.css);
            style.innerHTML = '';
            style.appendChild(cssText);
            // let sysCssText=document.createTextNode(`\ndiv:last-child{margin-bottom:100px;}`)
            // style.appendChild(sysCssText)
            // 动态添加scoped style
            __WEBPACK_IMPORTED_MODULE_8_scopedcss___default.a.applyTo(this.$refs.preview);
        },
        rightClick: function rightClick(e) {
            this.clickPreview(e);
            this.contextmenu.open = false;
            this.contextmenu.trigger = this.$refs.contextmenu;
            this.contextmenu.style = {
                position: 'fixed',
                left: e.x + 10 + 'px',
                top: e.y - 10 + 'px'
            };
            this.contextmenu.open = true;
        },
        fullScreen: function fullScreen() {
            if (document.webkitIsFullScreen) return document.webkitCancelFullScreen();
            var el = document.body;
            //Chrome
            if (el.webkitRequestFullScreen) {
                el.webkitRequestFullScreen();
                el.style.width = window.screen.width + 'px';
                el.style.height = window.screen.height + 'px';
            }
            document.addEventListener("webkitfullscreenchange", function (e) {
                if (!document.webkitIsFullScreen) {
                    el.style.width = 'inherit';
                    el.style.height = 'inherit';
                }
            }, false);
        },
        undo: function undo() {
            var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.$store.state.backupComponents));
            this.$store.commit('setState', {
                backupComponents: [],
                components: components
            });
            this.fresh();
        },
        copyComponent: function copyComponent() {
            var _this5 = this;

            var copied = [];
            var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.components));
            var current = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.current));
            var getCopiedComponents = function getCopiedComponents() {
                var component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : current;

                var hasChild = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(component.slots).filter(function (slot) {
                    return component.slots[slot].length;
                }).length;

                //修改id和parentId
                var parentId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_guid__["a" /* default */])();

                //局部的的components可能被child.info.id = guid()所改变，所以重新定义个
                var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this5.components));

                //找到了就重新赋值id,并且能够说明有传component进来，因为被传进来的id都是被改变的，不会被找到
                if (components.find(function (c) {
                    return c.info.id === component.info.id;
                })) {
                    component.info.id = parentId;
                    //被复制的组件的最父级组件
                    component.parentId = null;
                }
                if (hasChild) {
                    var arr = [];
                    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(component.slots).forEach(function (slot) {
                        component.slots[slot].forEach(function (item) {
                            var child = components.find(function (c) {
                                return c.info.id === item.id;
                            });
                            //赋予新id
                            child.info.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_guid__["a" /* default */])();
                            child.parentId = parentId;
                            item.id = child.info.id;
                            arr.push.apply(arr, getCopiedComponents(child));
                        });
                    });
                    return [component].concat(arr);
                } else {
                    return [component];
                }
            };
            var copiedComponents = getCopiedComponents();
            this.$store.commit('setState', {
                copiedComponents: copiedComponents
            });
            this.$toast('复制成功');
        },
        pasteComponent: function pasteComponent() {
            var _this6 = this;

            var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.components));
            var index = components.findIndex(function (c) {
                return c.info.id === _this6.current.info.id;
            });
            this.popover.trigger = document.getElementById(this.current.info.id);
            this.popover.open = true;
            var selectSlot = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this6.selectedSlot = function (value) {
                    _this6.popover.open = false;
                    resolve(value);
                };
            });
            selectSlot.then(function (slot) {
                var copiedComponents = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this6.$store.state.copiedComponents));
                var pasteComponent = copiedComponents.find(function (c) {
                    return !c.parentId;
                });
                components[index].slots[slot].push({
                    id: pasteComponent.info.id
                });
                pasteComponent.parentId = components[index].info.id;
                pasteComponent.slot = slot;
                components = components.concat(copiedComponents);
                _this6.$store.commit('setState', {
                    components: components,
                    copiedComponents: [] //粘贴后清除剪切板
                });
                var topComponent = _this6.getParentComponent(components[index]);
                var topIndex = components.findIndex(function (c) {
                    return c.info.id === topComponent.info.id;
                });
                components[topIndex].template = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__template__["a" /* getTemplate */])(components[topIndex].info, components[topIndex].attributes, components[topIndex].slots).template;
                //因为getTemplate中需要最新的components，所以提交两次状态
                _this6.$store.commit('setState', {
                    components: components,
                    copiedComponents: [] //粘贴后清除剪切板
                });
                _this6.fresh();
            });
        },
        empty: function empty() {
            //清空
            this.$store.commit('setState', {
                css: '', //用户编辑的自定义css字符串
                currentComponent: {}, //预览视图的选中组件
                components: [], //预览视图的组件树
                backupComponents: [],
                copiedComponents: []
            });
            this.fresh();
        }
    },
    computed: {
        width: {
            //各视图宽度比
            get: function get() {
                return this.$store.state.width;
            },
            set: function set(width) {
                this.$store.commit('setState', {
                    width: width
                });
            }
        },
        components: {
            //组件树 ，预览视图中所有组件
            get: function get() {
                return this.$store.state.components;
            },
            set: function set(components) {
                this.$store.commit('setState', {
                    components: components
                });
            }
        },
        current: {
            //当前选中组件
            get: function get() {
                return this.$store.state.currentComponent;
            }
        },
        css: {
            get: function get() {
                return this.$store.state.css;
            },
            set: function set(val) {
                this.$store.commit('setState', {
                    css: val
                });
            }
        }
    },
    watch: {
        css: function css(val, oldVal) {
            this.addUserStyle();
        }
    }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mount__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preview_product__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preview_product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__preview_product__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'product',
    data: function data() {
        return {};
    },

    components: {
        previewProduct: __WEBPACK_IMPORTED_MODULE_1__preview_product___default.a
    }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mount__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scopedcss__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scopedcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scopedcss__);

//
//
//
//
//
//
//
//


// scoped style插件 ，解决webkit不支持scoped的问题

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'preview',
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        var _this = this;

        //读取云端数据
        var id = this.$route.params.id;
        var query = new this.$lean.Query('Share');
        if (id) {
            query.get(id).then(function (share) {
                var store = share.get('store');
                if (store) {
                    _this.$store.commit('setState', store);
                    //dom没有渲染完成 window._Vue为undefined，加个延迟
                    setTimeout(function () {
                        _this.mount();
                    }, 0);
                }
            });
        } else if (localStorage.store) {
            //读取本地数据
            var store = JSON.parse(localStorage.store);
            this.$store.commit('setState', store);
            //dom没有渲染完成 window._Vue为undefined，加个延迟
            setTimeout(function () {
                _this.mount();
            }, 0);
        }
    },

    computed: {
        components: {
            //组件树 ，预览视图中所有组件
            get: function get() {
                return this.$store.state.components;
            }
        },
        current: {
            //当前选中组件
            get: function get() {
                return this.$store.state.currentComponent;
            }
        }
    },
    methods: {
        mount: function mount() {
            var _this2 = this;

            //更新视图中组件的位置信息
            var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.components));
            components.filter(function (component) {
                return !component.parentId;
            }).forEach(function (component) {
                //预览模式 去掉选中边框
                component.template = component.template.replace(/ tabIndex="0"/g, '');
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mount__["a" /* default */])(component.info.id, component);
                _this2.addUserStyle();
            });
        },
        addUserStyle: function addUserStyle() {
            if (!this.$store.state.css) return;
            //添加用户编辑的css效果到预览视图
            var style = document.getElementById('custom-layout');
            if (!style) {
                style = document.createElement('style');
                style.id = 'custom-layout';
                style.setAttribute('scoped', '');
                style.type = 'text/css';
                this.$refs.preview.appendChild(style);
            }
            var cssText = document.createTextNode(this.$store.state.css);
            style.innerHTML = '';
            style.appendChild(cssText);
            // 动态添加scoped style
            __WEBPACK_IMPORTED_MODULE_2_scopedcss___default.a.applyTo(this.$refs.preview);
        }
    }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__iconPicker__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__iconPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__iconPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colorPicker__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colorPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__colorPicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ioniconPicker__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ioniconPicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ioniconPicker__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'subAttributes',
    data: function data() {
        return {
            attr: {}
        };
    },

    props: {
        attributes: {
            type: Object,
            default: null
        },
        keyOfAttr: {
            type: String,
            default: null
        }
    },
    created: function created() {
        this.attr = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.attributes));
    },

    watch: {
        attributes: {
            deep: true,
            handler: function handler(val, oldVal) {
                this.attr = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(val));
            }
        }
    },
    methods: {
        subUpdate: function subUpdate(attr) {
            //收到了子组件的更新
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.attr, attr);
            this.updateAttribute();
        },
        updateAttribute: function updateAttribute() {
            //提交更新到父组件
            if (this.keyOfAttr) this.$emit('update', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.keyOfAttr, {
                children: this.attr
            }));else this.$emit('update', this.attr);
        }
    },
    components: {
        iconPicker: __WEBPACK_IMPORTED_MODULE_3__iconPicker___default.a, colorPicker: __WEBPACK_IMPORTED_MODULE_4__colorPicker___default.a, ioniconPicker: __WEBPACK_IMPORTED_MODULE_5__ioniconPicker___default.a
    }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ name: 'red50', value: '#ffebee' }, { name: 'red100', value: '#ffcdd2' }, { name: 'red200', value: '#ef9a9a' }, { name: 'red300', value: '#e57373' }, { name: 'red400', value: '#ef5350' }, { name: 'red500', value: '#f44336' }, { name: 'red600', value: '#e53935' }, { name: 'red700', value: '#d32f2f' }, { name: 'red800', value: '#c62828' }, { name: 'red900', value: '#b71c1c' }, { name: 'redA100', value: '#ff8a80' }, { name: 'redA200', value: '#ff5252' }, { name: 'redA400', value: '#ff1744' }, { name: 'redA700', value: '#d50000' }, { name: 'pink50', value: '#fce4ec' }, { name: 'pink100', value: '#f8bbd0' }, { name: 'pink200', value: '#f48fb1' }, { name: 'pink300', value: '#f06292' }, { name: 'pink400', value: '#ec407a' }, { name: 'pink500', value: '#e91e63' }, { name: 'pink600', value: '#d81b60' }, { name: 'pink700', value: '#c2185b' }, { name: 'pink800', value: '#ad1457' }, { name: 'pink900', value: '#880e4f' }, { name: 'pinkA100', value: '#ff80ab' }, { name: 'pinkA200', value: '#ff4081' }, { name: 'pinkA400', value: '#f50057' }, { name: 'pinkA700', value: '#c51162' }, { name: 'purple50', value: '#f3e5f5' }, { name: 'purple100', value: '#e1bee7' }, { name: 'purple200', value: '#ce93d8' }, { name: 'purple300', value: '#ba68c8' }, { name: 'purple400', value: '#ab47bc' }, { name: 'purple500', value: '#9c27b0' }, { name: 'purple600', value: '#8e24aa' }, { name: 'purple700', value: '#7b1fa2' }, { name: 'purple800', value: '#6a1b9a' }, { name: 'purple900', value: '#4a148c' }, { name: 'purpleA100', value: '#ea80fc' }, { name: 'purpleA200', value: '#e040fb' }, { name: 'purpleA400', value: '#d500f9' }, { name: 'purpleA700', value: '#aa00ff' }, { name: 'deepPurple50', value: '#ede7f6' }, { name: 'deepPurple100', value: '#d1c4e9' }, { name: 'deepPurple200', value: '#b39ddb' }, { name: 'deepPurple300', value: '#9575cd' }, { name: 'deepPurple400', value: '#7e57c2' }, { name: 'deepPurple500', value: '#673ab7' }, { name: 'deepPurple600', value: '#5e35b1' }, { name: 'deepPurple700', value: '#512da8' }, { name: 'deepPurple800', value: '#4527a0' }, { name: 'deepPurple900', value: '#311b92' }, { name: 'deepPurpleA100', value: '#b388ff' }, { name: 'deepPurpleA200', value: '#7c4dff' }, { name: 'deepPurpleA400', value: '#651fff' }, { name: 'deepPurpleA700', value: '#6200ea' }, { name: 'indigo50', value: '#e8eaf6' }, { name: 'indigo100', value: '#c5cae9' }, { name: 'indigo200', value: '#9fa8da' }, { name: 'indigo300', value: '#7986cb' }, { name: 'indigo400', value: '#5c6bc0' }, { name: 'indigo500', value: '#3f51b5' }, { name: 'indigo600', value: '#3949ab' }, { name: 'indigo700', value: '#303f9f' }, { name: 'indigo800', value: '#283593' }, { name: 'indigo900', value: '#1a237e' }, { name: 'indigoA100', value: '#8c9eff' }, { name: 'indigoA200', value: '#536dfe' }, { name: 'indigoA400', value: '#3d5afe' }, { name: 'indigoA700', value: '#304ffe' }, { name: 'blue50', value: '#e3f2fd' }, { name: 'blue100', value: '#bbdefb' }, { name: 'blue200', value: '#90caf9' }, { name: 'blue300', value: '#64b5f6' }, { name: 'blue400', value: '#42a5f5' }, { name: 'blue500', value: '#2196f3' }, { name: 'blue600', value: '#1e88e5' }, { name: 'blue700', value: '#1976d2' }, { name: 'blue800', value: '#1565c0' }, { name: 'blue900', value: '#0d47a1' }, { name: 'blueA100', value: '#82b1ff' }, { name: 'blueA200', value: '#448aff' }, { name: 'blueA400', value: '#2979ff' }, { name: 'blueA700', value: '#2962ff' }, { name: 'lightBlue50', value: '#e1f5fe' }, { name: 'lightBlue100', value: '#b3e5fc' }, { name: 'lightBlue200', value: '#81d4fa' }, { name: 'lightBlue300', value: '#4fc3f7' }, { name: 'lightBlue400', value: '#29b6f6' }, { name: 'lightBlue500', value: '#03a9f4' }, { name: 'lightBlue600', value: '#039be5' }, { name: 'lightBlue700', value: '#0288d1' }, { name: 'lightBlue800', value: '#0277bd' }, { name: 'lightBlue900', value: '#01579b' }, { name: 'lightBlueA100', value: '#80d8ff' }, { name: 'lightBlueA200', value: '#40c4ff' }, { name: 'lightBlueA400', value: '#00b0ff' }, { name: 'lightBlueA700', value: '#0091ea' }, { name: 'cyan50', value: '#e0f7fa' }, { name: 'cyan100', value: '#b2ebf2' }, { name: 'cyan200', value: '#80deea' }, { name: 'cyan300', value: '#4dd0e1' }, { name: 'cyan400', value: '#26c6da' }, { name: 'cyan500', value: '#00bcd4' }, { name: 'cyan600', value: '#00acc1' }, { name: 'cyan700', value: '#0097a7' }, { name: 'cyan800', value: '#00838f' }, { name: 'cyan900', value: '#006064' }, { name: 'cyanA100', value: '#84ffff' }, { name: 'cyanA200', value: '#18ffff' }, { name: 'cyanA400', value: '#00e5ff' }, { name: 'cyanA700', value: '#00b8d4' }, { name: 'teal50', value: '#e0f2f1' }, { name: 'teal100', value: '#b2dfdb' }, { name: 'teal200', value: '#80cbc4' }, { name: 'teal300', value: '#4db6ac' }, { name: 'teal400', value: '#26a69a' }, { name: 'teal500', value: '#009688' }, { name: 'teal600', value: '#00897b' }, { name: 'teal700', value: '#00796b' }, { name: 'teal800', value: '#00695c' }, { name: 'teal900', value: '#004d40' }, { name: 'tealA100', value: '#a7ffeb' }, { name: 'tealA200', value: '#64ffda' }, { name: 'tealA400', value: '#1de9b6' }, { name: 'tealA700', value: '#00bfa5' }, { name: 'green50', value: '#e8f5e9' }, { name: 'green100', value: '#c8e6c9' }, { name: 'green200', value: '#a5d6a7' }, { name: 'green300', value: '#81c784' }, { name: 'green400', value: '#66bb6a' }, { name: 'green500', value: '#4caf50' }, { name: 'green600', value: '#43a047' }, { name: 'green700', value: '#388e3c' }, { name: 'green800', value: '#2e7d32' }, { name: 'green900', value: '#1b5e20' }, { name: 'greenA100', value: '#b9f6ca' }, { name: 'greenA200', value: '#69f0ae' }, { name: 'greenA400', value: '#00e676' }, { name: 'greenA700', value: '#00c853' }, { name: 'lightGreen50', value: '#f1f8e9' }, { name: 'lightGreen100', value: '#dcedc8' }, { name: 'lightGreen200', value: '#c5e1a5' }, { name: 'lightGreen300', value: '#aed581' }, { name: 'lightGreen400', value: '#9ccc65' }, { name: 'lightGreen500', value: '#8bc34a' }, { name: 'lightGreen600', value: '#7cb342' }, { name: 'lightGreen700', value: '#689f38' }, { name: 'lightGreen800', value: '#558b2f' }, { name: 'lightGreen900', value: '#33691e' }, { name: 'lightGreenA100', value: '#ccff90' }, { name: 'lightGreenA200', value: '#b2ff59' }, { name: 'lightGreenA400', value: '#76ff03' }, { name: 'lightGreenA700', value: '#64dd17' }, { name: 'lime50', value: '#f9fbe7' }, { name: 'lime100', value: '#f0f4c3' }, { name: 'lime200', value: '#e6ee9c' }, { name: 'lime300', value: '#dce775' }, { name: 'lime400', value: '#d4e157' }, { name: 'lime500', value: '#cddc39' }, { name: 'lime600', value: '#c0ca33' }, { name: 'lime700', value: '#afb42b' }, { name: 'lime800', value: '#9e9d24' }, { name: 'lime900', value: '#827717' }, { name: 'limeA100', value: '#f4ff81' }, { name: 'limeA200', value: '#eeff41' }, { name: 'limeA400', value: '#c6ff00' }, { name: 'limeA700', value: '#aeea00' }, { name: 'yellow50', value: '#fffde7' }, { name: 'yellow100', value: '#fff9c4' }, { name: 'yellow200', value: '#fff59d' }, { name: 'yellow300', value: '#fff176' }, { name: 'yellow400', value: '#ffee58' }, { name: 'yellow500', value: '#ffeb3b' }, { name: 'yellow600', value: '#fdd835' }, { name: 'yellow700', value: '#fbc02d' }, { name: 'yellow800', value: '#f9a825' }, { name: 'yellow900', value: '#f57f17' }, { name: 'yellowA100', value: '#ffff8d' }, { name: 'yellowA200', value: '#ffff00' }, { name: 'yellowA400', value: '#ffea00' }, { name: 'yellowA700', value: '#ffd600' }, { name: 'amber50', value: '#fff8e1' }, { name: 'amber100', value: '#ffecb3' }, { name: 'amber200', value: '#ffe082' }, { name: 'amber300', value: '#ffd54f' }, { name: 'amber400', value: '#ffca28' }, { name: 'amber500', value: '#ffc107' }, { name: 'amber600', value: '#ffb300' }, { name: 'amber700', value: '#ffa000' }, { name: 'amber800', value: '#ff8f00' }, { name: 'amber900', value: '#ff6f00' }, { name: 'amberA100', value: '#ffe57f' }, { name: 'amberA200', value: '#ffd740' }, { name: 'amberA400', value: '#ffc400' }, { name: 'amberA700', value: '#ffab00' }, { name: 'orange50', value: '#fff3e0' }, { name: 'orange100', value: '#ffe0b2' }, { name: 'orange200', value: '#ffcc80' }, { name: 'orange300', value: '#ffb74d' }, { name: 'orange400', value: '#ffa726' }, { name: 'orange500', value: '#ff9800' }, { name: 'orange600', value: '#fb8c00' }, { name: 'orange700', value: '#f57c00' }, { name: 'orange800', value: '#ef6c00' }, { name: 'orange900', value: '#e65100' }, { name: 'orangeA100', value: '#ffd180' }, { name: 'orangeA200', value: '#ffab40' }, { name: 'orangeA400', value: '#ff9100' }, { name: 'orangeA700', value: '#ff6d00' }, { name: 'deepOrange50', value: '#fbe9e7' }, { name: 'deepOrange100', value: '#ffccbc' }, { name: 'deepOrange200', value: '#ffab91' }, { name: 'deepOrange300', value: '#ff8a65' }, { name: 'deepOrange400', value: '#ff7043' }, { name: 'deepOrange500', value: '#ff5722' }, { name: 'deepOrange600', value: '#f4511e' }, { name: 'deepOrange700', value: '#e64a19' }, { name: 'deepOrange800', value: '#d84315' }, { name: 'deepOrange900', value: '#bf360c' }, { name: 'deepOrangeA100', value: '#ff9e80' }, { name: 'deepOrangeA200', value: '#ff6e40' }, { name: 'deepOrangeA400', value: '#ff3d00' }, { name: 'deepOrangeA700', value: '#dd2c00' }, { name: 'brown50', value: '#efebe9' }, { name: 'brown100', value: '#d7ccc8' }, { name: 'brown200', value: '#bcaaa4' }, { name: 'brown300', value: '#a1887f' }, { name: 'brown400', value: '#8d6e63' }, { name: 'brown500', value: '#795548' }, { name: 'brown600', value: '#6d4c41' }, { name: 'brown700', value: '#5d4037' }, { name: 'brown800', value: '#4e342e' }, { name: 'brown900', value: '#3e2723' }, { name: 'blueGrey50', value: '#eceff1' }, { name: 'blueGrey100', value: '#cfd8dc' }, { name: 'blueGrey200', value: '#b0bec5' }, { name: 'blueGrey300', value: '#90a4ae' }, { name: 'blueGrey400', value: '#78909c' }, { name: 'blueGrey500', value: '#607d8b' }, { name: 'blueGrey600', value: '#546e7a' }, { name: 'blueGrey700', value: '#455a64' }, { name: 'blueGrey800', value: '#37474f' }, { name: 'blueGrey900', value: '#263238' }, { name: 'grey50', value: '#fafafa' }, { name: 'grey100', value: '#f5f5f5' }, { name: 'grey200', value: '#eeeeee' }, { name: 'grey300', value: '#e0e0e0' }, { name: 'grey400', value: '#bdbdbd' }, { name: 'grey500', value: '#9e9e9e' }, { name: 'grey600', value: '#757575' }, { name: 'grey700', value: '#616161' }, { name: 'grey800', value: '#424242' }, { name: 'grey900', value: '#212121' }, { name: 'black', value: '#000000' }, { name: 'white', value: '#ffffff' }, { name: 'transparent', value: 'rgba(0, 0, 0, 0)' }, { name: 'fullBlack', value: 'rgba(0, 0, 0, 1)' }, { name: 'darkBlack', value: 'rgba(0, 0, 0, 0.87)' }, { name: 'lightBlack', value: 'rgba(0, 0, 0, 0.54)' }, { name: 'minBlack', value: 'rgba(0, 0, 0, 0.26)' }, { name: 'faintBlack', value: 'rgba(0, 0, 0, 0.12)' }, { name: 'fullWhite', value: 'rgba(255, 255, 255, 1)' }, { name: 'darkWhite', value: 'rgba(255, 255, 255, 0.87)' }, { name: 'lightWhite', value: 'rgba(255, 255, 255, 0.54)' }]);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 来源 https://github.com/google/material-design-icons/edit/master/iconfont/codepoints
/* harmony default export */ __webpack_exports__["a"] = (['3d_rotation', 'ac_unit', 'access_alarm', 'access_alarms', 'access_time', 'accessibility', 'accessible', 'account_balance', 'account_balance_wallet', 'account_box', 'account_circle', 'adb', 'add', 'add_a_photo', 'add_alarm', 'add_alert', 'add_box', 'add_circle', 'add_circle_outline', 'add_location', 'add_shopping_cart', 'add_to_photos', 'add_to_queue', 'adjust', 'airline_seat_flat', 'airline_seat_flat_angled', 'airline_seat_individual_suite', 'airline_seat_legroom_extra', 'airline_seat_legroom_normal', 'airline_seat_legroom_reduced', 'airline_seat_recline_extra', 'airline_seat_recline_normal', 'airplanemode_active', 'airplanemode_inactive', 'airplay', 'airport_shuttle', 'alarm', 'alarm_add', 'alarm_off', 'alarm_on', 'album', 'all_inclusive', 'all_out', 'android', 'announcement', 'apps', 'archive', 'arrow_back', 'arrow_downward', 'arrow_drop_down', 'arrow_drop_down_circle', 'arrow_drop_up', 'arrow_forward', 'arrow_upward', 'art_track', 'aspect_ratio', 'assessment', 'assignment', 'assignment_ind', 'assignment_late', 'assignment_return', 'assignment_returned', 'assignment_turned_in', 'assistant', 'assistant_photo', 'attach_file', 'attach_money', 'attachment', 'audiotrack', 'autorenew', 'av_timer', 'backspace', 'backup', 'battery_alert', 'battery_charging_full', 'battery_full', 'battery_std', 'battery_unknown', 'beach_access', 'beenhere', 'block', 'bluetooth', 'bluetooth_audio', 'bluetooth_connected', 'bluetooth_disabled', 'bluetooth_searching', 'blur_circular', 'blur_linear', 'blur_off', 'blur_on', 'book', 'bookmark', 'bookmark_border', 'border_all', 'border_bottom', 'border_clear', 'border_color', 'border_horizontal', 'border_inner', 'border_left', 'border_outer', 'border_right', 'border_style', 'border_top', 'border_vertical', 'branding_watermark', 'brightness_1', 'brightness_2', 'brightness_3', 'brightness_4', 'brightness_5', 'brightness_6', 'brightness_7', 'brightness_auto', 'brightness_high', 'brightness_low', 'brightness_medium', 'broken_image', 'brush', 'bubble_chart', 'bug_report', 'build', 'burst_mode', 'business', 'business_center', 'cached', 'cake', 'call', 'call_end', 'call_made', 'call_merge', 'call_missed', 'call_missed_outgoing', 'call_received', 'call_split', 'call_to_action', 'camera', 'camera_alt', 'camera_enhance', 'camera_front', 'camera_rear', 'camera_roll', 'cancel', 'card_giftcard', 'card_membership', 'card_travel', 'casino', 'cast', 'cast_connected', 'center_focus_strong', 'center_focus_weak', 'change_history', 'chat', 'chat_bubble', 'chat_bubble_outline', 'check', 'check_box', 'check_box_outline_blank', 'check_circle', 'chevron_left', 'chevron_right', 'child_care', 'child_friendly', 'chrome_reader_mode', 'class', 'clear', 'clear_all', 'close', 'closed_caption', 'cloud', 'cloud_circle', 'cloud_done', 'cloud_download', 'cloud_off', 'cloud_queue', 'cloud_upload', 'code', 'collections', 'collections_bookmark', 'color_lens', 'colorize', 'comment', 'compare', 'compare_arrows', 'computer', 'confirmation_number', 'contact_mail', 'contact_phone', 'contacts', 'content_copy', 'content_cut', 'content_paste', 'control_point', 'control_point_duplicate', 'copyright', 'create', 'create_new_folder', 'credit_card', 'crop', 'crop_16_9', 'crop_3_2', 'crop_5_4', 'crop_7_5', 'crop_din', 'crop_free', 'crop_landscape', 'crop_original', 'crop_portrait', 'crop_rotate', 'crop_square', 'dashboard', 'data_usage', 'date_range', 'dehaze', 'delete', 'delete_forever', 'delete_sweep', 'description', 'desktop_mac', 'desktop_windows', 'details', 'developer_board', 'developer_mode', 'device_hub', 'devices', 'devices_other', 'dialer_sip', 'dialpad', 'directions', 'directions_bike', 'directions_boat', 'directions_bus', 'directions_car', 'directions_railway', 'directions_run', 'directions_subway', 'directions_transit', 'directions_walk', 'disc_full', 'dns', 'do_not_disturb', 'do_not_disturb_alt', 'do_not_disturb_off', 'do_not_disturb_on', 'dock', 'domain', 'done', 'done_all', 'donut_large', 'donut_small', 'drafts', 'drag_handle', 'drive_eta', 'dvr', 'edit', 'edit_location', 'eject', 'email', 'enhanced_encryption', 'equalizer', 'error', 'error_outline', 'euro_symbol', 'ev_station', 'event', 'event_available', 'event_busy', 'event_note', 'event_seat', 'exit_to_app', 'expand_less', 'expand_more', 'explicit', 'explore', 'exposure', 'exposure_neg_1', 'exposure_neg_2', 'exposure_plus_1', 'exposure_plus_2', 'exposure_zero', 'extension', 'face', 'fast_forward', 'fast_rewind', 'favorite', 'favorite_border', 'featured_play_list', 'featured_video', 'feedback', 'fiber_dvr', 'fiber_manual_record', 'fiber_new', 'fiber_pin', 'fiber_smart_record', 'file_download', 'file_upload', 'filter', 'filter_1', 'filter_2', 'filter_3', 'filter_4', 'filter_5', 'filter_6', 'filter_7', 'filter_8', 'filter_9', 'filter_9_plus', 'filter_b_and_w', 'filter_center_focus', 'filter_drama', 'filter_frames', 'filter_hdr', 'filter_list', 'filter_none', 'filter_tilt_shift', 'filter_vintage', 'find_in_page', 'find_replace', 'fingerprint', 'first_page', 'fitness_center', 'flag', 'flare', 'flash_auto', 'flash_off', 'flash_on', 'flight', 'flight_land', 'flight_takeoff', 'flip', 'flip_to_back', 'flip_to_front', 'folder', 'folder_open', 'folder_shared', 'folder_special', 'font_download', 'format_align_center', 'format_align_justify', 'format_align_left', 'format_align_right', 'format_bold', 'format_clear', 'format_color_fill', 'format_color_reset', 'format_color_text', 'format_indent_decrease', 'format_indent_increase', 'format_italic', 'format_line_spacing', 'format_list_bulleted', 'format_list_numbered', 'format_paint', 'format_quote', 'format_shapes', 'format_size', 'format_strikethrough', 'format_textdirection_l_to_r', 'format_textdirection_r_to_l', 'format_underlined', 'forum', 'forward', 'forward_10', 'forward_30', 'forward_5', 'free_breakfast', 'fullscreen', 'fullscreen_exit', 'functions', 'g_translate', 'gamepad', 'games', 'gavel', 'gesture', 'get_app', 'gif', 'golf_course', 'gps_fixed', 'gps_not_fixed', 'gps_off', 'grade', 'gradient', 'grain', 'graphic_eq', 'grid_off', 'grid_on', 'group', 'group_add', 'group_work', 'hd', 'hdr_off', 'hdr_on', 'hdr_strong', 'hdr_weak', 'headset', 'headset_mic', 'healing', 'hearing', 'help', 'help_outline', 'high_quality', 'highlight', 'highlight_off', 'history', 'home', 'hot_tub', 'hotel', 'hourglass_empty', 'hourglass_full', 'http', 'https', 'image', 'image_aspect_ratio', 'import_contacts', 'import_export', 'important_devices', 'inbox', 'indeterminate_check_box', 'info', 'info_outline', 'input', 'insert_chart', 'insert_comment', 'insert_drive_file', 'insert_emoticon', 'insert_invitation', 'insert_link', 'insert_photo', 'invert_colors', 'invert_colors_off', 'iso', 'keyboard', 'keyboard_arrow_down', 'keyboard_arrow_left', 'keyboard_arrow_right', 'keyboard_arrow_up', 'keyboard_backspace', 'keyboard_capslock', 'keyboard_hide', 'keyboard_return', 'keyboard_tab', 'keyboard_voice', 'kitchen', 'label', 'label_outline', 'landscape', 'language', 'laptop', 'laptop_chromebook', 'laptop_mac', 'laptop_windows', 'last_page', 'launch', 'layers', 'layers_clear', 'leak_add', 'leak_remove', 'lens', 'library_add', 'library_books', 'library_music', 'lightbulb_outline', 'line_style', 'line_weight', 'linear_scale', 'link', 'linked_camera', 'list', 'live_help', 'live_tv', 'local_activity', 'local_airport', 'local_atm', 'local_bar', 'local_cafe', 'local_car_wash', 'local_convenience_store', 'local_dining', 'local_drink', 'local_florist', 'local_gas_station', 'local_grocery_store', 'local_hospital', 'local_hotel', 'local_laundry_service', 'local_library', 'local_mall', 'local_movies', 'local_offer', 'local_parking', 'local_pharmacy', 'local_phone', 'local_pizza', 'local_play', 'local_post_office', 'local_printshop', 'local_see', 'local_shipping', 'local_taxi', 'location_city', 'location_disabled', 'location_off', 'location_on', 'location_searching', 'lock', 'lock_open', 'lock_outline', 'looks', 'looks_3', 'looks_4', 'looks_5', 'looks_6', 'looks_one', 'looks_two', 'loop', 'loupe', 'low_priority', 'loyalty', 'mail', 'mail_outline', 'map', 'markunread', 'markunread_mailbox', 'memory', 'menu', 'merge_type', 'message', 'mic', 'mic_none', 'mic_off', 'mms', 'mode_comment', 'mode_edit', 'monetization_on', 'money_off', 'monochrome_photos', 'mood', 'mood_bad', 'more', 'more_horiz', 'more_vert', 'motorcycle', 'mouse', 'move_to_inbox', 'movie', 'movie_creation', 'movie_filter', 'multiline_chart', 'music_note', 'music_video', 'my_location', 'nature', 'nature_people', 'navigate_before', 'navigate_next', 'navigation', 'near_me', 'network_cell', 'network_check', 'network_locked', 'network_wifi', 'new_releases', 'next_week', 'nfc', 'no_encryption', 'no_sim', 'not_interested', 'note', 'note_add', 'notifications', 'notifications_active', 'notifications_none', 'notifications_off', 'notifications_paused', 'offline_pin', 'ondemand_video', 'opacity', 'open_in_browser', 'open_in_new', 'open_with', 'pages', 'pageview', 'palette', 'pan_tool', 'panorama', 'panorama_fish_eye', 'panorama_horizontal', 'panorama_vertical', 'panorama_wide_angle', 'party_mode', 'pause', 'pause_circle_filled', 'pause_circle_outline', 'payment', 'people', 'people_outline', 'perm_camera_mic', 'perm_contact_calendar', 'perm_data_setting', 'perm_device_information', 'perm_identity', 'perm_media', 'perm_phone_msg', 'perm_scan_wifi', 'person', 'person_add', 'person_outline', 'person_pin', 'person_pin_circle', 'personal_video', 'pets', 'phone', 'phone_android', 'phone_bluetooth_speaker', 'phone_forwarded', 'phone_in_talk', 'phone_iphone', 'phone_locked', 'phone_missed', 'phone_paused', 'phonelink', 'phonelink_erase', 'phonelink_lock', 'phonelink_off', 'phonelink_ring', 'phonelink_setup', 'photo', 'photo_album', 'photo_camera', 'photo_filter', 'photo_library', 'photo_size_select_actual', 'photo_size_select_large', 'photo_size_select_small', 'picture_as_pdf', 'picture_in_picture', 'picture_in_picture_alt', 'pie_chart', 'pie_chart_outlined', 'pin_drop', 'place', 'play_arrow', 'play_circle_filled', 'play_circle_outline', 'play_for_work', 'playlist_add', 'playlist_add_check', 'playlist_play', 'plus_one', 'poll', 'polymer', 'pool', 'portable_wifi_off', 'portrait', 'power', 'power_input', 'power_settings_new', 'pregnant_woman', 'present_to_all', 'print', 'priority_high', 'public', 'publish', 'query_builder', 'question_answer', 'queue', 'queue_music', 'queue_play_next', 'radio', 'radio_button_checked', 'radio_button_unchecked', 'rate_review', 'receipt', 'recent_actors', 'record_voice_over', 'redeem', 'redo', 'refresh', 'remove', 'remove_circle', 'remove_circle_outline', 'remove_from_queue', 'remove_red_eye', 'remove_shopping_cart', 'reorder', 'repeat', 'repeat_one', 'replay', 'replay_10', 'replay_30', 'replay_5', 'reply', 'reply_all', 'report', 'report_problem', 'restaurant', 'restaurant_menu', 'restore', 'restore_page', 'ring_volume', 'room', 'room_service', 'rotate_90_degrees_ccw', 'rotate_left', 'rotate_right', 'rounded_corner', 'router', 'rowing', 'rss_feed', 'rv_hookup', 'satellite', 'save', 'scanner', 'schedule', 'school', 'screen_lock_landscape', 'screen_lock_portrait', 'screen_lock_rotation', 'screen_rotation', 'screen_share', 'sd_card', 'sd_storage', 'search', 'security', 'select_all', 'send', 'sentiment_dissatisfied', 'sentiment_neutral', 'sentiment_satisfied', 'sentiment_very_dissatisfied', 'sentiment_very_satisfied', 'settings', 'settings_applications', 'settings_backup_restore', 'settings_bluetooth', 'settings_brightness', 'settings_cell', 'settings_ethernet', 'settings_input_antenna', 'settings_input_component', 'settings_input_composite', 'settings_input_hdmi', 'settings_input_svideo', 'settings_overscan', 'settings_phone', 'settings_power', 'settings_remote', 'settings_system_daydream', 'settings_voice', 'share', 'shop', 'shop_two', 'shopping_basket', 'shopping_cart', 'short_text', 'show_chart', 'shuffle', 'signal_cellular_4_bar', 'signal_cellular_connected_no_internet_4_bar', 'signal_cellular_no_sim', 'signal_cellular_null', 'signal_cellular_off', 'signal_wifi_4_bar', 'signal_wifi_4_bar_lock', 'signal_wifi_off', 'sim_card', 'sim_card_alert', 'skip_next', 'skip_previous', 'slideshow', 'slow_motion_video', 'smartphone', 'smoke_free', 'smoking_rooms', 'sms', 'sms_failed', 'snooze', 'sort', 'sort_by_alpha', 'spa', 'space_bar', 'speaker', 'speaker_group', 'speaker_notes', 'speaker_notes_off', 'speaker_phone', 'spellcheck', 'star', 'star_border', 'star_half', 'stars', 'stay_current_landscape', 'stay_current_portrait', 'stay_primary_landscape', 'stay_primary_portrait', 'stop', 'stop_screen_share', 'storage', 'store', 'store_mall_directory', 'straighten', 'streetview', 'strikethrough_s', 'style', 'subdirectory_arrow_left', 'subdirectory_arrow_right', 'subject', 'subscriptions', 'subtitles', 'subway', 'supervisor_account', 'surround_sound', 'swap_calls', 'swap_horiz', 'swap_vert', 'swap_vertical_circle', 'switch_camera', 'switch_video', 'sync', 'sync_disabled', 'sync_problem', 'system_update', 'system_update_alt', 'tab', 'tab_unselected', 'tablet', 'tablet_android', 'tablet_mac', 'tag_faces', 'tap_and_play', 'terrain', 'text_fields', 'text_format', 'textsms', 'texture', 'theaters', 'thumb_down', 'thumb_up', 'thumbs_up_down', 'time_to_leave', 'timelapse', 'timeline', 'timer', 'timer_10', 'timer_3', 'timer_off', 'title', 'toc', 'today', 'toll', 'tonality', 'touch_app', 'toys', 'track_changes', 'traffic', 'train', 'tram', 'transfer_within_a_station', 'transform', 'translate', 'trending_down', 'trending_flat', 'trending_up', 'tune', 'turned_in', 'turned_in_not', 'tv', 'unarchive', 'undo', 'unfold_less', 'unfold_more', 'update', 'usb', 'verified_user', 'vertical_align_bottom', 'vertical_align_center', 'vertical_align_top', 'vibration', 'video_call', 'video_label', 'video_library', 'videocam', 'videocam_off', 'videogame_asset', 'view_agenda', 'view_array', 'view_carousel', 'view_column', 'view_comfy', 'view_compact', 'view_day', 'view_headline', 'view_list', 'view_module', 'view_quilt', 'view_stream', 'view_week', 'vignette', 'visibility', 'visibility_off', 'voice_chat', 'voicemail', 'volume_down', 'volume_mute', 'volume_off', 'volume_up', 'vpn_key', 'vpn_lock', 'wallpaper', 'warning', 'watch', 'watch_later', 'wb_auto', 'wb_cloudy', 'wb_incandescent', 'wb_iridescent', 'wb_sunny', 'wc', 'web', 'web_asset', 'weekend', 'whatshot', 'widgets', 'wifi', 'wifi_lock', 'wifi_tethering', 'work', 'wrap_text', 'youtube_searched_for', 'zoom_in', 'zoom_out', 'zoom_out_map']);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var list = ['alert', 'alert-circled', 'android-add', 'android-add-circle', 'android-alarm-clock', 'android-alert', 'android-apps', 'android-archive', 'android-arrow-back', 'android-arrow-down', 'android-arrow-dropdown', 'android-arrow-dropdown-circle', 'android-arrow-dropleft', 'android-arrow-dropleft-circle', 'android-arrow-dropright', 'android-arrow-dropright-circle', 'android-arrow-dropup', 'android-arrow-dropup-circle', 'android-arrow-forward', 'android-arrow-up', 'android-attach', 'android-bar', 'android-bicycle', 'android-boat', 'android-bookmark', 'android-bulb', 'android-bus', 'android-calendar', 'android-call', 'android-camera', 'android-cancel', 'android-car', 'android-cart', 'android-chat', 'android-checkbox', 'android-checkbox-blank', 'android-checkbox-outline', 'android-checkbox-outline-blank', 'android-checkmark-circle', 'android-clipboard', 'android-close', 'android-cloud', 'android-cloud-circle', 'android-cloud-done', 'android-cloud-outline', 'android-color-palette', 'android-compass', 'android-contact', 'android-contacts', 'android-contract', 'android-create', 'android-delete', 'android-desktop', 'android-document', 'android-done', 'android-done-all', 'android-download', 'android-drafts', 'android-exit', 'android-expand', 'android-favorite', 'android-favorite-outline', 'android-film', 'android-folder', 'android-folder-open', 'android-funnel', 'android-globe', 'android-hand', 'android-hangout', 'android-happy', 'android-home', 'android-image', 'android-laptop', 'android-list', 'android-locate', 'android-lock', 'android-mail', 'android-map', 'android-menu', 'android-microphone', 'android-microphone-off', 'android-more-horizontal', 'android-more-vertical', 'android-navigate', 'android-notifications', 'android-notifications-none', 'android-notifications-off', 'android-open', 'android-options', 'android-people', 'android-person', 'android-person-add', 'android-phone-landscape', 'android-phone-portrait', 'android-pin', 'android-plane', 'android-playstore', 'android-print', 'android-radio-button-off', 'android-radio-button-on', 'android-refresh', 'android-remove', 'android-remove-circle', 'android-restaurant', 'android-sad', 'android-search', 'android-send', 'android-settings', 'android-share', 'android-share-alt', 'android-star', 'android-star-half', 'android-star-outline', 'android-stopwatch', 'android-subway', 'android-sunny', 'android-sync', 'android-textsms', 'android-time', 'android-train', 'android-unlock', 'android-upload', 'android-volume-down', 'android-volume-mute', 'android-volume-off', 'android-volume-up', 'android-walk', 'android-warning', 'android-watch', 'android-wifi', 'aperture', 'archive', 'arrow-down-a', 'arrow-down-b', 'arrow-down-c', 'arrow-expand', 'arrow-graph-down-left', 'arrow-graph-down-right', 'arrow-graph-up-left', 'arrow-graph-up-right', 'arrow-left-a', 'arrow-left-b', 'arrow-left-c', 'arrow-move', 'arrow-resize', 'arrow-return-left', 'arrow-return-right', 'arrow-right-a', 'arrow-right-b', 'arrow-right-c', 'arrow-shrink', 'arrow-swap', 'arrow-up-a', 'arrow-up-b', 'arrow-up-c', 'asterisk', 'at', 'backspace', 'backspace-outline', 'bag', 'battery-charging', 'battery-empty', 'battery-full', 'battery-half', 'battery-low', 'beaker', 'beer', 'bluetooth', 'bonfire', 'bookmark', 'bowtie', 'briefcase', 'bug', 'calculator', 'calendar', 'camera', 'card', 'cash', 'chatbox', 'chatbox-working', 'chatboxes', 'chatbubble', 'chatbubble-working', 'chatbubbles', 'checkmark', 'checkmark-circled', 'checkmark-round', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'clipboard', 'clock', 'close', 'close-circled', 'close-round', 'closed-captioning', 'cloud', 'code', 'code-download', 'code-working', 'coffee', 'compass', 'compose', 'connection-bars', 'contrast', 'crop', 'cube', 'disc', 'document', 'document-text', 'drag', 'earth', 'easel', 'edit', 'egg', 'eject', 'email', 'email-unread', 'erlenmeyer-flask', 'erlenmeyer-flask-bubbles', 'eye', 'eye-disabled', 'female', 'filing', 'film-marker', 'fireball', 'flag', 'flame', 'flash', 'flash-off', 'folder', 'fork', 'fork-repo', 'forward', 'funnel', 'gear-a', 'gear-b', 'grid', 'hammer', 'happy', 'happy-outline', 'headphone', 'heart', 'heart-broken', 'help', 'help-buoy', 'help-circled', 'home', 'icecream', 'image', 'images', 'information', 'information-circled', 'ionic', 'ios-alarm', 'ios-alarm-outline', 'ios-albums', 'ios-albums-outline', 'ios-americanfootball', 'ios-americanfootball-outline', 'ios-analytics', 'ios-analytics-outline', 'ios-arrow-back', 'ios-arrow-down', 'ios-arrow-forward', 'ios-arrow-left', 'ios-arrow-right', 'ios-arrow-thin-down', 'ios-arrow-thin-left', 'ios-arrow-thin-right', 'ios-arrow-thin-up', 'ios-arrow-up', 'ios-at', 'ios-at-outline', 'ios-barcode', 'ios-barcode-outline', 'ios-baseball', 'ios-baseball-outline', 'ios-basketball', 'ios-basketball-outline', 'ios-bell', 'ios-bell-outline', 'ios-body', 'ios-body-outline', 'ios-bolt', 'ios-bolt-outline', 'ios-book', 'ios-book-outline', 'ios-bookmarks', 'ios-bookmarks-outline', 'ios-box', 'ios-box-outline', 'ios-briefcase', 'ios-briefcase-outline', 'ios-browsers', 'ios-browsers-outline', 'ios-calculator', 'ios-calculator-outline', 'ios-calendar', 'ios-calendar-outline', 'ios-camera', 'ios-camera-outline', 'ios-cart', 'ios-cart-outline', 'ios-chatboxes', 'ios-chatboxes-outline', 'ios-chatbubble', 'ios-chatbubble-outline', 'ios-checkmark', 'ios-checkmark-empty', 'ios-checkmark-outline', 'ios-circle-filled', 'ios-circle-outline', 'ios-clock', 'ios-clock-outline', 'ios-close', 'ios-close-empty', 'ios-close-outline', 'ios-cloud', 'ios-cloud-download', 'ios-cloud-download-outline', 'ios-cloud-outline', 'ios-cloud-upload', 'ios-cloud-upload-outline', 'ios-cloudy', 'ios-cloudy-night', 'ios-cloudy-night-outline', 'ios-cloudy-outline', 'ios-cog', 'ios-cog-outline', 'ios-color-filter', 'ios-color-filter-outline', 'ios-color-wand', 'ios-color-wand-outline', 'ios-compose', 'ios-compose-outline', 'ios-contact', 'ios-contact-outline', 'ios-copy', 'ios-copy-outline', 'ios-crop', 'ios-crop-strong', 'ios-download', 'ios-download-outline', 'ios-drag', 'ios-email', 'ios-email-outline', 'ios-eye', 'ios-eye-outline', 'ios-fastforward', 'ios-fastforward-outline', 'ios-filing', 'ios-filing-outline', 'ios-film', 'ios-film-outline', 'ios-flag', 'ios-flag-outline', 'ios-flame', 'ios-flame-outline', 'ios-flask', 'ios-flask-outline', 'ios-flower', 'ios-flower-outline', 'ios-folder', 'ios-folder-outline', 'ios-football', 'ios-football-outline', 'ios-game-controller-a', 'ios-game-controller-a-outline', 'ios-game-controller-b', 'ios-game-controller-b-outline', 'ios-gear', 'ios-gear-outline', 'ios-glasses', 'ios-glasses-outline', 'ios-grid-view', 'ios-grid-view-outline', 'ios-heart', 'ios-heart-outline', 'ios-help', 'ios-help-empty', 'ios-help-outline', 'ios-home', 'ios-home-outline', 'ios-infinite', 'ios-infinite-outline', 'ios-information', 'ios-information-empty', 'ios-information-outline', 'ios-ionic-outline', 'ios-keypad', 'ios-keypad-outline', 'ios-lightbulb', 'ios-lightbulb-outline', 'ios-list', 'ios-list-outline', 'ios-location', 'ios-location-outline', 'ios-locked', 'ios-locked-outline', 'ios-loop', 'ios-loop-strong', 'ios-medical', 'ios-medical-outline', 'ios-medkit', 'ios-medkit-outline', 'ios-mic', 'ios-mic-off', 'ios-mic-outline', 'ios-minus', 'ios-minus-empty', 'ios-minus-outline', 'ios-monitor', 'ios-monitor-outline', 'ios-moon', 'ios-moon-outline', 'ios-more', 'ios-more-outline', 'ios-musical-note', 'ios-musical-notes', 'ios-navigate', 'ios-navigate-outline', 'ios-nutrition', 'ios-nutrition-outline', 'ios-paper', 'ios-paper-outline', 'ios-paperplane', 'ios-paperplane-outline', 'ios-partlysunny', 'ios-partlysunny-outline', 'ios-pause', 'ios-pause-outline', 'ios-paw', 'ios-paw-outline', 'ios-people', 'ios-people-outline', 'ios-person', 'ios-person-outline', 'ios-personadd', 'ios-personadd-outline', 'ios-photos', 'ios-photos-outline', 'ios-pie', 'ios-pie-outline', 'ios-pint', 'ios-pint-outline', 'ios-play', 'ios-play-outline', 'ios-plus', 'ios-plus-empty', 'ios-plus-outline', 'ios-pricetag', 'ios-pricetag-outline', 'ios-pricetags', 'ios-pricetags-outline', 'ios-printer', 'ios-printer-outline', 'ios-pulse', 'ios-pulse-strong', 'ios-rainy', 'ios-rainy-outline', 'ios-recording', 'ios-recording-outline', 'ios-redo', 'ios-redo-outline', 'ios-refresh', 'ios-refresh-empty', 'ios-refresh-outline', 'ios-reload', 'ios-reverse-camera', 'ios-reverse-camera-outline', 'ios-rewind', 'ios-rewind-outline', 'ios-rose', 'ios-rose-outline', 'ios-search', 'ios-search-strong', 'ios-settings', 'ios-settings-strong', 'ios-shuffle', 'ios-shuffle-strong', 'ios-skipbackward', 'ios-skipbackward-outline', 'ios-skipforward', 'ios-skipforward-outline', 'ios-snowy', 'ios-speedometer', 'ios-speedometer-outline', 'ios-star', 'ios-star-half', 'ios-star-outline', 'ios-stopwatch', 'ios-stopwatch-outline', 'ios-sunny', 'ios-sunny-outline', 'ios-telephone', 'ios-telephone-outline', 'ios-tennisball', 'ios-tennisball-outline', 'ios-thunderstorm', 'ios-thunderstorm-outline', 'ios-time', 'ios-time-outline', 'ios-timer', 'ios-timer-outline', 'ios-toggle', 'ios-toggle-outline', 'ios-trash', 'ios-trash-outline', 'ios-undo', 'ios-undo-outline', 'ios-unlocked', 'ios-unlocked-outline', 'ios-upload', 'ios-upload-outline', 'ios-videocam', 'ios-videocam-outline', 'ios-volume-high', 'ios-volume-low', 'ios-wineglass', 'ios-wineglass-outline', 'ios-world', 'ios-world-outline', 'ipad', 'iphone', 'ipod', 'jet', 'key', 'knife', 'laptop', 'leaf', 'levels', 'lightbulb', 'link', 'load-a', 'load-b', 'load-c', 'load-d', 'location', 'lock-combination', 'locked', 'log-in', 'log-out', 'loop', 'magnet', 'male', 'man', 'map', 'medkit', 'merge', 'mic-a', 'mic-b', 'mic-c', 'minus', 'minus-circled', 'minus-round', 'model-s', 'monitor', 'more', 'mouse', 'music-note', 'navicon', 'navicon-round', 'navigate', 'network', 'no-smoking', 'nuclear', 'outlet', 'paintbrush', 'paintbucket', 'paper-airplane', 'paperclip', 'pause', 'person', 'person-add', 'person-stalker', 'pie-graph', 'pin', 'pinpoint', 'pizza', 'plane', 'planet', 'play', 'playstation', 'plus', 'plus-circled', 'plus-round', 'podium', 'pound', 'power', 'pricetag', 'pricetags', 'printer', 'pull-request', 'qr-scanner', 'quote', 'radio-waves', 'record', 'refresh', 'reply', 'reply-all', 'ribbon-a', 'ribbon-b', 'sad', 'sad-outline', 'scissors', 'search', 'settings', 'share', 'shuffle', 'skip-backward', 'skip-forward', 'social-android', 'social-android-outline', 'social-angular', 'social-angular-outline', 'social-apple', 'social-apple-outline', 'social-bitcoin', 'social-bitcoin-outline', 'social-buffer', 'social-buffer-outline', 'social-chrome', 'social-chrome-outline', 'social-codepen', 'social-codepen-outline', 'social-css3', 'social-css3-outline', 'social-designernews', 'social-designernews-outline', 'social-dribbble', 'social-dribbble-outline', 'social-dropbox', 'social-dropbox-outline', 'social-euro', 'social-euro-outline', 'social-facebook', 'social-facebook-outline', 'social-foursquare', 'social-foursquare-outline', 'social-freebsd-devil', 'social-github', 'social-github-outline', 'social-google', 'social-google-outline', 'social-googleplus', 'social-googleplus-outline', 'social-hackernews', 'social-hackernews-outline', 'social-html5', 'social-html5-outline', 'social-instagram', 'social-instagram-outline', 'social-javascript', 'social-javascript-outline', 'social-linkedin', 'social-linkedin-outline', 'social-markdown', 'social-nodejs', 'social-octocat', 'social-pinterest', 'social-pinterest-outline', 'social-python', 'social-reddit', 'social-reddit-outline', 'social-rss', 'social-rss-outline', 'social-sass', 'social-skype', 'social-skype-outline', 'social-snapchat', 'social-snapchat-outline', 'social-tumblr', 'social-tumblr-outline', 'social-tux', 'social-twitch', 'social-twitch-outline', 'social-twitter', 'social-twitter-outline', 'social-usd', 'social-usd-outline', 'social-vimeo', 'social-vimeo-outline', 'social-whatsapp', 'social-whatsapp-outline', 'social-windows', 'social-windows-outline', 'social-wordpress', 'social-wordpress-outline', 'social-yahoo', 'social-yahoo-outline', 'social-yen', 'social-yen-outline', 'social-youtube', 'social-youtube-outline', 'soup-can', 'soup-can-outline', 'speakerphone', 'speedometer', 'spoon', 'star', 'stats-bars', 'steam', 'stop', 'thermometer', 'thumbsdown', 'thumbsup', 'toggle', 'toggle-filled', 'transgender', 'trash-a', 'trash-b', 'trophy', 'tshirt', 'tshirt-outline', 'umbrella', 'university', 'unlocked', 'upload', 'usb', 'videocamera', 'volume-high', 'volume-low', 'volume-medium', 'volume-mute', 'wand', 'waterdrop', 'wifi', 'wineglass', 'woman', 'wrench', 'xbox:before', 'alert', 'alert-circled', 'android-add', 'android-add-circle', 'android-alarm-clock', 'android-alert', 'android-apps', 'android-archive', 'android-arrow-back', 'android-arrow-down', 'android-arrow-dropdown', 'android-arrow-dropdown-circle', 'android-arrow-dropleft', 'android-arrow-dropleft-circle', 'android-arrow-dropright', 'android-arrow-dropright-circle', 'android-arrow-dropup', 'android-arrow-dropup-circle', 'android-arrow-forward', 'android-arrow-up', 'android-attach', 'android-bar', 'android-bicycle', 'android-boat', 'android-bookmark', 'android-bulb', 'android-bus', 'android-calendar', 'android-call', 'android-camera', 'android-cancel', 'android-car', 'android-cart', 'android-chat', 'android-checkbox', 'android-checkbox-blank', 'android-checkbox-outline', 'android-checkbox-outline-blank', 'android-checkmark-circle', 'android-clipboard', 'android-close', 'android-cloud', 'android-cloud-circle', 'android-cloud-done', 'android-cloud-outline', 'android-color-palette', 'android-compass', 'android-contact', 'android-contacts', 'android-contract', 'android-create', 'android-delete', 'android-desktop', 'android-document', 'android-done', 'android-done-all', 'android-download', 'android-drafts', 'android-exit', 'android-expand', 'android-favorite', 'android-favorite-outline', 'android-film', 'android-folder', 'android-folder-open', 'android-funnel', 'android-globe', 'android-hand', 'android-hangout', 'android-happy', 'android-home', 'android-image', 'android-laptop', 'android-list', 'android-locate', 'android-lock', 'android-mail', 'android-map', 'android-menu', 'android-microphone', 'android-microphone-off', 'android-more-horizontal', 'android-more-vertical', 'android-navigate', 'android-notifications', 'android-notifications-none', 'android-notifications-off', 'android-open', 'android-options', 'android-people', 'android-person', 'android-person-add', 'android-phone-landscape', 'android-phone-portrait', 'android-pin', 'android-plane', 'android-playstore', 'android-print', 'android-radio-button-off', 'android-radio-button-on', 'android-refresh', 'android-remove', 'android-remove-circle', 'android-restaurant', 'android-sad', 'android-search', 'android-send', 'android-settings', 'android-share', 'android-share-alt', 'android-star', 'android-star-half', 'android-star-outline', 'android-stopwatch', 'android-subway', 'android-sunny', 'android-sync', 'android-textsms', 'android-time', 'android-train', 'android-unlock', 'android-upload', 'android-volume-down', 'android-volume-mute', 'android-volume-off', 'android-volume-up', 'android-walk', 'android-warning', 'android-watch', 'android-wifi', 'aperture', 'archive', 'arrow-down-a', 'arrow-down-b', 'arrow-down-c', 'arrow-expand', 'arrow-graph-down-left', 'arrow-graph-down-right', 'arrow-graph-up-left', 'arrow-graph-up-right', 'arrow-left-a', 'arrow-left-b', 'arrow-left-c', 'arrow-move', 'arrow-resize', 'arrow-return-left', 'arrow-return-right', 'arrow-right-a', 'arrow-right-b', 'arrow-right-c', 'arrow-shrink', 'arrow-swap', 'arrow-up-a', 'arrow-up-b', 'arrow-up-c', 'asterisk', 'at', 'backspace', 'backspace-outline', 'bag', 'battery-charging', 'battery-empty', 'battery-full', 'battery-half', 'battery-low', 'beaker', 'beer', 'bluetooth', 'bonfire', 'bookmark', 'bowtie', 'briefcase', 'bug', 'calculator', 'calendar', 'camera', 'card', 'cash', 'chatbox', 'chatbox-working', 'chatboxes', 'chatbubble', 'chatbubble-working', 'chatbubbles', 'checkmark', 'checkmark-circled', 'checkmark-round', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'clipboard', 'clock', 'close', 'close-circled', 'close-round', 'closed-captioning', 'cloud', 'code', 'code-download', 'code-working', 'coffee', 'compass', 'compose', 'connection-bars', 'contrast', 'crop', 'cube', 'disc', 'document', 'document-text', 'drag', 'earth', 'easel', 'edit', 'egg', 'eject', 'email', 'email-unread', 'erlenmeyer-flask', 'erlenmeyer-flask-bubbles', 'eye', 'eye-disabled', 'female', 'filing', 'film-marker', 'fireball', 'flag', 'flame', 'flash', 'flash-off', 'folder', 'fork', 'fork-repo', 'forward', 'funnel', 'gear-a', 'gear-b', 'grid', 'hammer', 'happy', 'happy-outline', 'headphone', 'heart', 'heart-broken', 'help', 'help-buoy', 'help-circled', 'home', 'icecream', 'image', 'images', 'information', 'information-circled', 'ionic', 'ios-alarm', 'ios-alarm-outline', 'ios-albums', 'ios-albums-outline', 'ios-americanfootball', 'ios-americanfootball-outline', 'ios-analytics', 'ios-analytics-outline', 'ios-arrow-back', 'ios-arrow-down', 'ios-arrow-forward', 'ios-arrow-left', 'ios-arrow-right', 'ios-arrow-thin-down', 'ios-arrow-thin-left', 'ios-arrow-thin-right', 'ios-arrow-thin-up', 'ios-arrow-up', 'ios-at', 'ios-at-outline', 'ios-barcode', 'ios-barcode-outline', 'ios-baseball', 'ios-baseball-outline', 'ios-basketball', 'ios-basketball-outline', 'ios-bell', 'ios-bell-outline', 'ios-body', 'ios-body-outline', 'ios-bolt', 'ios-bolt-outline', 'ios-book', 'ios-book-outline', 'ios-bookmarks', 'ios-bookmarks-outline', 'ios-box', 'ios-box-outline', 'ios-briefcase', 'ios-briefcase-outline', 'ios-browsers', 'ios-browsers-outline', 'ios-calculator', 'ios-calculator-outline', 'ios-calendar', 'ios-calendar-outline', 'ios-camera', 'ios-camera-outline', 'ios-cart', 'ios-cart-outline', 'ios-chatboxes', 'ios-chatboxes-outline', 'ios-chatbubble', 'ios-chatbubble-outline', 'ios-checkmark', 'ios-checkmark-empty', 'ios-checkmark-outline', 'ios-circle-filled', 'ios-circle-outline', 'ios-clock', 'ios-clock-outline', 'ios-close', 'ios-close-empty', 'ios-close-outline', 'ios-cloud', 'ios-cloud-download', 'ios-cloud-download-outline', 'ios-cloud-outline', 'ios-cloud-upload', 'ios-cloud-upload-outline', 'ios-cloudy', 'ios-cloudy-night', 'ios-cloudy-night-outline', 'ios-cloudy-outline', 'ios-cog', 'ios-cog-outline', 'ios-color-filter', 'ios-color-filter-outline', 'ios-color-wand', 'ios-color-wand-outline', 'ios-compose', 'ios-compose-outline', 'ios-contact', 'ios-contact-outline', 'ios-copy', 'ios-copy-outline', 'ios-crop', 'ios-crop-strong', 'ios-download', 'ios-download-outline', 'ios-drag', 'ios-email', 'ios-email-outline', 'ios-eye', 'ios-eye-outline', 'ios-fastforward', 'ios-fastforward-outline', 'ios-filing', 'ios-filing-outline', 'ios-film', 'ios-film-outline', 'ios-flag', 'ios-flag-outline', 'ios-flame', 'ios-flame-outline', 'ios-flask', 'ios-flask-outline', 'ios-flower', 'ios-flower-outline', 'ios-folder', 'ios-folder-outline', 'ios-football', 'ios-football-outline', 'ios-game-controller-a', 'ios-game-controller-a-outline', 'ios-game-controller-b', 'ios-game-controller-b-outline', 'ios-gear', 'ios-gear-outline', 'ios-glasses', 'ios-glasses-outline', 'ios-grid-view', 'ios-grid-view-outline', 'ios-heart', 'ios-heart-outline', 'ios-help', 'ios-help-empty', 'ios-help-outline', 'ios-home', 'ios-home-outline', 'ios-infinite', 'ios-infinite-outline', 'ios-information', 'ios-information-empty', 'ios-information-outline', 'ios-ionic-outline', 'ios-keypad', 'ios-keypad-outline', 'ios-lightbulb', 'ios-lightbulb-outline', 'ios-list', 'ios-list-outline', 'ios-location', 'ios-location-outline', 'ios-locked', 'ios-locked-outline', 'ios-loop', 'ios-loop-strong', 'ios-medical', 'ios-medical-outline', 'ios-medkit', 'ios-medkit-outline', 'ios-mic', 'ios-mic-off', 'ios-mic-outline', 'ios-minus', 'ios-minus-empty', 'ios-minus-outline', 'ios-monitor', 'ios-monitor-outline', 'ios-moon', 'ios-moon-outline', 'ios-more', 'ios-more-outline', 'ios-musical-note', 'ios-musical-notes', 'ios-navigate', 'ios-navigate-outline', 'ios-nutrition', 'ios-nutrition-outline', 'ios-paper', 'ios-paper-outline', 'ios-paperplane', 'ios-paperplane-outline', 'ios-partlysunny', 'ios-partlysunny-outline', 'ios-pause', 'ios-pause-outline', 'ios-paw', 'ios-paw-outline', 'ios-people', 'ios-people-outline', 'ios-person', 'ios-person-outline', 'ios-personadd', 'ios-personadd-outline', 'ios-photos', 'ios-photos-outline', 'ios-pie', 'ios-pie-outline', 'ios-pint', 'ios-pint-outline', 'ios-play', 'ios-play-outline', 'ios-plus', 'ios-plus-empty', 'ios-plus-outline', 'ios-pricetag', 'ios-pricetag-outline', 'ios-pricetags', 'ios-pricetags-outline', 'ios-printer', 'ios-printer-outline', 'ios-pulse', 'ios-pulse-strong', 'ios-rainy', 'ios-rainy-outline', 'ios-recording', 'ios-recording-outline', 'ios-redo', 'ios-redo-outline', 'ios-refresh', 'ios-refresh-empty', 'ios-refresh-outline', 'ios-reload', 'ios-reverse-camera', 'ios-reverse-camera-outline', 'ios-rewind', 'ios-rewind-outline', 'ios-rose', 'ios-rose-outline', 'ios-search', 'ios-search-strong', 'ios-settings', 'ios-settings-strong', 'ios-shuffle', 'ios-shuffle-strong', 'ios-skipbackward', 'ios-skipbackward-outline', 'ios-skipforward', 'ios-skipforward-outline', 'ios-snowy', 'ios-speedometer', 'ios-speedometer-outline', 'ios-star', 'ios-star-half', 'ios-star-outline', 'ios-stopwatch', 'ios-stopwatch-outline', 'ios-sunny', 'ios-sunny-outline', 'ios-telephone', 'ios-telephone-outline', 'ios-tennisball', 'ios-tennisball-outline', 'ios-thunderstorm', 'ios-thunderstorm-outline', 'ios-time', 'ios-time-outline', 'ios-timer', 'ios-timer-outline', 'ios-toggle', 'ios-toggle-outline', 'ios-trash', 'ios-trash-outline', 'ios-undo', 'ios-undo-outline', 'ios-unlocked', 'ios-unlocked-outline', 'ios-upload', 'ios-upload-outline', 'ios-videocam', 'ios-videocam-outline', 'ios-volume-high', 'ios-volume-low', 'ios-wineglass', 'ios-wineglass-outline', 'ios-world', 'ios-world-outline', 'ipad', 'iphone', 'ipod', 'jet', 'key', 'knife', 'laptop', 'leaf', 'levels', 'lightbulb', 'link', 'load-a', 'load-b', 'load-c', 'load-d', 'location', 'lock-combination', 'locked', 'log-in', 'log-out', 'loop', 'magnet', 'male', 'man', 'map', 'medkit', 'merge', 'mic-a', 'mic-b', 'mic-c', 'minus', 'minus-circled', 'minus-round', 'model-s', 'monitor', 'more', 'mouse', 'music-note', 'navicon', 'navicon-round', 'navigate', 'network', 'no-smoking', 'nuclear', 'outlet', 'paintbrush', 'paintbucket', 'paper-airplane', 'paperclip', 'pause', 'person', 'person-add', 'person-stalker', 'pie-graph', 'pin', 'pinpoint', 'pizza', 'plane', 'planet', 'play', 'playstation', 'plus', 'plus-circled', 'plus-round', 'podium', 'pound', 'power', 'pricetag', 'pricetags', 'printer', 'pull-request', 'qr-scanner', 'quote', 'radio-waves', 'record', 'refresh', 'reply', 'reply-all', 'ribbon-a', 'ribbon-b', 'sad', 'sad-outline', 'scissors', 'search', 'settings', 'share', 'shuffle', 'skip-backward', 'skip-forward', 'social-android', 'social-android-outline', 'social-angular', 'social-angular-outline', 'social-apple', 'social-apple-outline', 'social-bitcoin', 'social-bitcoin-outline', 'social-buffer', 'social-buffer-outline', 'social-chrome', 'social-chrome-outline', 'social-codepen', 'social-codepen-outline', 'social-css3', 'social-css3-outline', 'social-designernews', 'social-designernews-outline', 'social-dribbble', 'social-dribbble-outline', 'social-dropbox', 'social-dropbox-outline', 'social-euro', 'social-euro-outline', 'social-facebook', 'social-facebook-outline', 'social-foursquare', 'social-foursquare-outline', 'social-freebsd-devil', 'social-github', 'social-github-outline', 'social-google', 'social-google-outline', 'social-googleplus', 'social-googleplus-outline', 'social-hackernews', 'social-hackernews-outline', 'social-html5', 'social-html5-outline', 'social-instagram', 'social-instagram-outline', 'social-javascript', 'social-javascript-outline', 'social-linkedin', 'social-linkedin-outline', 'social-markdown', 'social-nodejs', 'social-octocat', 'social-pinterest', 'social-pinterest-outline', 'social-python', 'social-reddit', 'social-reddit-outline', 'social-rss', 'social-rss-outline', 'social-sass', 'social-skype', 'social-skype-outline', 'social-snapchat', 'social-snapchat-outline', 'social-tumblr', 'social-tumblr-outline', 'social-tux', 'social-twitch', 'social-twitch-outline', 'social-twitter', 'social-twitter-outline', 'social-usd', 'social-usd-outline', 'social-vimeo', 'social-vimeo-outline', 'social-whatsapp', 'social-whatsapp-outline', 'social-windows', 'social-windows-outline', 'social-wordpress', 'social-wordpress-outline', 'social-yahoo', 'social-yahoo-outline', 'social-yen', 'social-yen-outline', 'social-youtube', 'social-youtube-outline', 'soup-can', 'soup-can-outline', 'speakerphone', 'speedometer', 'spoon', 'star', 'stats-bars', 'steam', 'stop', 'thermometer', 'thumbsdown', 'thumbsup', 'toggle', 'toggle-filled', 'transgender', 'trash-a', 'trash-b', 'trophy', 'tshirt', 'tshirt-outline', 'umbrella', 'university', 'unlocked', 'upload', 'usb', 'videocamera', 'volume-high', 'volume-low', 'volume-medium', 'volume-mute', 'wand', 'waterdrop', 'wifi', 'wineglass', 'woman', 'wrench', 'xbox'];

/* harmony default export */ __webpack_exports__["a"] = (list);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Row__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ButtonGroup__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ButtonGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ButtonGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RadioGroup__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Select__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Form__);






/* harmony default export */ __webpack_exports__["a"] = ({
	iviewRow: __WEBPACK_IMPORTED_MODULE_0__Row___default.a,
	iviewButtonGroup: __WEBPACK_IMPORTED_MODULE_1__ButtonGroup___default.a,
	iviewRadioGroup: __WEBPACK_IMPORTED_MODULE_2__RadioGroup___default.a,
	iviewSelect: __WEBPACK_IMPORTED_MODULE_3__Select___default.a,
	iviewForm: __WEBPACK_IMPORTED_MODULE_4__Form___default.a
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Swipe__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Swipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Progress__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Progress__);


/* harmony default export */ __webpack_exports__["a"] = ({
	mintSwipe: __WEBPACK_IMPORTED_MODULE_0__Swipe___default.a,
	mintProgress: __WEBPACK_IMPORTED_MODULE_1__Progress___default.a
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appbar__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__appbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shanGe__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shanGe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shanGe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__textField__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__textField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__textField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FlatButton__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FlatButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FlatButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__iconButton__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__iconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__iconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RaisedButton__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RaisedButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__RaisedButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__floatingActionButton__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__floatingActionButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__floatingActionButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__avatar__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icon__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__list__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__listItem__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__listItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__listItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__grid__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__datePicker__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__datePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__datePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__timePicker__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__timePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__timePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__badge__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__nav__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__tab__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__breadcrumb__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__checkBox__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__checkBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__checkBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__radio__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__switch__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__selectField__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__selectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__selectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pagination__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__slider__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__divider__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__linearProgress__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__linearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__linearProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__circularProgress__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__circularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__circularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__backTop__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__backTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__backTop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__chip__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__chip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__chip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__paper__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__cardHeader__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__cardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__cardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__card__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__subHeader__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__subHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__subHeader__);

































/* harmony default export */ __webpack_exports__["a"] = ({
    appbar: __WEBPACK_IMPORTED_MODULE_0__appbar___default.a,
    shanGe: __WEBPACK_IMPORTED_MODULE_1__shanGe___default.a,
    textField: __WEBPACK_IMPORTED_MODULE_2__textField___default.a,
    FlatButton: __WEBPACK_IMPORTED_MODULE_3__FlatButton___default.a,
    iconButton: __WEBPACK_IMPORTED_MODULE_4__iconButton___default.a,
    RaisedButton: __WEBPACK_IMPORTED_MODULE_5__RaisedButton___default.a,
    FloatingActionButton: __WEBPACK_IMPORTED_MODULE_6__floatingActionButton___default.a,
    avatar: __WEBPACK_IMPORTED_MODULE_7__avatar___default.a,
    icon: __WEBPACK_IMPORTED_MODULE_8__icon___default.a,
    list: __WEBPACK_IMPORTED_MODULE_9__list___default.a,
    listItem: __WEBPACK_IMPORTED_MODULE_10__listItem___default.a,
    grid: __WEBPACK_IMPORTED_MODULE_11__grid___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_12__datePicker___default.a,
    timePicker: __WEBPACK_IMPORTED_MODULE_13__timePicker___default.a,
    badge: __WEBPACK_IMPORTED_MODULE_14__badge___default.a,
    navigation: __WEBPACK_IMPORTED_MODULE_15__nav___default.a,
    tab: __WEBPACK_IMPORTED_MODULE_16__tab___default.a,
    breadcrumb: __WEBPACK_IMPORTED_MODULE_17__breadcrumb___default.a,
    checkBox: __WEBPACK_IMPORTED_MODULE_18__checkBox___default.a,
    radio: __WEBPACK_IMPORTED_MODULE_19__radio___default.a,
    swit: __WEBPACK_IMPORTED_MODULE_20__switch___default.a,
    selectField: __WEBPACK_IMPORTED_MODULE_21__selectField___default.a,
    pagination: __WEBPACK_IMPORTED_MODULE_22__pagination___default.a,
    slider: __WEBPACK_IMPORTED_MODULE_23__slider___default.a,
    divider: __WEBPACK_IMPORTED_MODULE_24__divider___default.a,
    linearProgress: __WEBPACK_IMPORTED_MODULE_25__linearProgress___default.a,
    circularProgress: __WEBPACK_IMPORTED_MODULE_26__circularProgress___default.a,
    backTop: __WEBPACK_IMPORTED_MODULE_27__backTop___default.a,
    chip: __WEBPACK_IMPORTED_MODULE_28__chip___default.a,
    paper: __WEBPACK_IMPORTED_MODULE_29__paper___default.a,
    cardHeader: __WEBPACK_IMPORTED_MODULE_30__cardHeader___default.a,
    card: __WEBPACK_IMPORTED_MODULE_31__card___default.a,
    subHeader: __WEBPACK_IMPORTED_MODULE_32__subHeader___default.a
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        text: {
            type: 'text',
            value: 'Link'
        },
        href: {
            type: 'text',
            value: ''
        },
        target: {
            type: 'selection',
            value: '',
            items: ['_blank', 'self', '_parent', '_top']
        },
        title: {
            type: 'text',
            value: ''
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    // var subContent = getSlotContent(slots) || '&nbsp;'

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<a ' + stringAttr + '>\n                        ' + (attributes.text.value || '&nbsp;') + '\n                    </a>';

    template = template.replace(/text=".*?"/g, ''); //模板字符串中删除text属性


    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {},
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots) || '&nbsp;';
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<br ' + stringAttr + '/>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {},
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots) || '&nbsp;';
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<div ' + stringAttr + '>\n                        ' + (subContent || '&nbsp;') + '\n                    </div>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        src: {
            type: 'text',
            value: './static/img_default.JPG'
        },
        alt: {
            type: 'text',
            value: ''
        },
        width: {
            type: 'text',
            value: ''
        },
        height: {
            type: 'text',
            value: ''
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots) || '&nbsp;';
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<img ' + stringAttr + ' />';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);




var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        text: {
            type: 'text',
            value: ''
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots) || '&nbsp;';
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var text = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(attributes)).text.value || 'Text';
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<span ' + stringAttr + '>' + text + '</span>';

    template = template.replace(/text=".*?"/g, ''); //模板字符串中删除text属性

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Text__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Img__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Br__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Div__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__A__ = __webpack_require__(135);





var obj = {
    Text: __WEBPACK_IMPORTED_MODULE_0__Text__["a" /* default */],
    Img: __WEBPACK_IMPORTED_MODULE_1__Img__["a" /* default */],
    Br: __WEBPACK_IMPORTED_MODULE_2__Br__["a" /* default */],
    Div: __WEBPACK_IMPORTED_MODULE_3__Div__["a" /* default */],
    A: __WEBPACK_IMPORTED_MODULE_4__A__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (obj);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);


var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        text: {
            type: 'text',
            value: '按钮'
        },
        type: {
            type: 'selection',
            items: ['primary', 'error', 'success', 'warning'],
            value: ''
        },
        color: {
            type: 'color',
            value: ''
        },
        size: {
            type: 'selection',
            items: ['normal', 'large', 'small'],
            value: ''
        }
    },
        slots = {
        default: [],
        icon: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mt-badge \n                        ' + stringAttr + '>' + subContent + '\n                            ' + attributes.text.value + '\n                        </mt-badge>';
    //删除自定义非ui属性
    template = template.replace(':text="' + attributes.text.value + '"', '');
    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);


var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        label: {
            type: 'text',
            value: '按钮'
        },
        plain: {
            type: 'boolean',
            value: ''
        },
        type: {
            type: 'selection',
            items: ['default', 'primary', 'danger'],
            value: 'default'
        },
        size: {
            type: 'selection',
            items: ['small', 'normal', 'large'],
            value: ''
        },
        icon: {
            type: 'selection',
            items: ['more', 'back'],
            value: ''
        }
    },
        slots = {
        default: [],
        icon: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mt-button \n                        ' + stringAttr + '>' + subContent + '\n                            ' + attributes.label.value + '\n                        </mt-button>';
    //删除自定义非ui属性
    template = template.replace(':label="' + attributes.label.value + '"', '');
    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        icon: {
            type: 'selection',
            items: ['more', 'back'],
            value: ''
        },
        title: {
            type: 'text',
            value: 'title'
        },
        value: {
            type: 'text',
            value: ''
        },
        label: {
            type: 'text',
            value: ''
        }
    }, 'is-link', {
        type: 'boolean',
        value: false
    }),
        slots = {
        default: [],
        title: [],
        icon: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mt-cell \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mt-cell>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);


var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        type: {
            type: 'selection',
            items: ['text', 'number', 'email', 'url', 'tel', 'date', 'datetime', 'password', 'textarea'],
            value: ''
        },
        label: {
            type: 'text',
            value: 'label'
        },
        value: {
            type: 'text',
            value: ''
        },
        rows: {
            type: 'number',
            value: ''
        },
        placeholder: {
            type: 'text',
            value: ''
        },
        readonly: {
            type: 'text',
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        state: {
            type: 'selection',
            items: ['error', 'success', 'warning'],
            value: ''
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mt-field \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mt-field>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);


var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        title: {
            type: 'text',
            value: 'title'
        },
        fixed: {
            type: 'boolean',
            value: false
        }
    },
        slots = {
        left: [],
        right: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mt-header \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mt-header>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        value: {
            type: 'number',
            value: 0
        },
        barHeight: {
            type: 'number',
            value: 1
        }
    },
        slots = {
        start: [],
        end: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mt-progress \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mt-progress>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        value: {
            type: 'number',
            value: 0
        },
        min: {
            type: 'number',
            value: 0
        },
        max: {
            type: 'number',
            value: 100
        },
        step: {
            type: 'number',
            value: 1
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        barHeight: {
            type: 'number',
            value: 1
        }
    },
        slots = {
        start: [],
        end: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mt-range \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mt-range>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);





var handle = function handle(_attr, _slots, _info) {
    //定义默认属性
    var attributes = {},
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var isFirstCreate = !components.find(function (c) {
        return c.info.id === _info.id;
    });
    var addComponent = function addComponent(_attr, _slots) {
        var info = {
            name: 'Img',
            ui: 'Common',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        //尽量每次getTemplate后都重新获取components，避免里面修改了后造成不同步会报错
        components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
        component.parentId = _info.id;
        components.push(component);
        return component;
    };
    if (isFirstCreate) {
        var img = addComponent();
        slots.default.push({ id: img.info.id });
        _Vue.$store.commit('setState', { components: components });
    }

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mt-swipe-item \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mt-swipe-item>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);




var handle = function handle(_attr, _slots, _ref) {
    var id = _ref.id;

    //定义默认属性
    var attributes = {
        quantity: {
            type: 'number',
            value: 3
        },
        speed: {
            type: 'number',
            value: ''
        },
        auto: {
            type: 'number',
            value: ''
        },
        defaultIndex: {
            type: 'number',
            value: ''
        },
        continuous: {
            type: 'boolean',
            value: true
        },
        showIndicators: {
            type: 'boolean',
            value: true
        },
        prevent: {
            type: 'boolean',
            value: false
        },
        stopPropagation: {
            type: 'boolean',
            value: false
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作
    var max = _attr.quantity ? _attr.quantity.value : attributes.quantity.value;
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var component = components.find(function (c) {
        return c.info.id === id;
    }) || { slots: slots };
    var oldSlots = component.slots;
    var defaul = []; //default 
    var newComponents = [];
    var addComponent = function addComponent(_attr, _slots) {
        var info = {
            name: 'Swipe item',
            ui: 'Mint-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var itemTemplate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        //尽量每次getTemplate后都重新获取components，避免里面修改了后造成不同步会报错
        components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
        itemTemplate.parentId = id;
        newComponents.push(itemTemplate);
        return itemTemplate;
    };
    for (var i = 0; i < max; i++) {
        if (oldSlots.default[i]) {
            defaul.push(oldSlots.default[i]);
        } else {
            defaul.push({ id: addComponent().info.id });
        }
    }
    components.push.apply(components, newComponents);

    //quantity数值减少时，子属性要对应的删除
    var arr = oldSlots.default.filter(function (item) {
        //得到所有要删除的对象
        return defaul.findIndex(function (_ref2) {
            var id = _ref2.id;
            return id === item.id;
        }) === -1;
    });
    arr.forEach(function (_ref3) {
        var id = _ref3.id;

        var index = components.findIndex(function (c) {
            return c.info.id === id;
        });
        components.splice(index, 1);
    });
    slots.default = defaul;
    _Vue.$store.commit('setState', { components: components });

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mt-swipe \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mt-swipe>';
    //删除自定义非ui属性
    template = template.replace(':quantity="' + attributes.quantity.value + '"', '');
    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);


var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        value: {
            type: 'boolean',
            value: false
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mt-switch \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mt-switch>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Header__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Swipe_item__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Swipe__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Range__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Progress__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Cell__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Switch__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Field__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Badge__ = __webpack_require__(141);


var _obj;

// Mint-UI template











var obj = (_obj = {
    Header: __WEBPACK_IMPORTED_MODULE_1__Header__["a" /* default */],
    Button: __WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Swipe item', __WEBPACK_IMPORTED_MODULE_3__Swipe_item__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Swipe', __WEBPACK_IMPORTED_MODULE_4__Swipe__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Range', __WEBPACK_IMPORTED_MODULE_5__Range__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Progress', __WEBPACK_IMPORTED_MODULE_6__Progress__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Cell', __WEBPACK_IMPORTED_MODULE_7__Cell__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Switch', __WEBPACK_IMPORTED_MODULE_8__Switch__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Field', __WEBPACK_IMPORTED_MODULE_9__Field__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Badge', __WEBPACK_IMPORTED_MODULE_10__Badge__["a" /* default */]), _obj);

/* harmony default export */ __webpack_exports__["a"] = (obj);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots, info) {
    //定义默认属性
    var attributes = {
        title: {
            type: 'text',
            value: 'App Bar'
        },
        zDepth: {
            type: 'slider',
            value: 0,
            max: 5,
            min: 0,
            step: 1
        },
        titleClass: {
            type: 'text',
            value: ''
        }
    },
        slots = {
        left: [],
        right: [],
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-appbar \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-appbar>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        backgroundColor: {
            type: 'color',
            value: ''
        },
        color: {
            type: 'color',
            value: ''
        },
        src: {
            type: 'text',
            value: ''
        },
        icon: {
            type: 'icon',
            value: ''
        },
        iconSize: {
            type: 'number',
            value: ''
        },
        size: {
            type: 'number',
            value: ''
        }
    },
        slots = {
        default: []
        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);
    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }
    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-avatar \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-avatar>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        height: {
            type: 'number',
            value: ''
        },
        bottom: {
            type: 'number',
            value: ''
        },
        right: {
            type: 'number',
            value: ''
        },
        duration: {
            type: 'number',
            value: ''
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-back-top \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-back-top>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        content: {
            type: 'text',
            value: 'badge'
        },
        color: {
            type: 'color',
            value: ''
        },
        primary: {
            type: 'boolean',
            value: false
        },
        secondary: {
            type: 'boolean',
            value: false
        },
        circle: {
            type: 'boolean',
            value: false
        },
        badgeClass: {
            type: 'text',
            value: ''
        }
    },
        slots = {
        content: [],
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-badge \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-badge>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        icon: {
            type: 'icon',
            value: ''
        },
        iconClass: {
            type: 'text',
            value: ''
        },
        title: {
            type: 'text',
            value: ''
        },
        titleClass: {
            type: 'text',
            value: ''
        },
        value: {
            type: 'text',
            value: ''
        },
        href: {
            type: 'text',
            value: ''
        },
        tag: {
            type: 'text',
            value: ''
        },
        activeClass: {
            type: 'text',
            value: ''
        },
        exact: {
            type: 'boolean',
            value: false
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-bottom-nav-item \n                    \t' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-bottom-nav-item>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mergeDeep__ = __webpack_require__(5);




// 深度合并

var handle = function handle(_attr, _slots, _ref) {
    var id = _ref.id;

    //定义默认属性
    var attributes = {
        shift: {
            type: 'boolean',
            value: false
        },
        value: {
            type: 'text',
            value: 'nav0'
        },
        column: {
            type: 'number',
            value: 2
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);
    if (attributes.column.value < 0) attributes.column.value = 0;

    //根据组件不同需要做的不同操作
    var max = _attr.column ? _attr.column.value : attributes.column.value;
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var component = components.find(function (c) {
        return c.info.id === id;
    }) || { slots: slots };
    var oldSlots = component.slots;
    var defaul = []; //default 
    var addComponent = function addComponent(_attr, _slots) {
        var info = {
            name: 'Bottom Nav Item',
            ui: 'Muse-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var itemTemplate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        itemTemplate.parentId = id;
        components.push(itemTemplate);
        return itemTemplate;
    };
    for (var i = 0; i < max; i++) {
        if (oldSlots.default[i]) {
            defaul.push(oldSlots.default[i]);
        } else {
            var childAttr = {
                title: {
                    type: 'text',
                    value: 'nav' + i
                },
                value: {
                    type: 'text',
                    value: 'nav' + i
                }
            };
            defaul.push({ id: addComponent(childAttr).info.id });
        }
    }

    //column数值减少时，子属性要对应的删除
    var arr = oldSlots.default.filter(function (item) {
        //得到所有要删除的对象
        return defaul.findIndex(function (_ref2) {
            var id = _ref2.id;
            return id === item.id;
        }) === -1;
    });
    arr.forEach(function (_ref3) {
        var id = _ref3.id;

        var index = components.findIndex(function (c) {
            return c.info.id === id;
        });
        components.splice(index, 1);
    });
    slots.default = defaul;
    _Vue.$store.commit('setState', { components: components });

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-bottom-nav\n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-bottom-nav>';

    //删除自定义非ui属性
    template = template.replace(':column="' + attributes.column.value + '"', '');

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        text: {
            type: 'text',
            value: 'text'
        },
        href: {
            type: 'text',
            value: '#'
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作
    var text = attributes.text.value;

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-breadcrumb-item \n                    \t' + stringAttr + '>\n                        ' + text + '\n                    </mu-breadcrumb-item>';

    //删除自定义非ui属性
    template = template.replace('text="' + text + '"', '');

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mergeDeep__ = __webpack_require__(5);




// 深度合并

var handle = function handle(_attr, _slots, _ref) {
    var id = _ref.id;

    //定义默认属性
    var attributes = {
        column: {
            type: 'number',
            value: 2
        },
        separator: {
            type: 'text',
            value: ''
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);
    if (attributes.column.value < 0) attributes.column.value = 0;

    //根据组件不同需要做的不同操作
    var max = _attr.column ? _attr.column.value : attributes.column.value;
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var component = components.find(function (c) {
        return c.info.id === id;
    }) || { slots: slots };
    var oldSlots = component.slots;
    var defaul = []; //default 
    var addComponent = function addComponent(_attr, _slots) {
        var info = {
            name: 'Breadcrumb Item',
            ui: 'Muse-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var itemTemplate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        itemTemplate.parentId = id;
        components.push(itemTemplate);
        return itemTemplate;
    };
    for (var i = 0; i < max; i++) {
        if (oldSlots.default[i]) {
            defaul.push(oldSlots.default[i]);
        } else {
            defaul.push({ id: addComponent().info.id });
        }
    }

    //column数值减少时，子属性要对应的删除
    var arr = oldSlots.default.filter(function (item) {
        //得到所有要删除的对象
        return defaul.findIndex(function (_ref2) {
            var id = _ref2.id;
            return id === item.id;
        }) === -1;
    });
    arr.forEach(function (_ref3) {
        var id = _ref3.id;

        var index = components.findIndex(function (c) {
            return c.info.id === id;
        });
        components.splice(index, 1);
    });
    slots.default = defaul;
    _Vue.$store.commit('setState', { components: components });

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-breadcrumb\n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-breadcrumb>';

    //删除自定义非ui属性
    template = template.replace(':column="' + attributes.column.value + '"', '');

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);





var handle = function handle(_attr, _slots, _info) {
    //定义默认属性
    var attributes = {},
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var isFirstCreate = !components.find(function (c) {
        return c.info.id === _info.id;
    });
    var addComponent = function addComponent(_attr, _slots) {
        var info = {
            name: 'Flat Button',
            ui: 'Muse-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        //尽量每次getTemplate后都重新获取components，避免里面修改了后造成不同步会报错
        components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
        component.parentId = _info.id;
        components.push(component);
        return component;
    };
    if (isFirstCreate) {
        var img = addComponent();
        slots.default.push({ id: img.info.id });
        _Vue.$store.commit('setState', { components: components });
    }

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-card-actions \n                    ' + stringAttr + '>\n                    ' + (subContent || '&nbsp;') + '\n                </mu-card-actions>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);





var handle = function handle(_attr, _slots, _info) {
    //定义默认属性
    var attributes = {
        title: {
            type: 'text',
            value: 'name'
        },
        titleClass: {
            type: 'text',
            value: ''
        },
        subTitle: {
            type: 'text',
            value: 'other'
        },
        subTitleClass: {
            type: 'text',
            value: ''
        }
    },
        slots = {
        avatar: [],
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var isFirstCreate = !components.find(function (c) {
        return c.info.id === _info.id;
    });
    var addAvatarComponent = function addAvatarComponent(_attr, _slots) {
        var info = {
            name: 'Avatar',
            ui: 'Muse-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var avatarComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        //尽量每次getTemplate后都重新获取components，避免里面修改了后造成不同步会报错
        components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
        avatarComponent.parentId = _info.id;
        components.push(avatarComponent);
        return avatarComponent;
    };
    if (isFirstCreate) {
        var attr = { slot: 'avatar' };
        var avatar = addAvatarComponent(attr);
        slots.avatar.push({ id: avatar.info.id });
        _Vue.$store.commit('setState', { components: components });
    }

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-card-header \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-card-header>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);





var handle = function handle(_attr, _slots, _info) {
    //定义默认属性
    var attributes = {
        title: {
            type: 'text',
            value: 'title'
        },
        titleClass: {
            type: 'text',
            value: ''
        },
        subTitle: {
            type: 'text',
            value: ''
        },
        subTitleClass: {
            type: 'text',
            value: ''
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var isFirstCreate = !components.find(function (c) {
        return c.info.id === _info.id;
    });
    var addComponent = function addComponent(_attr, _slots) {
        var info = {
            name: 'Img',
            ui: 'Common',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        //尽量每次getTemplate后都重新获取components，避免里面修改了后造成不同步会报错
        components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
        component.parentId = _info.id;
        components.push(component);
        return component;
    };
    if (isFirstCreate) {
        var img = addComponent({ height: { type: 'text', value: '200px' } });
        slots.default.push({ id: img.info.id });
        _Vue.$store.commit('setState', { components: components });
    }

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-card-media \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-card-media>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_guid__ = __webpack_require__(4);




var handle = function handle(_attr, _slots, _info) {
    //定义默认属性
    var attributes = {
        text: {
            type: 'text',
            value: '正文'
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-card-text >\n                    ' + attributes.text.value + '\n                </mu-card-text>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_guid__ = __webpack_require__(4);




var handle = function handle(_attr, _slots, _info) {
    //定义默认属性
    var attributes = {
        title: {
            type: 'text',
            value: 'Title'
        },
        titleClass: {
            type: 'text',
            value: ''
        },
        subTitle: {
            type: 'text',
            value: 'subTitle'
        },
        subTitleClass: {
            type: 'text',
            value: ''
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-card-title \n                    ' + stringAttr + ' />';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);





var handle = function handle(_attr, _slots, _info) {
    //定义默认属性
    var attributes = {},
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var isFirstCreate = !components.find(function (c) {
        return c.info.id === _info.id;
    });
    var newComponents = [];
    var addComponent = function addComponent(info) {
        var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info);
        //尽量每次getTemplate后都重新获取components，避免里面修改了后造成不同步会报错
        components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
        component.parentId = _info.id;
        newComponents.push(component);
        return component;
    };
    if (isFirstCreate) {
        //添加card-header组件
        var headerInfo = {
            name: 'Card Header',
            ui: 'Muse-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var header = addComponent(headerInfo);
        slots.default.push({ id: header.info.id });

        //添加car-media组件
        var mediaInfo = {
            name: 'Card Media',
            ui: 'Muse-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var media = addComponent(mediaInfo);
        slots.default.push({ id: media.info.id });

        //添加card-title
        var titleInfo = {
            name: 'Card Title',
            ui: 'Muse-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var title = addComponent(titleInfo);
        slots.default.push({ id: title.info.id });

        //添加card-text
        var textInfo = {
            name: 'Card Text',
            ui: 'Muse-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var text = addComponent(textInfo);
        slots.default.push({ id: text.info.id });

        //添加card-actions
        var actionsInfo = {
            name: 'Card Actions',
            ui: 'Muse-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var actions = addComponent(actionsInfo);
        slots.default.push({ id: actions.info.id });

        components.push.apply(components, newComponents);
        _Vue.$store.commit('setState', { components: components });
    }

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-card \n                    ' + stringAttr + '>\n                    ' + (subContent || '&nbsp;') + '\n                </mu-card>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        name: {
            type: 'text',
            value: ''
        },
        nativeValue: {
            type: 'text',
            value: ''
        },
        label: {
            type: 'text',
            value: 'Checkbox'
        },
        labelLeft: {
            type: 'boolean',
            value: false
        },
        labelClass: {
            type: 'text',
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        uncheckIcon: {
            type: 'icon',
            value: ''
        },
        checkedIcon: {
            type: 'icon',
            value: ''
        },
        iconClass: {
            type: 'itext',
            value: ''
        },
        value: {
            type: 'boolean',
            value: false,
            notBind: true
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-checkbox \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-checkbox>';

    //删除自定义非ui属性
    // template = template.replace(/<label.*?>/g, '')
    // template = template.replace(/<\/label>/g, '')

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);





var handle = function handle(_attr, _slots, _ref) {
    var id = _ref.id;

    //定义默认属性
    var attributes = {
        showDelete: {
            type: 'boolean',
            value: false
        },
        deleteIconClass: {
            type: 'text',
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        backgroundColor: {
            type: 'color',
            value: ''
        },
        color: {
            type: 'color',
            value: ''
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var component = components.find(function (c) {
        return c.info.id === id;
    }) || { slots: slots };
    var oldSlots = component.slots;

    var addAvatarComponent = function addAvatarComponent(_parentId, _attr, _slots) {
        var info = {
            name: 'Avatar',
            ui: 'Muse-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        component.parentId = _parentId;
        components.push(component);
        return component;
    };
    var defaul = []; //default
    if (slots.default[0]) {
        defaul = slots.default;
    } else {
        var attr = {
            icon: {
                type: 'icon',
                value: 'account_circle'
            },
            size: {
                type: 'number',
                value: 32
            }
        };
        defaul.push({
            id: addAvatarComponent(id, attr).info.id
        });
    }

    _Vue.$store.commit('setState', { components: components });
    slots.default = defaul;

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-chip  \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-chip>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        mode: {
            type: 'selection',
            value: '',
            items: ['indeterminate', 'determinate']
        },
        value: {
            type: 'number',
            value: ''
        },
        max: {
            type: 'number',
            value: ''
        },
        min: {
            type: 'number',
            value: ''
        },
        size: {
            type: 'number',
            value: ''
        },
        strokeWidth: {
            type: 'number',
            value: ''
        },
        color: {
            type: 'color',
            value: ''
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-circular-progress \n                    ' + stringAttr + ' />';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        width: {
            type: 'slider',
            value: 20,
            max: 100,
            min: 0,
            step: 5,
            notBind: true //notBind属性告诉模板处理函数，value作为字符串传入，不用v-bind
        },
        tablet: {
            type: 'slider',
            value: 20,
            max: 100,
            min: 0,
            step: 5,
            notBind: true
        },
        desktop: {
            type: 'slider',
            value: 20,
            max: 100,
            min: 0,
            step: 5,
            notBind: true
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots) || '&nbsp;';
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-col \n                    \t' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-col>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        autoOk: {
            type: 'boolean',
            value: false
        },
        okLabel: {
            type: 'text',
            value: ''
        },
        cancelLabel: {
            type: 'text',
            value: ''
        },
        container: {
            type: 'selection',
            value: '',
            items: ['inline', 'dialog']
        },
        disableYearSelection: {
            type: 'boolean',
            value: false
        },
        firstDayOfWeek: {
            type: 'number',
            value: ''
        },
        mode: {
            type: 'selection',
            value: '',
            items: ['portrait', 'landscape']
        },
        format: {
            type: 'text',
            value: ''
        },
        maxDate: {
            type: 'text',
            value: ''
        },
        minDate: {
            type: 'text',
            value: ''
        },
        name: {
            type: 'text',
            value: ''
        },
        label: {
            type: 'text',
            value: ''
        },
        labelFloat: {
            type: 'boolean',
            value: false
        },
        labelClass: {
            type: 'text',
            value: ''
        },
        labelFocusClass: {
            type: 'text',
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        hintText: {
            type: 'text',
            value: ''
        },
        hintTextClass: {
            type: 'text',
            value: ''
        },
        helpText: {
            type: 'text',
            value: ''
        },
        helpTextClass: {
            type: 'text',
            value: ''
        },
        errorText: {
            type: 'text',
            value: ''
        },
        errorColor: {
            type: 'color',
            value: ''
        },
        icon: {
            type: 'icon',
            value: ''
        },
        iconClass: {
            type: 'text',
            value: ''
        },
        fullWidth: {
            type: 'boolean',
            value: false
        },
        underlineShow: {
            type: 'boolean',
            value: false
        },
        underlineClass: {
            type: 'text',
            value: ''
        },
        underlneFocusClass: {
            type: 'text',
            value: ''
        },
        inputClass: {
            type: 'text',
            value: ''
        },
        value: {
            type: 'text',
            value: ''
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-date-picker \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-date-picker>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        inset: {
            type: 'boolean',
            value: false
        },
        shallowInset: {
            type: 'boolean',
            value: false
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-divider  \n                    ' + stringAttr + ' />';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);


var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        label: {
            type: 'text',
            value: '按钮'
        },
        labelPosition: {
            type: 'selection',
            value: '',
            items: ['before', 'after']
        },
        icon: {
            type: 'icon',
            value: ''
        },
        primary: {
            type: 'boolean',
            value: false
        },
        secondary: {
            type: 'boolean',
            value: false
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        type: {
            type: 'selection',
            value: '',
            items: ['submit', 'button', 'reset']
        },
        href: {
            type: 'text',
            value: ''
        },
        target: {
            type: 'selection',
            value: '',
            items: ['_blank', 'self', '_parent', '_top']
        },
        tag: {
            type: 'text',
            value: ''
        },
        exact: {
            type: 'boolean',
            value: false
        },
        backgroundColor: {
            type: 'color',
            value: ''
        },
        color: {
            type: 'color',
            value: ''
        },
        hoverColor: {
            type: 'color',
            value: ''
        },
        rippleColor: {
            type: 'color',
            value: ''
        },
        rippleOpacity: {
            type: 'number',
            value: ''
        }

    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-flat-button \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-flat-button>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);


var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        icon: {
            type: 'icon',
            value: 'add'
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        type: {
            type: 'selection',
            value: '',
            items: ['submit', 'button', 'reset']
        },
        href: {
            type: 'text',
            value: ''
        },
        target: {
            type: 'selection',
            value: '',
            items: ['_blank', 'self', '_parent', '_top']
        },
        tag: {
            type: 'text',
            value: ''
        },
        exact: {
            type: 'boolean',
            value: false
        },
        secondary: {
            type: 'boolean',
            value: false
        },
        mini: {
            type: 'booleam',
            value: false
        },
        backgroundColor: {
            type: 'color',
            value: ''
        }

    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-float-button \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-float-button>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mergeDeep__ = __webpack_require__(5);




// 深度合并

var handle = function handle(_attr, _slots, _ref) {
    var id = _ref.id;

    //定义默认属性
    var attributes = {
        column: {
            type: 'number',
            value: 2,
            children: {}
        },
        gutter: {
            type: 'boolean',
            value: false
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);
    if (attributes.column.value < 0) attributes.column.value = 0;

    //根据组件不同需要做的不同操作
    var max = _attr.column ? _attr.column.value : attributes.column.value;
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var component = components.find(function (c) {
        return c.info.id === id;
    }) || { slots: slots };
    var oldSlots = component.slots;
    var defaul = []; //default 
    var addComponent = function addComponent(_attr, _slots) {
        var info = {
            name: 'Col',
            ui: 'Muse-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var colComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        colComponent.parentId = id;
        components.push(colComponent);
        return colComponent;
    };
    for (var i = 0; i < max; i++) {
        if (oldSlots.default[i]) {
            defaul.push(oldSlots.default[i]);
        } else {
            defaul.push({ id: addComponent().info.id });
        }
    }

    //column数值减少时，子属性要对应的删除
    var arr = oldSlots.default.filter(function (item) {
        //得到所有要删除的对象
        return defaul.findIndex(function (_ref2) {
            var id = _ref2.id;
            return id === item.id;
        }) === -1;
    });
    arr.forEach(function (_ref3) {
        var id = _ref3.id;

        var index = components.findIndex(function (c) {
            return c.info.id === id;
        });
        components.splice(index, 1);
    });
    slots.default = defaul;
    _Vue.$store.commit('setState', { components: components });

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-row\n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-row>';

    //删除自定义非ui属性
    template = template.replace(':column="' + attributes.column.value + '"', '');

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);


var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        icon: {
            type: 'icon',
            value: 'insert_emoticon'
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        type: {
            type: 'selection',
            value: '',
            items: ['submit', 'button', 'reset']
        },
        href: {
            type: 'text',
            value: ''
        },
        target: {
            type: 'selection',
            value: '',
            items: ['_blank', 'self', '_parent', '_top']
        },
        tooltip: {
            type: 'text',
            value: ''
        },
        tooltipPosition: {
            type: 'selection',
            value: '',
            items: ['top-left', 'top-right', 'top-center', 'middle-left', 'middle-right', 'middle-center', 'bottom-left', 'bottom-right', 'bottom-center']
        },
        touch: {
            type: 'boolean',
            value: false
        },
        tag: {
            type: 'text',
            value: ''
        },
        exact: {
            type: 'boolean',
            value: false
        }

    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-icon-button \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-icon-button>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        value: {
            type: 'icon',
            value: 'insert_emoticon'
        },
        size: {
            type: 'number',
            value: ''
        },
        color: {
            type: 'color',
            value: ''
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-icon \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-icon>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        mode: {
            type: 'selection',
            value: '',
            items: ['indeterminate', 'determinate']
        },
        value: {
            type: 'number',
            value: ''
        },
        max: {
            type: 'number',
            value: ''
        },
        min: {
            type: 'number',
            value: ''
        },
        size: {
            type: 'number',
            value: ''
        },
        color: {
            type: 'color',
            value: ''
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-linear-progress \n                    ' + stringAttr + ' />';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        href: {
            type: 'text',
            value: '',
            describ: '相当于 a 标签的 href属性，设置之后会渲染成 a 标签，默认是使用div标签'
        },
        tag: {
            type: 'text',
            value: '',
            describ: '有时候想要 <router-link> 渲染成某种标签，例如 <li>。 于是我们使用 tag prop 类指定何种标签，同样它还是会监听点击，触发导航。'
        },
        activeClass: {
            type: 'text',
            value: '',
            describ: '设置 链接激活时使用的 CSS 类名。默认值可以通过路由的构造选项 linkActiveClass 来全局配置。'
        },
        exact: {
            type: 'text',
            value: '',
            describ: '"是否激活" 默认类名的依据是 inclusive match （全包含匹配）。 举个例子，如果当前的路径是 /a 开头的，那么 <router-link to="/a"> 也会被设置 CSS 类名。'
        },
        target: {
            type: 'text',
            value: '',
            items: ['_blank', 'self', '_parent', '_top'],
            describ: '相当于 a 标签的target属性'
        },
        title: {
            type: 'text',
            value: '',
            describ: 'listItem 的标题文字'
        },
        titleClass: {
            type: 'text',
            value: '',
            describ: '标题文字样式，同 class 绑定方式一致'
        },
        afterText: {
            type: 'text',
            value: '',
            describ: '标题行最右边的文字'
        },
        afterTextClass: {
            type: 'text',
            value: '',
            describ: '标题行最右边的文字样式，同 class 绑定方式一致'
        },
        describeText: {
            type: 'text',
            value: '',
            describ: '大段描述文字'
        },
        describeLine: {
            type: 'number',
            value: '',
            describ: '描述文字行数'
        },
        describeTextClass: {
            type: 'text',
            value: '',
            describ: '描述文字样式，同 class 绑定方式一致'
        },
        inset: {
            type: 'boolean',
            value: false,
            describ: '是否向内缩进, 会调整paddingLeft 为 72px'
        },
        disabled: {
            type: 'boolean',
            value: false,
            describ: '设置为 true ，则不会触发点击事件，没有 focusRipple 和 touchRipple 的效果'
        },
        disableRipple: {
            type: 'boolean',
            value: false,
            describ: '设置为 true , 没有 focusRipple 和 touchRipple 的效果, 但是会触发点击事件'
        },
        value: {
            type: 'text',
            value: '',
            describ: '当 value 和 list 组件的 value 值相等时，组件呈现被选择状态'
        },
        toggleNested: {
            type: 'boolean',
            value: false,
            describ: '是否可以自动切换嵌套列表的显示'
        },
        toggleIconClass: {
            type: 'text',
            value: '',
            describ: '切换显示的图标样式，同 class 绑定方式一致'
        },
        nestedListClass: {
            type: 'text',
            value: '',
            describ: '嵌套列表样式'
        },
        open: {
            type: 'boolean',
            value: false,
            describ: '设为true，显示嵌套的列表'
        }
    },
        slots = {
        left: [],
        leftAvatar: [],
        right: [],
        rightAvatar: [],
        title: [],
        after: [],
        describe: [],
        nested: [],
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots) || '';
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-list-item \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-list-item>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_preview__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_mergeDeep__ = __webpack_require__(5);



// 深度合并

var handle = function handle(_attr, _slots, _ref) {
    var id = _ref.id;

    //定义默认属性
    var attributes = {
        value: {
            type: 'text',
            value: ''
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    // //根据组件不同需要做的不同操作
    // let max = _attr.column ? _attr.column.value : attributes.column.value
    // let components = JSON.parse(JSON.stringify(_Vue.$store.state.components))
    // let component = components.find(c => c.info.id === id) || { slots }
    // let oldSlots = component.slots
    // let defaul = [] //default 格式化插件对default这个字符格式化有问题 就没写全
    // let addComponent = (_attr, _slots) => {
    //     let info = {
    //         name: 'Col',
    //         ui: 'Muse-UI',
    //         id: preview.methods.guid()
    //     }
    //     let colComponent = getTemplate(info, _attr, _slots)
    //     colComponent.parentId = id
    //     components.push(colComponent)
    //     return colComponent
    // }
    // for (let i = 0; i < max; i++) {
    //     if (oldSlots.default[i]) {
    //         defaul.push(oldSlots.default[i])
    //     } else {
    //         defaul.push({ id: addComponent().info.id })
    //     }
    // }

    // //column数值减少时，子属性要对应的删除
    // let arr = oldSlots.default.filter(item => { //得到所有要删除的对象
    //     return defaul.findIndex(({ id }) => id === item.id) === -1
    // })
    // arr.forEach(({ id }) => {
    //     let index = components.findIndex(c => c.info.id === id)
    //     components.splice(index, 1)
    // })
    // slots.default = defaul
    // _Vue.$store.commit('setState', { components: components })

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-list\n                        ' + stringAttr + '>\n                        ' + (subContent || '拖动“列表项”组件到这里') + '\n                    </mu-list>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        href: {
            type: 'text',
            value: '',
            describ: '相当于 a 标签的 href属性，设置之后会渲染成 a 标签，默认是使用div标签'
        },
        tag: {
            type: 'text',
            value: '',
            describ: '有时候想要 <router-link> 渲染成某种标签，例如 <li>。 于是我们使用 tag prop 类指定何种标签，同样它还是会监听点击，触发导航。'
        },
        activeClass: {
            type: 'text',
            value: '',
            describ: '设置 链接激活时使用的 CSS 类名。默认值可以通过路由的构造选项 linkActiveClass 来全局配置。'
        },
        exact: {
            type: 'text',
            value: '',
            describ: '"是否激活" 默认类名的依据是 inclusive match （全包含匹配）。 举个例子，如果当前的路径是 /a 开头的，那么 <router-link to="/a"> 也会被设置 CSS 类名。'
        },
        target: {
            type: 'text',
            value: '',
            items: ['_blank', 'self', '_parent', '_top'],
            describ: '相当于 a 标签的target属性'
        },
        title: {
            type: 'text',
            value: '',
            describ: 'listItem 的标题文字'
        },
        titleClass: {
            type: 'text',
            value: '',
            describ: '标题文字样式，同 class 绑定方式一致'
        },
        afterText: {
            type: 'text',
            value: '',
            describ: '标题行最右边的文字'
        },
        afterTextClass: {
            type: 'text',
            value: '',
            describ: '标题行最右边的文字样式，同 class 绑定方式一致'
        },
        inset: {
            type: 'boolean',
            value: false,
            describ: '是否向内缩进, 会调整paddingLeft 为 72px'
        },
        disableFocusRiple: {
            type: 'boolean',
            value: false
        },
        disabled: {
            type: 'boolean',
            value: false,
            describ: '设置为 true ，则不会触发点击事件，没有 focusRipple 和 touchRipple 的效果'
        },
        leftIcon: {
            type: 'icon',
            value: ''
        },
        leftIconColor: {
            type: 'color',
            value: ''
        },
        leftIconClass: {
            type: 'text',
            value: ''
        },
        rightIcon: {
            type: 'icon',
            value: ''
        },
        rightIconColor: {
            type: 'color',
            value: ''
        },
        rightIconClass: {
            type: 'text',
            value: ''
        },
        nestedMenuClass: {
            type: 'text',
            value: ''
        },
        nextedMenuListClass: {
            type: 'text',
            value: ''
        },
        value: {
            type: 'text',
            value: '',
            describ: '当 value 和 list 组件的 value 值相等时，组件呈现被选择状态'
        },
        nestedMenuValue: {
            type: 'text',
            value: ''
        }
    },
        slots = {
        title: [],
        after: [],
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots) || '';
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-menu-item\n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-menu-item>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        current: {
            type: 'number',
            value: 1
        },
        total: {
            type: 'number',
            value: 10
        },
        pageSize: {
            type: 'number',
            value: 1
        },
        defaultPageSize: {
            type: 'number',
            value: ''
        },
        showSizeChanger: {
            type: 'boolean',
            value: false
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-pagination  \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-pagination >';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        circle: {
            type: 'boolean',
            value: false
        },
        rounded: {
            type: 'boolean',
            value: false
        },
        zDepth: {
            type: 'slider',
            value: 0,
            max: 5,
            min: 0,
            step: 1
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-paper \n                    ' + stringAttr + '>\n                    ' + (subContent || '&nbsp;') + '\n                </mu-paper>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        name: {
            type: 'text',
            value: ''
        },
        nativeValue: {
            type: 'text',
            value: ''
        },
        label: {
            type: 'text',
            value: 'Checkbox'
        },
        labelLeft: {
            type: 'boolean',
            value: false
        },
        labelClass: {
            type: 'text',
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        uncheckIcon: {
            type: 'icon',
            value: ''
        },
        checkedIcon: {
            type: 'icon',
            value: ''
        },
        iconClass: {
            type: 'itext',
            value: ''
        },
        value: {
            type: 'boolean',
            value: false,
            notBind: true
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-radio \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-radio>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);


var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        label: {
            type: 'text',
            value: '按钮'
        },
        labelPosition: {
            type: 'selection',
            value: '',
            items: ['before', 'after']
        },
        icon: {
            type: 'icon',
            value: ''
        },
        primary: {
            type: 'boolean',
            value: false
        },
        secondary: {
            type: 'boolean',
            value: false
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        fullWidth: {
            type: 'boolean',
            value: false
        },
        type: {
            type: 'selection',
            value: '',
            items: ['submit', 'button', 'reset']
        },
        href: {
            type: 'text',
            value: ''
        },
        target: {
            type: 'selection',
            value: '',
            items: ['_blank', 'self', '_parent', '_top']
        },
        tag: {
            type: 'text',
            value: ''
        },
        exact: {
            type: 'boolean',
            value: false
        },
        backgroundColor: {
            type: 'color',
            value: ''
        },
        color: {
            type: 'color',
            value: ''
        },
        hoverColor: {
            type: 'color',
            value: ''
        },
        rippleColor: {
            type: 'color',
            value: ''
        },
        rippleOpacity: {
            type: 'number',
            value: ''
        }

    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-raised-button \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-raised-button>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mergeDeep__ = __webpack_require__(5);




// 深度合并

var handle = function handle(_attr, _slots, _ref) {
    var id = _ref.id;

    //定义默认属性
    var attributes = {
        itemQuantity: {
            type: 'number',
            value: 2
        },
        autoWidth: {
            type: 'boolean',
            value: false
        },
        maxHeight: {
            type: 'number',
            value: ''
        },
        multiple: {
            type: 'boolean',
            value: false
        },
        name: {
            type: 'text',
            value: ''
        },
        label: {
            type: 'text',
            value: ''
        },
        labelFloat: {
            type: 'boolean',
            value: false
        },
        labelClass: {
            type: 'text',
            value: ''
        },
        labelFocusClass: {
            type: 'text',
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        hintText: {
            type: 'text',
            value: ''
        },
        hintTextClass: {
            type: 'text',
            value: ''
        },
        helpText: {
            type: 'text',
            value: ''
        },
        helpTextClass: {
            type: 'text',
            value: ''
        },
        errorText: {
            type: 'text',
            value: ''
        },
        errorColor: {
            type: 'color',
            value: ''
        },
        icon: {
            type: 'icon',
            value: ''
        },
        iconClass: {
            type: 'text',
            value: ''
        },
        fullWidth: {
            type: 'boolean',
            value: false
        },
        underlineShow: {
            type: 'boolean',
            value: false
        },
        underlineClass: {
            type: 'text',
            value: ''
        },
        underlineFocusClass: {
            type: 'text',
            value: ''
        },
        dropDownIconClass: {
            type: 'text',
            value: ''
        },
        value: {
            type: 'text',
            value: ''
        },
        separator: {
            type: 'text',
            value: ''
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);
    if (attributes.itemQuantity.value < 0) attributes.itemQuantity.value = 0;

    //根据组件不同需要做的不同操作
    var max = _attr.itemQuantity ? _attr.itemQuantity.value : attributes.itemQuantity.value;
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var component = components.find(function (c) {
        return c.info.id === id;
    }) || { slots: slots };
    var oldSlots = component.slots;
    var defaul = []; //default 
    var addComponent = function addComponent(_attr, _slots) {
        var info = {
            name: 'Menu Item',
            ui: 'Muse-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var itemTemplate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        itemTemplate.parentId = id;
        components.push(itemTemplate);
        return itemTemplate;
    };
    for (var i = 0; i < max; i++) {
        if (oldSlots.default[i]) {
            defaul.push(oldSlots.default[i]);
        } else {
            var childAttr = {
                title: {
                    type: 'text',
                    value: 'item' + i
                },
                value: {
                    type: 'text',
                    value: 'item' + i
                }
            };
            defaul.push({ id: addComponent(childAttr).info.id });
        }
    }

    //itemQuantity数值减少时，子属性要对应的删除
    var arr = oldSlots.default.filter(function (item) {
        //得到所有要删除的对象
        return defaul.findIndex(function (_ref2) {
            var id = _ref2.id;
            return id === item.id;
        }) === -1;
    });
    arr.forEach(function (_ref3) {
        var id = _ref3.id;

        var index = components.findIndex(function (c) {
            return c.info.id === id;
        });
        components.splice(index, 1);
    });
    slots.default = defaul;
    _Vue.$store.commit('setState', { components: components });

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-select-field\n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-select-field>';

    //删除自定义非ui属性
    template = template.replace(':itemQuantity="' + attributes.itemQuantity.value + '"', '');

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        name: {
            type: 'text',
            value: ''
        },
        max: {
            type: 'number',
            value: ''
        },
        min: {
            type: 'number',
            value: ''
        },
        step: {
            type: 'number',
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        value: {
            type: 'text',
            value: ''
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-slider   \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-slider >';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_guid__ = __webpack_require__(4);




var handle = function handle(_attr, _slots, _info) {
    //定义默认属性
    var attributes = {
        text: {
            type: 'text',
            value: '正文'
        },
        indset: {
            type: 'boolean',
            value: false
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-sub-header >\n                    ' + (subContent || attributes.text.value) + '\n                </mu-sub-header>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        label: {
            type: 'text',
            value: 'Checkbox'
        },
        labelLeft: {
            type: 'boolean',
            value: false
        },
        labelClass: {
            type: 'text',
            value: ''
        },
        trackClass: {
            type: 'text',
            value: ''
        },
        thumbClass: {
            type: 'text',
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        value: {
            type: 'boolean',
            value: false
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-switch \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-switch>';

    //删除自定义非ui属性
    // template = template.replace(/<label.*?>/g, '')
    // template = template.replace(/<\/label>/g, '')

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        icon: {
            type: 'icon',
            value: ''
        },
        iconClass: {
            type: 'text',
            value: ''
        },
        title: {
            type: 'text',
            value: ''
        },
        titleClass: {
            type: 'text',
            value: ''
        },
        value: {
            type: 'text',
            value: ''
        },
        href: {
            type: 'text',
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-tab \n                    \t' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-tab>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_guid__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mergeDeep__ = __webpack_require__(5);





// 深度合并

var handle = function handle(_attr, _slots, _ref) {
    var id = _ref.id;

    //定义默认属性
    var attributes = {
        column: {
            type: 'number',
            value: 2
        },
        row: {
            type: 'number',
            value: 2
        },
        fixedHeader: {
            type: 'boolean',
            value: false
        },
        fixedFooter: {
            type: 'boolean',
            value: false
        },
        height: {
            type: 'text',
            value: ''
        },
        enableSelectAll: {
            type: 'boolean',
            value: false
        },
        allRowsSelected: {
            type: 'boolean',
            value: false
        },
        multiSelectable: {
            type: 'boolean',
            value: false
        },
        selectable: {
            type: 'boolean',
            value: false
        },
        showCheckbox: {
            type: 'boolean',
            value: false
        }
    },
        slots = {
        header: [],
        footer: [],
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(attributes, _attr);
    if (attributes.column.value < 0) attributes.column.value = 0;
    if (attributes.row.value < 0) attributes.row.value = 0;

    // //根据组件不同需要做的不同操作
    var column = _attr.column ? _attr.column.value : attributes.column.value;
    var row = _attr.row ? _attr.row.value : attributes.row.value;
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var component = components.find(function (c) {
        return c.info.id === id;
    }) || { slots: slots };

    var addComponent = function addComponent(info, _parentId, _attr, _slots) {
        var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        component.parentId = _parentId;
        components.push(component);
        _Vue.$store.commit('setState', { components: components });
        return component;
    };

    var header = void 0,
        th = [];
    //得到header组件
    if (slots.header[0]) {
        header = components.find(function (c) {
            return c.info.id === slots.header[0].id;
        });
    } else {
        header = addComponent({ name: 'Thead', ui: 'Muse-UI', id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_guid__["a" /* default */])() }, id);
    }

    //设置表头
    var headerSlots = header.slots.default;
    for (var i = 0; i < column; i++) {
        if (headerSlots[i]) {
            th.push(headerSlots[i]);
        } else {
            var thId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_guid__["a" /* default */])();
            //添加要嵌入到th中的text组件
            var text = addComponent({ name: 'Text', ui: 'Common', id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_guid__["a" /* default */])() }, thId, { text: { type: 'text', value: '表头' + i } });
            var thSlots = { default: [{ id: text.info.id }]
                //添加th组件
            };var thComponent = addComponent({ name: 'Th', ui: 'Muse-UI', id: thId }, header.info.id, {}, thSlots);
            //push到th数组
            th.push({ id: thComponent.info.id });
        }
    }

    var headerIndex = components.findIndex(function (c) {
        return c.info.id === header.info.id;
    });
    //保存到components的header组件中
    components[headerIndex].slots.default = th;

    var body = void 0,
        tr = [];
    //得到body组件
    if (slots.default[0]) {
        body = components.find(function (c) {
            return c.info.id === slots.default[0].id;
        });
    } else {
        body = addComponent({ name: 'Tbody', ui: 'Muse-UI', id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_guid__["a" /* default */])() }, id);
    }

    var addColumn = function addColumn(column, parentId) {
        var td = [];
        for (var j = 0; j < column; j++) {
            var tdId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_guid__["a" /* default */])();
            var _text = addComponent({ name: 'Text', ui: 'Common', id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_guid__["a" /* default */])() }, tdId);
            var tdSlots = { default: [{ id: _text.info.id }] };
            var tdComponent = addComponent({ name: 'Td', ui: 'Muse-UI', id: tdId }, parentId, {}, tdSlots);
            td.push({ id: tdId });
        }
        return td;
    };

    var _loop = function _loop(_i) {
        if (body.slots.default[_i]) {
            var index = components.findIndex(function (c) {
                return c.info.id === body.slots.default[_i].id;
            });
            var len = components[index].slots.default.length;
            //行未改变，列增加的情况
            if (len < column) {
                var td = addColumn(column - len, components[index].info.id);
                components[index].slots.default.push.apply(components[index].slots.default, td);
            }
            //行未改变，列减少了的情况
            if (len > column) {
                var arr = components[index].slots.default.splice(column, len - column); //删除自身不需要的 并返回删除的
                var _slots2 = { default: arr //构造slots传入递归删除
                };del(_slots2);
            }
            if (column == 0) //为0时跳出本次循环，不往tr中push
                return 'break';
            tr.push(body.slots.default[_i]);
        } else {
            var trId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_guid__["a" /* default */])();
            var _td = addColumn(column, trId);
            var trComponent = addComponent({ name: 'Tr', ui: 'Muse-UI', id: trId }, body.info.id, {}, { default: _td });
            tr.push({ id: trComponent.info.id });
        }
    };

    for (var _i = 0; _i < row; _i++) {
        var _ret = _loop(_i);

        if (_ret === 'break') break;
    }

    var bodyIndex = components.findIndex(function (c) {
        return c.info.id === body.info.id;
    });
    components[bodyIndex].slots.default = tr;

    // 递归删除要删除组件的子组件
    function del(slots) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(slots).forEach(function (slot) {
            slots[slot].forEach(function (slot) {
                var index = components.findIndex(function (c) {
                    return c.info.id === slot.id;
                });
                var child = components.find(function (c) {
                    return c.info.id === slot.id;
                });
                components.splice(index, 1);
                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(child.slots)) del(child.slots);
            });
        });
    }
    //column数值减少时，子属性要对应的删除
    function reduce(_slots, _slot) {
        var arr = _slots.filter(function (item) {
            //得到所有要删除的对象
            return _slot.findIndex(function (_ref2) {
                var id = _ref2.id;
                return id === item.id;
            }) === -1;
        });
        arr.forEach(function (_ref3) {
            var id = _ref3.id;

            var component = components.find(function (c) {
                return c.info.id === id;
            });
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(component.slots)) {
                del(component.slots);
            }
            var index = components.findIndex(function (c) {
                return c.info.id === id;
            });
            components.splice(index, 1);
        });
    }
    reduce(headerSlots, th);
    reduce(body.slots.default, tr);

    //设置table的slots
    slots.header = [{ id: header.info.id }];
    slots.default = [{ id: body.info.id }];
    _Vue.$store.commit('setState', { components: components });

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }
    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-table \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-table>';
    //删除自定义非ui属性
    template = template.replace(':column="' + attributes.column.value + '"\n:row="' + attributes.row.value + '"', '');

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mergeDeep__ = __webpack_require__(5);




// 深度合并

var handle = function handle(_attr, _slots, _ref) {
    var id = _ref.id;

    //定义默认属性
    var attributes = {
        column: {
            type: 'number',
            value: 2
        },
        lineClass: {
            type: 'text',
            value: ''
        },
        value: {
            type: 'text',
            value: 'tab0'
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);
    if (attributes.column.value < 0) attributes.column.value = 0;

    //根据组件不同需要做的不同操作
    var max = _attr.column ? _attr.column.value : attributes.column.value;
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var component = components.find(function (c) {
        return c.info.id === id;
    }) || { slots: slots };
    var oldSlots = component.slots;
    var defaul = []; //default 
    var addComponent = function addComponent(_attr, _slots) {
        var info = {
            name: 'Tab',
            ui: 'Muse-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var itemTemplate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        itemTemplate.parentId = id;
        components.push(itemTemplate);
        return itemTemplate;
    };
    for (var i = 0; i < max; i++) {
        if (oldSlots.default[i]) {
            defaul.push(oldSlots.default[i]);
        } else {
            var childAttr = {
                title: {
                    type: 'text',
                    value: 'tab' + i
                },
                value: {
                    type: 'text',
                    value: 'tab' + i
                }
            };
            defaul.push({ id: addComponent(childAttr).info.id });
        }
    }

    //column数值减少时，子属性要对应的删除
    var arr = oldSlots.default.filter(function (item) {
        //得到所有要删除的对象
        return defaul.findIndex(function (_ref2) {
            var id = _ref2.id;
            return id === item.id;
        }) === -1;
    });
    arr.forEach(function (_ref3) {
        var id = _ref3.id;

        var index = components.findIndex(function (c) {
            return c.info.id === id;
        });
        components.splice(index, 1);
    });
    slots.default = defaul;
    _Vue.$store.commit('setState', { components: components });

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-tabs\n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-tabs>';

    //删除自定义非ui属性
    template = template.replace(':column="' + attributes.column.value + '"', '');

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {},
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots) || '&nbsp;';
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-tbody\n                    \t' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-tbody>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        name: {
            type: 'text',
            value: ''
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots) || '&nbsp;';
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-td\n                    \t' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-td>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);


var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        name: {
            type: 'text',
            value: ''
        },
        type: {
            type: 'selection',
            value: 'text',
            items: ['text', 'password', 'email', 'url', 'number']
        },
        icon: {
            type: 'icon',
            value: ''
        },
        iconClass: {
            type: 'text',
            value: ''
        },
        label: {
            type: 'text',
            value: ''
        },
        labelFloat: {
            type: 'boolean',
            value: false
        },
        labelClass: {
            type: 'text',
            value: ''
        },
        labelFocusClass: {
            type: 'text',
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        hintText: {
            type: 'text',
            value: '提示文字'
        },
        hintTextClass: {
            type: 'text',
            value: ''
        },
        helpText: {
            type: 'text',
            value: ''
        },
        helpTextClass: {
            type: 'text',
            value: ''
        },
        errorText: {
            type: 'text',
            value: ''
        },
        errorColor: {
            type: 'color',
            value: ''
        },
        fullWidth: {
            type: 'boolean',
            value: false
        },
        underlineShow: {
            type: 'boolean',
            value: false
        },
        underlineClass: {
            type: 'text',
            value: ''
        },
        underlineFocusClass: {
            type: 'text',
            value: ''
        },
        inputClass: {
            type: 'text',
            value: ''
        },
        multiLine: {
            type: 'boolean',
            value: false
        },
        rows: {
            type: 'number',
            value: ''
        },
        rowsMax: {
            type: 'number',
            value: ''
        },
        maxLength: {
            type: 'number',
            value: ''
        },
        value: {
            type: 'text',
            value: ''
        },
        max: {
            type: 'number',
            value: ''
        },
        min: {
            type: 'number',
            value: ''
        },
        required: {
            type: 'boolean',
            value: false
        }

    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-text-field \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-text-field>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {},
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots) || '&nbsp;';
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-tfoot\n                    \t' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-tfoot>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_guid__ = __webpack_require__(4);




var handle = function handle(_attr, _slots, _ref) {
    var id = _ref.id;

    //定义默认属性
    var attributes = {
        tooltip: {
            type: 'text',
            value: ''
        },
        tooltipPosition: {
            type: 'selection',
            value: '',
            items: ['top-left', 'top-right', 'top-center', 'middle-left', 'middle-right', 'middle-center', 'bottom-left', 'bottom-right', 'bottom-center']
        },
        touch: {
            type: 'boolean',
            value: false
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots) || '&nbsp;';
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-th\n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-th>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {},
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots) || '&nbsp;';
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-thead><mu-tr \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                        </mu-tr></mu-thead>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        autoOk: {
            type: 'boolean',
            value: false
        },
        okLabel: {
            type: 'text',
            value: ''
        },
        cancelLabel: {
            type: 'text',
            value: ''
        },
        container: {
            type: 'selection',
            value: '',
            items: ['inline', 'dialog']
        },
        mode: {
            type: 'selection',
            value: '',
            items: ['portrait', 'landscape']
        },
        format: {
            type: 'text',
            value: ''
        },
        label: {
            type: 'text',
            value: ''
        },
        labelFloat: {
            type: 'boolean',
            value: false
        },
        labelClass: {
            type: 'text',
            value: ''
        },
        labelFocusClass: {
            type: 'text',
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        hintText: {
            type: 'text',
            value: ''
        },
        hintTextClass: {
            type: 'text',
            value: ''
        },
        helpText: {
            type: 'text',
            value: ''
        },
        helpTextClass: {
            type: 'text',
            value: ''
        },
        errorText: {
            type: 'text',
            value: ''
        },
        errorColor: {
            type: 'color',
            value: ''
        },
        icon: {
            type: 'icon',
            value: ''
        },
        iconClass: {
            type: 'text',
            value: ''
        },
        fullWidth: {
            type: 'boolean',
            value: false
        },
        underlineShow: {
            type: 'boolean',
            value: false
        },
        underlineClass: {
            type: 'text',
            value: ''
        },
        underlneFocusClass: {
            type: 'text',
            value: ''
        },
        inputClass: {
            type: 'text',
            value: ''
        },
        value: {
            type: 'text',
            value: ''
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-time-picker \n                    ' + stringAttr + '>\n                    ' + subContent + '\n                </mu-time-picker>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        selectable: {
            type: 'boolean',
            value: false
        },
        selected: {
            type: 'boolean',
            value: false
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots) || '&nbsp;';
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<mu-tr\n                    \t' + stringAttr + '>\n                        ' + subContent + '\n                    </mu-tr>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_Bar__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Grid__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Col__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Text_Field__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Flat_Button__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Raised_Button__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon_Button__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Floating_Action_Button__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Avatar__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__List__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__List_Item__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Table__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Thead__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Tbody__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Tfoot__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Td__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Th__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Tr__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Date_Picker__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Time_Picker__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Badge__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Bottom_Nav__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Bottom_Nav_Item__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Tabs__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Tab__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Breadcrumb__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Breadcrumb_Item__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Checkbox__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Radio__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Switch__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Select_Field__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Menu_Item__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Pagination__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Slider__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Divider__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Linear_Progress__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Circular_Progress__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Back_Top__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Chip__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Icon__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Paper__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Card__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Card_Actions__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Card_Header__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Card_Media__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Card_Text__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Card_Title__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Sub_Header__ = __webpack_require__(187);


var _obj;


















































var obj = (_obj = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'App Bar', __WEBPACK_IMPORTED_MODULE_1__App_Bar__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Grid', __WEBPACK_IMPORTED_MODULE_2__Grid__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Col', __WEBPACK_IMPORTED_MODULE_3__Col__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Text Field', __WEBPACK_IMPORTED_MODULE_4__Text_Field__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Flat Button', __WEBPACK_IMPORTED_MODULE_5__Flat_Button__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Raised Button', __WEBPACK_IMPORTED_MODULE_6__Raised_Button__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Icon Button', __WEBPACK_IMPORTED_MODULE_7__Icon_Button__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Floating Action Button', __WEBPACK_IMPORTED_MODULE_8__Floating_Action_Button__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Avatar', __WEBPACK_IMPORTED_MODULE_9__Avatar__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'List', __WEBPACK_IMPORTED_MODULE_10__List__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'List Item', __WEBPACK_IMPORTED_MODULE_11__List_Item__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Table', __WEBPACK_IMPORTED_MODULE_12__Table__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Thead', __WEBPACK_IMPORTED_MODULE_13__Thead__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Tbody', __WEBPACK_IMPORTED_MODULE_14__Tbody__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Tfoot', __WEBPACK_IMPORTED_MODULE_15__Tfoot__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Td', __WEBPACK_IMPORTED_MODULE_16__Td__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Th', __WEBPACK_IMPORTED_MODULE_17__Th__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Tr', __WEBPACK_IMPORTED_MODULE_18__Tr__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Date Picker', __WEBPACK_IMPORTED_MODULE_19__Date_Picker__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Time Picker', __WEBPACK_IMPORTED_MODULE_20__Time_Picker__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Badge', __WEBPACK_IMPORTED_MODULE_21__Badge__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Bottom Nav', __WEBPACK_IMPORTED_MODULE_22__Bottom_Nav__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Bottom Nav Item', __WEBPACK_IMPORTED_MODULE_23__Bottom_Nav_Item__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Tabs', __WEBPACK_IMPORTED_MODULE_24__Tabs__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Tab', __WEBPACK_IMPORTED_MODULE_25__Tab__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Breadcrumb', __WEBPACK_IMPORTED_MODULE_26__Breadcrumb__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Breadcrumb Item', __WEBPACK_IMPORTED_MODULE_27__Breadcrumb_Item__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Checkbox', __WEBPACK_IMPORTED_MODULE_28__Checkbox__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Radio', __WEBPACK_IMPORTED_MODULE_29__Radio__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Switch', __WEBPACK_IMPORTED_MODULE_30__Switch__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Select Field', __WEBPACK_IMPORTED_MODULE_31__Select_Field__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Menu Item', __WEBPACK_IMPORTED_MODULE_32__Menu_Item__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Pagination', __WEBPACK_IMPORTED_MODULE_33__Pagination__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Slider', __WEBPACK_IMPORTED_MODULE_34__Slider__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Divider', __WEBPACK_IMPORTED_MODULE_35__Divider__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Linear Progress', __WEBPACK_IMPORTED_MODULE_36__Linear_Progress__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Circular Progress', __WEBPACK_IMPORTED_MODULE_37__Circular_Progress__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Back Top', __WEBPACK_IMPORTED_MODULE_38__Back_Top__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Chip', __WEBPACK_IMPORTED_MODULE_39__Chip__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Icon', __WEBPACK_IMPORTED_MODULE_40__Icon__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Paper', __WEBPACK_IMPORTED_MODULE_41__Paper__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Card', __WEBPACK_IMPORTED_MODULE_42__Card__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Card Actions', __WEBPACK_IMPORTED_MODULE_43__Card_Actions__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Card Header', __WEBPACK_IMPORTED_MODULE_44__Card_Header__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Card Media', __WEBPACK_IMPORTED_MODULE_45__Card_Media__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Card Text', __WEBPACK_IMPORTED_MODULE_46__Card_Text__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Card Title', __WEBPACK_IMPORTED_MODULE_47__Card_Title__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_obj, 'Sub Header', __WEBPACK_IMPORTED_MODULE_48__Sub_Header__["a" /* default */]), _obj);

/* harmony default export */ __webpack_exports__["a"] = (obj);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);




var handle = function handle(_attr, _slots) {
    var _attributes;

    //定义默认属性
    var attributes = (_attributes = {
        label: {
            type: 'text',
            value: 'Button'
        },
        type: {
            type: 'selection',
            items: ['primary', 'ghost', 'dashed', 'text', 'info', 'success', 'warning', 'error'],
            value: ''
        },
        size: {
            type: 'selection',
            items: ['large', 'small', ''],
            value: ''
        },
        shape: {
            type: 'selection',
            items: ['circle', ''],
            value: ''
        },
        long: {
            type: 'boolean',
            value: false
        }
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'html-type', {
        type: 'selection',
        items: ['button', 'submit', 'reset'],
        value: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'disabled', {
        type: 'boolean',
        value: false
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'loading', {
        type: 'boolean',
        value: false
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'icon', {
        type: 'ionicon',
        value: ''
    }), _attributes),
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Button \n                        ' + stringAttr + '>\n                        ' + (subContent || attributes.label.value) + '\n                    </Button>';

    //删除自定义非ui属性
    template = template.replace('label="' + attributes.label.value + '"', '');

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mergeDeep__ = __webpack_require__(5);




// 深度合并

var handle = function handle(_attr, _slots, _ref) {
    var id = _ref.id;

    //定义默认属性
    var attributes = {
        quantity: {
            type: 'number',
            value: 2,
            children: {}
        },
        size: {
            type: 'selection',
            items: ['large', 'small', ''],
            value: ''
        },
        shape: {
            type: 'selection',
            items: ['circle', ''],
            value: ''
        },
        vertical: {
            type: 'boolean',
            value: false
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);
    if (attributes.quantity.value < 0) attributes.quantity.value = 0;

    //根据组件不同需要做的不同操作
    var max = _attr.quantity ? _attr.quantity.value : attributes.quantity.value;
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var component = components.find(function (c) {
        return c.info.id === id;
    }) || { slots: slots };
    var oldSlots = component.slots;
    var defaul = []; //default 
    var addComponent = function addComponent(_attr, _slots) {
        var info = {
            name: 'Button',
            ui: 'iView-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var colComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        colComponent.parentId = id;
        components.push(colComponent);
        return colComponent;
    };
    for (var i = 0; i < max; i++) {
        if (oldSlots.default[i]) {
            defaul.push(oldSlots.default[i]);
        } else {
            defaul.push({ id: addComponent().info.id });
        }
    }

    //quantity数值减少时，子属性要对应的删除
    var arr = oldSlots.default.filter(function (item) {
        //得到所有要删除的对象
        return defaul.findIndex(function (_ref2) {
            var id = _ref2.id;
            return id === item.id;
        }) === -1;
    });
    arr.forEach(function (_ref3) {
        var id = _ref3.id;

        var index = components.findIndex(function (c) {
            return c.info.id === id;
        });
        components.splice(index, 1);
    });
    slots.default = defaul;
    _Vue.$store.commit('setState', { components: components });

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Button-group\n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </Button-group>';

    //删除自定义非ui属性
    template = template.replace(':quantity="' + attributes.quantity.value + '"', '');

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);




var handle = function handle(_attr, _slots) {
    var _attributes;

    //定义默认属性
    var attributes = (_attributes = {
        value: {
            type: 'boolean',
            value: false
        },
        label: {
            type: 'text',
            value: 'label'
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        indeterminate: {
            type: 'boolean',
            value: false
        }
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'true-value', {
        type: 'boolean',
        value: false
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'false-value', {
        type: 'boolean',
        value: false
    }), _attributes),
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Checkbox \n                        ' + stringAttr + '>\n                        ' + (subContent || attributes.label.value) + '\n                    </Checkbox>';
    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        span: {
            type: 'slider',
            value: 10,
            max: 24,
            min: 0,
            step: 1
        },
        order: {
            type: 'number',
            value: ''
        },
        offset: {
            type: 'number',
            value: ''
        },
        push: {
            type: 'number',
            value: ''
        },
        xs: {
            type: 'number',
            value: ''
        },
        sm: {
            type: 'number',
            value: ''
        },
        md: {
            type: 'number',
            value: ''
        },
        lg: {
            type: 'number',
            value: ''
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots) || '&nbsp;';
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Col \n                    \t' + stringAttr + '>\n                        ' + subContent + '\n                    </Col>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        value: {
            type: 'text',
            value: ''
        },
        type: {
            type: 'selection',
            items: ['date', 'daterange', 'datetime', 'datetimerange', 'year', 'month'],
            value: ''
        },
        format: {
            type: 'text',
            value: ''
        },
        placement: {
            type: 'selection',
            items: ['toptop', 'starttop', 'endbottombottom', 'startbottom', 'endleftleft', 'startleft', 'endrightright', 'startright', 'end'],
            value: ''
        },
        placeholder: {
            type: 'text',
            value: ''
        },
        confirm: {
            type: 'boolean',
            value: false
        },
        open: {
            type: 'boolean',
            value: false
        },
        size: {
            type: 'selection',
            items: ['large', 'small', ''],
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        clearable: {
            type: 'boolean',
            value: false
        },
        readonly: {
            type: 'boolean',
            value: false
        },
        editable: {
            type: 'boolean',
            value: false
        },
        transfer: {
            type: 'boolean',
            value: false
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Date-picker \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </Date-picker>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_guid__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mergeDeep__ = __webpack_require__(5);





// 深度合并

var handle = function handle(_attr, _slots, _ref) {
    var _attributes;

    var id = _ref.id;

    //定义默认属性
    var attributes = (_attributes = {
        quantity: {
            type: 'number',
            value: 2
        },
        model: {},
        rules: {},
        inline: {
            type: 'boolean',
            value: false
        }
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_attributes, 'label-position', {
        type: 'selection',
        items: ['left', 'right', 'top'],
        value: ''
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_attributes, 'label-width', {
        type: 'number',
        value: ''
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_attributes, 'show-message', {
        type: 'boolean',
        value: false
    }), _attributes),
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);
    if (attributes.quantity.value < 0) attributes.quantity.value = 0;

    //根据组件不同需要做的不同操作
    var max = _attr.quantity ? _attr.quantity.value : attributes.quantity.value;
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var component = components.find(function (c) {
        return c.info.id === id;
    }) || { slots: slots };
    var oldSlots = component.slots;
    var defaul = []; //default 
    var addComponent = function addComponent(_attr, _slots) {
        var info = {
            name: 'FormItem',
            ui: 'iView-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_guid__["a" /* default */])()
        };
        var colComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        colComponent.parentId = id;
        components.push(colComponent);
        return colComponent;
    };
    for (var i = 0; i < max; i++) {
        if (oldSlots.default[i]) {
            defaul.push(oldSlots.default[i]);
        } else {
            defaul.push({ id: addComponent().info.id });
        }
    }

    //quantity数值减少时，子属性要对应的删除
    var arr = oldSlots.default.filter(function (item) {
        //得到所有要删除的对象
        return defaul.findIndex(function (_ref2) {
            var id = _ref2.id;
            return id === item.id;
        }) === -1;
    });
    arr.forEach(function (_ref3) {
        var id = _ref3.id;

        var index = components.findIndex(function (c) {
            return c.info.id === id;
        });
        components.splice(index, 1);
    });
    slots.default = defaul;
    _Vue.$store.commit('setState', { components: components });

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Form\n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </Form>';

    //删除自定义非ui属性
    template = template.replace(':quantity="' + attributes.quantity.value + '"', '');

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);




var handle = function handle(_attr, _slots) {
    var _attributes;

    //定义默认属性
    var attributes = (_attributes = {
        prop: {
            type: 'text',
            value: ''
        },
        label: {
            type: 'text',
            value: ''
        }
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'label-width', {
        type: 'number',
        value: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'required', {
        type: 'boolean',
        value: false
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'rules', {
        type: 'number',
        value: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'error', {
        type: 'text',
        value: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'show-message', {
        type: 'text',
        value: ''
    }), _attributes),
        slots = {
        default: [],
        label: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Button \n                        ' + stringAttr + '>\n                        ' + (subContent || '&nbsp;') + '\n                    </Button>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        type: {
            type: 'ionicon',
            value: 'happy-outline'
        },
        size: {
            type: 'number',
            value: ''
        },
        color: {
            type: 'color',
            value: ''
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Icon \n                    \t' + stringAttr + '>\n                        ' + subContent + '\n                    </Icon>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        type: {
            type: 'selection',
            items: ['text', 'password', 'textarea'],
            value: ''
        },
        value: {
            type: 'text',
            value: ''
        },
        size: {
            type: 'selection',
            items: ['large', 'small', ''],
            value: ''
        },
        placeholder: {
            type: 'text',
            value: ''
        },
        readonly: {
            type: 'text',
            value: ''
        },
        maxlength: {
            type: 'number',
            value: ''
        },
        icon: {
            type: 'ionicon',
            value: ''
        },
        rows: {
            type: 'number',
            value: ''
        },
        autosize: {
            type: 'boolean',
            value: false
        },
        number: {
            type: 'boolean',
            value: ''
        },
        autofoucs: {
            type: 'boolean',
            value: false
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Input \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </Input>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        max: {
            type: 'number',
            value: ''
        },
        min: {
            type: 'number',
            value: ''
        },
        value: {
            type: 'number',
            value: ''
        },
        step: {
            type: 'number',
            value: ''
        },
        size: {
            type: 'selection',
            items: ['large', 'small', ''],
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Input-number \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </Input-number>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        label: {
            type: 'text',
            value: 'Option'
        },
        value: {
            type: 'text',
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Option \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </Option>';
    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);




var handle = function handle(_attr, _slots) {
    var _attributes;

    //定义默认属性
    var attributes = (_attributes = {
        value: {
            type: 'boolean',
            value: false
        },
        label: {
            type: 'text',
            value: 'label'
        },
        disabled: {
            type: 'text',
            value: ''
        }
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'true-value', {
        type: 'text',
        value: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'false-value', {
        type: 'text',
        value: ''
    }), _attributes),
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Radio \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </Radio>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mergeDeep__ = __webpack_require__(5);




// 深度合并

var handle = function handle(_attr, _slots, _ref) {
    var id = _ref.id;

    //定义默认属性
    var attributes = {
        quantity: {
            type: 'number',
            value: 2
        },
        value: {
            type: 'text',
            value: ''
        },
        type: {
            type: 'selection',
            items: ['button', ''],
            value: ''
        },
        size: {
            type: 'selection',
            items: ['large', 'small', ''],
            value: ''
        },
        vertical: {
            type: 'boolean',
            value: false
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);
    if (attributes.quantity.value < 0) attributes.quantity.value = 0;

    //根据组件不同需要做的不同操作
    var max = _attr.quantity ? _attr.quantity.value : attributes.quantity.value;
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var component = components.find(function (c) {
        return c.info.id === id;
    }) || { slots: slots };
    var oldSlots = component.slots;
    var defaul = []; //default 
    var addComponent = function addComponent(_attr, _slots) {
        var info = {
            name: 'Radio',
            ui: 'iView-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var colComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        colComponent.parentId = id;
        components.push(colComponent);
        return colComponent;
    };
    for (var i = 0; i < max; i++) {
        if (oldSlots.default[i]) {
            defaul.push(oldSlots.default[i]);
        } else {
            defaul.push({ id: addComponent().info.id });
        }
    }

    //quantity数值减少时，子属性要对应的删除
    var arr = oldSlots.default.filter(function (item) {
        //得到所有要删除的对象
        return defaul.findIndex(function (_ref2) {
            var id = _ref2.id;
            return id === item.id;
        }) === -1;
    });
    arr.forEach(function (_ref3) {
        var id = _ref3.id;

        var index = components.findIndex(function (c) {
            return c.info.id === id;
        });
        components.splice(index, 1);
    });
    slots.default = defaul;
    _Vue.$store.commit('setState', { components: components });

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Radio-group\n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </Radio-group>';

    //删除自定义非ui属性
    template = template.replace(':quantity="' + attributes.quantity.value + '"', '');

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);




var handle = function handle(_attr, _slots) {
    var _attributes;

    //定义默认属性
    var attributes = (_attributes = {
        count: {
            type: 'number',
            value: ''
        },
        value: {
            type: 'number',
            value: ''
        }
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'allow-harf', {
        type: 'boolean',
        value: false
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'disabled', {
        type: 'boolean',
        value: false
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'show-text', {
        type: 'boolean',
        value: false
    }), _attributes),
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Rate \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </Rate>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_guid__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_mergeDeep__ = __webpack_require__(5);




// 深度合并

var handle = function handle(_attr, _slots, _ref) {
    var id = _ref.id;

    //定义默认属性
    var attributes = {
        column: {
            type: 'number',
            value: 2,
            children: {}
        },
        gutter: {
            type: 'number',
            value: ''
        },
        type: {
            type: 'selection',
            items: ['', 'flex'],
            value: ''
        },
        align: {
            type: 'selection',
            items: ['top', 'middle', 'bottom'],
            value: ''
        },
        justify: {
            type: 'selection',
            items: ['start', 'end', 'center', 'space-around', 'space-between'],
            value: ''
        }
    },
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);
    if (attributes.column.value < 0) attributes.column.value = 0;

    //根据组件不同需要做的不同操作
    var max = _attr.column ? _attr.column.value : attributes.column.value;
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var component = components.find(function (c) {
        return c.info.id === id;
    }) || { slots: slots };
    var oldSlots = component.slots;
    var defaul = []; //default 
    var addComponent = function addComponent(_attr, _slots) {
        var info = {
            name: 'Col',
            ui: 'iView-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_guid__["a" /* default */])()
        };
        var colComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        colComponent.parentId = id;
        components.push(colComponent);
        return colComponent;
    };
    for (var i = 0; i < max; i++) {
        if (oldSlots.default[i]) {
            defaul.push(oldSlots.default[i]);
        } else {
            defaul.push({ id: addComponent().info.id });
        }
    }

    //column数值减少时，子属性要对应的删除
    var arr = oldSlots.default.filter(function (item) {
        //得到所有要删除的对象
        return defaul.findIndex(function (_ref2) {
            var id = _ref2.id;
            return id === item.id;
        }) === -1;
    });
    arr.forEach(function (_ref3) {
        var id = _ref3.id;

        var index = components.findIndex(function (c) {
            return c.info.id === id;
        });
        components.splice(index, 1);
    });
    slots.default = defaul;
    _Vue.$store.commit('setState', { components: components });

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Row\n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </Row>';

    //删除自定义非ui属性
    template = template.replace(':column="' + attributes.column.value + '"', '');

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_template__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_guid__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_mergeDeep__ = __webpack_require__(5);





// 深度合并

var handle = function handle(_attr, _slots, _ref) {
    var _attributes;

    var id = _ref.id;

    //定义默认属性
    var attributes = (_attributes = {
        quantity: {
            type: 'number',
            value: 2,
            children: {}
        },
        value: {
            type: 'text',
            value: ''
        },
        multiple: {
            type: 'boolean',
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        clearable: {
            type: 'boolean',
            value: false
        },
        filterable: {
            type: 'boolean',
            value: false
        },
        remote: {
            type: 'boolean',
            value: false
        },
        loading: {
            type: 'boolean',
            value: false
        }
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_attributes, 'loading-text', {
        type: 'text',
        value: ''
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_attributes, 'label', {
        type: 'text',
        value: 'label'
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_attributes, 'size', {
        type: 'selection',
        items: ['large', 'small', ''],
        value: ''
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_attributes, 'placeholder', {
        type: 'text',
        value: 'Select'
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_attributes, 'not-found-text', {
        type: 'text',
        value: ''
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_attributes, 'label-in-value', {
        type: 'boolean',
        value: false
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_attributes, 'placement', {
        type: 'selection',
        items: ['bottom', 'top'],
        value: ''
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_attributes, 'transfer', {
        type: 'boolean',
        value: false
    }), _attributes),
        slots = {
        default: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(attributes, _attr);
    if (attributes.quantity.value < 0) attributes.quantity.value = 0;

    //根据组件不同需要做的不同操作
    var max = _attr.quantity ? _attr.quantity.value : attributes.quantity.value;
    var components = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_Vue.$store.state.components));
    var component = components.find(function (c) {
        return c.info.id === id;
    }) || { slots: slots };
    var oldSlots = component.slots;
    var defaul = []; //default 
    var addComponent = function addComponent(_attr, _slots) {
        var info = {
            name: 'Option',
            ui: 'iView-UI',
            id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_guid__["a" /* default */])()
        };
        var colComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_template__["a" /* getTemplate */])(info, _attr, _slots);
        colComponent.parentId = id;
        components.push(colComponent);
        return colComponent;
    };
    for (var i = 0; i < max; i++) {
        if (oldSlots.default[i]) {
            defaul.push(oldSlots.default[i]);
        } else {
            defaul.push({ id: addComponent({ value: { type: 'text', value: i + '' } }).info.id });
        }
    }

    //quantity数值减少时，子属性要对应的删除
    var arr = oldSlots.default.filter(function (item) {
        //得到所有要删除的对象
        return defaul.findIndex(function (_ref2) {
            var id = _ref2.id;
            return id === item.id;
        }) === -1;
    });
    arr.forEach(function (_ref3) {
        var id = _ref3.id;

        var index = components.findIndex(function (c) {
            return c.info.id === id;
        });
        components.splice(index, 1);
    });
    slots.default = defaul;
    _Vue.$store.commit('setState', { components: components });

    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_template__["c" /* getSlotContent */])(slots);

    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Select\n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </Select>';

    //删除自定义非ui属性
    template = template.replace(':quantity="' + attributes.quantity.value + '"', '');

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_template__ = __webpack_require__(1);




var handle = function handle(_attr, _slots) {
    var _attributes;

    //定义默认属性
    var attributes = (_attributes = {
        value: {
            type: 'slider',
            value: 0,
            max: _attr.max ? _attr.max.value : 100,
            min: _attr.min ? _attr.min.value : 0,
            step: _attr.step ? _attr.step.value : 1
        },
        max: {
            type: 'number',
            value: ''
        },
        min: {
            type: 'number',
            value: ''
        },
        step: {
            type: 'number',
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        }
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'show-input', {
        type: 'boolean',
        value: false
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'show-stops', {
        type: 'boolean',
        value: false
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'show-tip', {
        type: 'boolean',
        value: false
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_attributes, 'tip-format', {
        type: 'boolean',
        value: false
    }), _attributes),
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Slider \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </Slider>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        value: {
            type: 'text',
            value: ''
        },
        type: {
            type: 'selection',
            items: ['time', 'timerange'],
            value: ''
        },
        format: {
            type: 'text',
            value: ''
        },
        placement: {
            type: 'selection',
            items: ['toptop', 'starttop', 'endbottombottom', 'startbottom', 'endleftleft', 'startleft', 'endrightright', 'startright', 'end'],
            value: ''
        },
        placeholder: {
            type: 'text',
            value: ''
        },
        confirm: {
            type: 'boolean',
            value: false
        },
        open: {
            type: 'boolean',
            value: false
        },
        size: {
            type: 'selection',
            items: ['large', 'small', ''],
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        },
        clearable: {
            type: 'boolean',
            value: false
        },
        readonly: {
            type: 'boolean',
            value: false
        },
        editable: {
            type: 'boolean',
            value: false
        },
        transfer: {
            type: 'boolean',
            value: false
        }
    },
        slots = {};

    //覆盖默认属性
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<Time-picker \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </Time-picker>';

    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_template__ = __webpack_require__(1);



var handle = function handle(_attr, _slots) {
    //定义默认属性
    var attributes = {
        value: {
            type: 'boolean',
            value: false
        },
        size: {
            type: ['large', 'small', ''],
            value: ''
        },
        disabled: {
            type: 'boolean',
            value: false
        }
    },
        slots = {
        open: [],
        close: []

        //覆盖默认属性
    };__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(slots, _slots);
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(attributes, _attr);

    //根据组件不同需要做的不同操作


    //获取插槽模板内容
    var subContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["c" /* getSlotContent */])(slots);
    //设置当前组件的slot
    if (attributes.slot && attributes.slot !== 'default') {
        attributes.slot = {
            type: 'text',
            value: attributes.slot
        };
    } else {
        attributes.slot = {
            type: 'text',
            value: ''
        };
    }

    //字符串模板操作
    var stringAttr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__components_template__["b" /* getStringTypeAttr */])(attributes);
    var template = '<i-switch \n                        ' + stringAttr + '>\n                        ' + subContent + '\n                    </i-switch>';
    return { template: template, attributes: attributes, slots: slots };
};
/* harmony default export */ __webpack_exports__["a"] = (handle);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Row__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Col__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ButtonGroup__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Input__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Radio__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RadioGroup__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Checkbox__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__iSwitch__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Select__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Option__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Slider__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DatePicker__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TimePicker__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__InputNumber__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Rate__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Form__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__FormItem__ = __webpack_require__(207);




















var obj = {
    Row: __WEBPACK_IMPORTED_MODULE_0__Row__["a" /* default */],
    Col: __WEBPACK_IMPORTED_MODULE_1__Col__["a" /* default */],
    Button: __WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */],
    ButtonGroup: __WEBPACK_IMPORTED_MODULE_3__ButtonGroup__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_4__Icon__["a" /* default */],
    Input: __WEBPACK_IMPORTED_MODULE_5__Input__["a" /* default */],
    Radio: __WEBPACK_IMPORTED_MODULE_6__Radio__["a" /* default */],
    RadioGroup: __WEBPACK_IMPORTED_MODULE_7__RadioGroup__["a" /* default */],
    Checkbox: __WEBPACK_IMPORTED_MODULE_8__Checkbox__["a" /* default */],
    iSwitch: __WEBPACK_IMPORTED_MODULE_9__iSwitch__["a" /* default */],
    Select: __WEBPACK_IMPORTED_MODULE_10__Select__["a" /* default */],
    Option: __WEBPACK_IMPORTED_MODULE_11__Option__["a" /* default */],
    Slider: __WEBPACK_IMPORTED_MODULE_12__Slider__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_13__DatePicker__["a" /* default */],
    TimePicker: __WEBPACK_IMPORTED_MODULE_14__TimePicker__["a" /* default */],
    InputNumber: __WEBPACK_IMPORTED_MODULE_15__InputNumber__["a" /* default */],
    Rate: __WEBPACK_IMPORTED_MODULE_16__Rate__["a" /* default */],
    Form: __WEBPACK_IMPORTED_MODULE_17__Form__["a" /* default */],
    FormItem: __WEBPACK_IMPORTED_MODULE_18__FormItem__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (obj);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_global_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_global_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_style_css__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_muse_ui__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_muse_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_muse_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_muse_ui_dist_muse_ui_css__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_muse_ui_dist_muse_ui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_muse_ui_dist_muse_ui_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_highlightjs__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_highlightjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_highlightjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pretty__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pretty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pretty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_leancloud_storage__ = __webpack_require__(72);







//iView-UI

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_iview___default.a);

//Mint-UI


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$toast = __WEBPACK_IMPORTED_MODULE_6_mint_ui__["Toast"];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$indicator = __WEBPACK_IMPORTED_MODULE_6_mint_ui__["Indicator"];

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_mint_ui___default.a);

//Muse-UI


// import '@/assets/css/theme-dark.css'
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_muse_ui___default.a);

//为代码文本提供高亮、缩进

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_highlightjs___default.a);
//为代码文本格式化

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$prettyDom = __WEBPACK_IMPORTED_MODULE_11_pretty___default.a;

//云数据库

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$lean = __WEBPACK_IMPORTED_MODULE_12__utils_leancloud_storage__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$compile = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].compile;

window._Vue = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(533),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(276)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(531),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1d2a3b03",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(284)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(570),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a945f026",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(278)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(542),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-30d23758",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(277)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(541),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-302ef9b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(282)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(563),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76cbf021",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(546),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(560),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(536),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(565),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(534),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(554),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(285)
}
var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(575),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-db262a12",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(549),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(552),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(545),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(524),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(557),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(553),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(525),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(551),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(538),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(556),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(568),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(564),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(544),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(574),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(567),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(559),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(535),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(569),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(558),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(572),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(543),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(540),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(529),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(539),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(573),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(527),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(571),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(555),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(537),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(526),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(562),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(532),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(550),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(279)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(547),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-391ccdb7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(561),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-avatar', [_vm._v("头")]), _vm._v(" "), _c('label', [_vm._v("头像")])], 1)
},staticRenderFns: []}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-breadcrumb', [_c('mu-breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("层")]), _vm._v(" "), _c('mu-breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("级")]), _vm._v(" "), _c('mu-breadcrumb-item', [_vm._v("结构")])], 1)
},staticRenderFns: []}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-switch', {
    attrs: {
      "label": "开关"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-select-field', {
    attrs: {
      "label": "选择框",
      "value": "index"
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "value": "index",
      "title": "选择框"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-pagination', {
    attrs: {
      "total": 5,
      "current": 2
    }
  })
},staticRenderFns: []}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('mu-appbar', [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n            Vue-Layout\n            "), _c('mu-badge', {
    staticClass: "description",
    attrs: {
      "content": "可视化布局 ",
      "color": "#f06292"
    }
  })], 1), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "share"
    },
    on: {
      "click": function($event) {
        _vm.share.open = true
      }
    },
    slot: "right"
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "settings"
    },
    on: {
      "click": function($event) {
        _vm.setting.open = true
      }
    },
    slot: "right"
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": ":iconfont icon-github",
      "href": "https://github.com/jaweii/Vue-Layout"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('mu-row', {
    staticClass: "main-content"
  }, [_c('mu-col', {
    staticClass: "attributes",
    attrs: {
      "width": _vm.width.attr,
      "tablet": _vm.width.attr,
      "desktop": _vm.width.attr
    }
  }, [_c('mu-sub-header', {
    staticClass: "header"
  }, [_c('mu-select-field', {
    staticClass: "select-field",
    attrs: {
      "autoWidth": ""
    },
    model: {
      value: (_vm.selectField.value),
      callback: function($$v) {
        _vm.selectField.value = $$v
      },
      expression: "selectField.value"
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "title": "属性",
      "value": "属性"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "组件树",
      "value": "组件树"
    }
  })], 1), _vm._v(" "), _c('span', [(_vm.parentComponent) ? _c('a', {
    staticClass: "parent-component",
    on: {
      "click": _vm.switchComponent
    }
  }, [_vm._v("┡ " + _vm._s(_vm.parentComponent.info.name))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.current.info ? ' - ' + _vm.current.info.name : ''))])], 1), _vm._v(" "), (_vm.selectField.value === '属性') ? _c('attributes', {
    staticClass: "attributes-content"
  }) : _vm._e(), _vm._v(" "), (_vm.selectField.value === '组件树') ? _c('component-tree', {
    staticClass: "component-tree",
    attrs: {
      "components": _vm.$store.state.components.filter(function (c) { return !c.parentId; })
    }
  }) : _vm._e(), _vm._v(" "), (_vm.current.info) ? _c('div', {
    staticClass: "attributes-bottom"
  }, [_c('mu-flat-button', {
    attrs: {
      "label": "UI文档"
    },
    on: {
      "click": _vm.openUiDocument
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": "操作"
    },
    on: {
      "click": _vm.oprate
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "preview",
    attrs: {
      "width": _vm.width.preview,
      "tablet": _vm.width.preview,
      "desktop": _vm.width.preview
    }
  }, [_c('preview', {
    ref: "preview"
  })], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "components",
    attrs: {
      "width": _vm.width.components,
      "tablet": _vm.width.components,
      "desktop": _vm.width.components
    }
  }, [_c('components', {
    ref: "components"
  })], 1)], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.setting.open,
      "title": "设置",
      "scrollable": ""
    },
    on: {
      "close": function($event) {
        _vm.setting.open = false
      }
    }
  }, [_c('br'), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": "选中边框效果"
    },
    on: {
      "change": _vm.setSelectEffect
    },
    model: {
      value: (_vm.setting.selectEffect),
      callback: function($$v) {
        _vm.setting.selectEffect = $$v
      },
      expression: "setting.selectEffect"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "primary": "",
      "label": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.setting.open = false
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.share.open,
      "title": "分享当前布局",
      "scrollable": ""
    },
    on: {
      "close": function($event) {
        _vm.share.open = false
      }
    }
  }, [_c('br'), _vm._v(" "), (!_vm.share.url) ? _c('mu-flat-button', {
    attrs: {
      "label": "点击生成"
    },
    on: {
      "click": _vm.createShare
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "type": "url",
      "disabled": true,
      "hintText": "分享地址",
      "label": "分享地址",
      "fullWidth": ""
    },
    model: {
      value: (_vm.share.url),
      callback: function($$v) {
        _vm.share.url = $$v
      },
      expression: "share.url"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "type": "url",
      "disabled": true,
      "label": "体验地址",
      "hintText": "体验地址",
      "fullWidth": ""
    },
    model: {
      value: (_vm.share.experience),
      callback: function($$v) {
        _vm.share.experience = $$v
      },
      expression: "share.experience"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "primary": "",
      "label": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.share.open = false
      }
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "form",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "hintText": _vm.name
    },
    on: {
      "input": _vm.change
    },
    model: {
      value: (_vm.color),
      callback: function($$v) {
        _vm.color = $$v
      },
      expression: "color"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    ref: "button",
    attrs: {
      "label": "颜色"
    },
    on: {
      "click": _vm.openPopover
    }
  })], 1), _vm._v(" "), _c('mu-popover', {
    attrs: {
      "trigger": _vm.trigger,
      "open": _vm.open
    },
    on: {
      "close": _vm.closePopover
    }
  }, [_c('mu-menu', {
    ref: "content",
    staticClass: "list-content",
    on: {
      "change": _vm.changeMenu
    }
  }, [_c('mu-content-block', [_c('mu-text-field', {
    attrs: {
      "hintText": "搜索",
      "fullWidth": ""
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.colorList), function(color, index) {
    return _c('mu-menu-item', {
      key: index,
      attrs: {
        "title": color.name,
        "value": color.value
      }
    }, [_c('mu-icon', {
      attrs: {
        "value": "color_lens",
        "color": color.value
      },
      slot: "after"
    })], 1)
  })], 2)], 1), _vm._v(" "), (_vm.scroller) ? _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading
    },
    on: {
      "load": _vm.loadMoreMaterialIcon
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-flat-button', {
    staticStyle: {
      "border-bottom": "1px solid gray"
    },
    attrs: {
      "label": "文本框",
      "primary": ""
    }
  })
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-content-block', [(_vm.current) ? _c('subAttribute', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "attributes": _vm.current.attributes
    },
    on: {
      "update": _vm.updateAttribute
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    model: {
      value: (_vm.model1),
      callback: function($$v) {
        _vm.model1 = $$v
      },
      expression: "model1"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }))
},staticRenderFns: []}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_c('mu-icon', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "value": "insert_emoticon",
      "size": 32
    }
  }), _vm._v("图标")], 1)])
},staticRenderFns: []}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Radio-group', {
    attrs: {
      "type": "button"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "Radio"
    }
  }), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "Group"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-sub-header', {
    staticStyle: {
      "transform": "scale(1.2)"
    }
  }, [_vm._v("列表标题")])
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card-header', {
    staticStyle: {
      "transform": "translateX(-12px)"
    },
    attrs: {
      "title": "Name",
      "subTitle": "sub title"
    }
  }, [_c('mu-avatar', {
    attrs: {
      "icon": "person"
    },
    slot: "avatar"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-paper', {
    attrs: {
      "zDepth": 5
    }
  }, [_c('mu-content-block', [_vm._v("\n   \t\t\t阴影容器\n   \t\t")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-bottom-nav', {
    attrs: {
      "value": "nav1"
    }
  }, [_c('mu-bottom-nav-item', {
    attrs: {
      "value": "nav1",
      "title": "nav1",
      "icon": "home"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    attrs: {
      "value": "nav2",
      "title": "nav2",
      "icon": "favorite"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    attrs: {
      "value": "nav3",
      "title": "nav3",
      "icon": "location_on"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "form",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "hintText": _vm.name
    },
    on: {
      "input": _vm.change
    },
    model: {
      value: (_vm.iconName),
      callback: function($$v) {
        _vm.iconName = $$v
      },
      expression: "iconName"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    ref: "button",
    attrs: {
      "label": "图标"
    },
    on: {
      "click": _vm.openPopover
    }
  })], 1), _vm._v(" "), _c('mu-popover', {
    attrs: {
      "trigger": _vm.trigger,
      "open": _vm.open
    },
    on: {
      "close": _vm.closePopover
    }
  }, [_c('mu-menu', {
    ref: "content",
    staticClass: "list-content",
    on: {
      "change": _vm.changeMenu
    }
  }, [_c('mu-content-block', [_c('mu-text-field', {
    attrs: {
      "hintText": "搜索",
      "fullWidth": ""
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.iconList), function(icon, index) {
    return _c('mu-menu-item', {
      key: index,
      attrs: {
        "leftIcon": icon,
        "title": icon,
        "value": icon
      }
    })
  })], 2)], 1), _vm._v(" "), (_vm.scroller) ? _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading
    },
    on: {
      "load": _vm.loadMoreMaterialIcon
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('mu-content-block', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('mu-select-field', {
    attrs: {
      "value": _vm.activeUI,
      "autoWidth": ""
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "title": "Muse-UI",
      "value": "Muse-UI"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "Mint-UI",
      "value": "Mint-UI"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "iView-UI",
      "value": "iView-UI"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "Element-UI",
      "value": "Element-UI"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "通用",
      "value": "Common"
    }
  })], 1), _vm._v(" "), _c('mu-sub-header', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("- 组件")])], 1), _vm._v(" "), (_vm.activeUI === 'Muse-UI') ? _c('div', [_c('ul', {
    staticClass: "components-list"
  }, [_c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "App Bar"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('appbar')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Grid"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('shanGe')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Text Field"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('textField')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Flat Button"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('FlatButton')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Raised Button"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('RaisedButton')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Icon Button"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('iconButton')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Icon"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('icon')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Floating Action Button"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('floatingActionButton')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Avatar"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('avatar')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Chip"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('chip')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Card Header"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('cardHeader')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Sub Header"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('subHeader')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "List"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('list')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "List Item"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('listItem')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Table"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('grid')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Date Picker"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('datePicker')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Time Picker"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('timePicker')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Badge"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('badge')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Bottom Nav"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('navigation')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Tabs"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('tab')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Breadcrumb"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('breadcrumb')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Checkbox"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('checkBox')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Radio"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('radio')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Switch"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('swit')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Select Field"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('selectField')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Paper"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('paper')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Pagination"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('pagination')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Slider"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('slider')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Divider"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('divider')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Linear Progress"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('linearProgress')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Circular Progress"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('circularProgress')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Card"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('card')], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeUI === 'Mint-UI') ? _c('div', [_c('ul', {
    staticClass: "components-list"
  }, [_c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Header"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mt-header', {
    attrs: {
      "fixed": "",
      "title": "Header"
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Button"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mt-button', {
    attrs: {
      "type": "default"
    }
  }, [_vm._v("Button")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Swipe"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mint-swipe')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Range"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mt-range')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Progress"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mint-progress')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Cell"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mt-cell', {
    attrs: {
      "title": "Cell",
      "value": "..."
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Switch"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mt-switch', [_vm._v("Switch")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Field"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mt-field', {
    attrs: {
      "label": "Field",
      "placeholder": "placeholder"
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Badge"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mt-badge', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Badge")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeUI === 'iView-UI') ? _c('div', [_c('ul', {
    staticClass: "components-list iview-ui"
  }, [_c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Row"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('iview-row')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Button"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Button', {
    attrs: {
      "size": "large"
    }
  }, [_vm._v("Button")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "ButtonGroup"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('iview-button-group')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Icon"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Icon', {
    attrs: {
      "type": "happy-outline",
      "size": 28
    }
  }), _vm._v(" icon\n            ")], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Input"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Input"
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Radio"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Radio', [_vm._v("Radio")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "RadioGroup"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('iview-radio-group')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Checkbox"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Checkbox', [_vm._v("Checkbox")])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "iSwitch"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('i-switch')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Select"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('iview-select')], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Slider"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_vm._v("\n                Slider\n                "), _c('Slider', {
    staticStyle: {
      "width": "75%",
      "display": "inline-block",
      "vertical-align": "middle"
    },
    attrs: {
      "value": 50
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "DatePicker"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Date-picker', {
    attrs: {
      "size": "large",
      "type": "date",
      "placeholder": "Date Picker"
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "TimePicker"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Time-picker', {
    attrs: {
      "size": "large",
      "type": "time",
      "placeholder": "Time Picker"
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "InputNumber"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Input-number', {
    attrs: {
      "max": 10,
      "min": 1
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Rate"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('Rate', {
    attrs: {
      "value": 5
    }
  })], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Form"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('iview-form')], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeUI === 'Element-UI') ? _c('div', [_c('ul', {
    staticClass: "components-list"
  })]) : _vm._e(), _vm._v(" "), (_vm.activeUI === 'Common') ? _c('div', [_c('ul', {
    staticClass: "components-list"
  }, [_c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Text"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mu-icon', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "value": "text_fields"
    }
  }), _vm._v(" 文本\n            ")], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "A"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mu-icon', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "value": "link"
    }
  }), _vm._v(" 链接\n            ")], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Img"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "image"
    }
  }), _vm._v(" 图片\n            ")], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Br"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "keyboard_return"
    }
  }), _vm._v(" 换行\n            ")], 1), _vm._v(" "), _c('li', {
    attrs: {
      "draggable": "true",
      "data-name": "Div"
    },
    on: {
      "dragstart": _vm.dragStart
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "check_box_outline_blank"
    }
  }), _vm._v(" div\n            ")], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-avatar', {
    attrs: {
      "icon": "remove"
    }
  }), _vm._v(" "), _c('label', [_vm._v("列表项")])], 1)
},staticRenderFns: []}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-avatar', {
    attrs: {
      "icon": "date_range"
    }
  }), _vm._v(" "), _c('label', [_vm._v("日期选择器")])], 1)
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-appbar', {
    attrs: {
      "title": "导航栏"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Button-group', [_c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "chevron-left"
    }
  }), _vm._v("\n        Backward\n    ")], 1), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("\n        Forward\n        "), _c('Icon', {
    attrs: {
      "type": "chevron-right"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "preview"
  }, [_c('div', {
    ref: "preview",
    staticClass: "preview-mobile"
  }, [_c('previewProduct')], 1)])
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "preview"
  }, [_c('div', {
    ref: "preview",
    staticClass: "preview-area"
  }, _vm._l((_vm.components), function(item, index) {
    return (!item.parentId) ? _c('div', {
      attrs: {
        "id": item.info.id
      }
    }) : _vm._e()
  }))])
},staticRenderFns: []}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-flat-button', {
    staticStyle: {
      "transform": "scale(1.2)"
    },
    attrs: {
      "label": "Flat 按钮"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-avatar', {
    attrs: {
      "icon": "alarm"
    }
  }), _vm._v(" "), _c('label', [_vm._v("时间选择器")])], 1)
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', [_c('mu-card-header', {
    attrs: {
      "title": "Myron",
      "subTitle": "sub title"
    }
  }, [_c('mu-avatar', {
    attrs: {
      "icon": "account_circle"
    },
    slot: "avatar"
  })], 1), _vm._v(" "), _c('mu-card-title', {
    attrs: {
      "title": "Content Title",
      "subTitle": "Content Title"
    }
  }), _vm._v(" "), _c('mu-card-text', [_vm._v("\r\n    正文\r\n  ")]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flat-button', {
    attrs: {
      "label": "Action 1"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-raised-button', {
    attrs: {
      "label": "Raised 按钮"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-badge', {
    attrs: {
      "content": "news",
      "secondary": ""
    }
  }), _vm._v(" "), _c('label', [_vm._v("徽章")])], 1)
},staticRenderFns: []}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mt-progress', {
    attrs: {
      "value": 50,
      "bar-height": 5
    }
  }, [_c('div', {
    slot: "end"
  }, [_vm._v("Progress")])])
},staticRenderFns: []}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n    滑动控件\n    "), _c('mu-slider')], 1)
},staticRenderFns: []}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-checkbox', {
    attrs: {
      "label": "复选框"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-avatar', {
    attrs: {
      "icon": "vertical_align_top"
    }
  }), _vm._v(" "), _c('label', [_vm._v("返回顶部")])], 1)
},staticRenderFns: []}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-linear-progress', {
    attrs: {
      "size": 10,
      "color": "red"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-avatar', {
    attrs: {
      "icon": "grid_on"
    }
  }), _vm._v(" "), _c('label', [_vm._v("表格")])], 1)
},staticRenderFns: []}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Form', {
    ref: "formInline",
    attrs: {
      "model": _vm.formInline,
      "rules": _vm.ruleInline,
      "inline": ""
    }
  }, [_vm._v("\n\tForm\n        "), _c('Form-item', {
    attrs: {
      "prop": "user"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    model: {
      value: (_vm.formInline.user),
      callback: function($$v) {
        _vm.formInline.user = $$v
      },
      expression: "formInline.user"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-person-outline"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    model: {
      value: (_vm.formInline.password),
      callback: function($$v) {
        _vm.formInline.password = $$v
      },
      expression: "formInline.password"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-locked-outline"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("登录")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, _vm._l((_vm.attr), function(v, k, i) {
    return (_vm.attr) ? _c('div', [(v.type === 'text') ? _c('mu-text-field', {
      attrs: {
        "label": k,
        "name": k,
        "type": "text",
        "fullWidth": ""
      },
      nativeOn: {
        "input": function($event) {
          _vm.updateAttribute($event)
        }
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }) : _vm._e(), _vm._v(" "), (v.type === 'number') ? _c('mu-text-field', {
      attrs: {
        "label": k,
        "name": k,
        "type": "number",
        "fullWidth": ""
      },
      nativeOn: {
        "input": function($event) {
          _vm.updateAttribute($event)
        }
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }) : _vm._e(), _vm._v(" "), (v.type === 'slider') ? _c('small', [_vm._v(_vm._s(k + ': ' + v.value))]) : _vm._e(), _vm._v(" "), (v.type === 'slider') ? _c('mu-slider', {
      attrs: {
        "step": v.step,
        "max": v.max,
        "min": v.min
      },
      nativeOn: {
        "mouseup": function($event) {
          _vm.updateAttribute($event)
        }
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }) : _vm._e(), _vm._v(" "), (v.type === 'label') ? _c('div', {
      staticClass: "mu-text-field-label"
    }, [_vm._v(_vm._s(v.value))]) : _vm._e(), _vm._v(" "), (v.type === 'boolean') ? _c('mu-switch', {
      style: ({
        width: '100%',
        marginBottom: '10px'
      }),
      attrs: {
        "label": k,
        "labelLeft": ""
      },
      on: {
        "change": _vm.updateAttribute
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }) : _vm._e(), _vm._v(" "), (v.type === 'selection') ? _c('mu-select-field', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "label": k
      },
      on: {
        "input": _vm.updateAttribute
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }, _vm._l((v.items), function(item, index) {
      return _c('mu-menu-item', {
        key: index,
        attrs: {
          "value": item,
          "title": item
        }
      })
    })) : _vm._e(), _vm._v(" "), (v.type === 'icon') ? _c('iconPicker', {
      attrs: {
        "name": k
      },
      on: {
        "change": _vm.updateAttribute
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }) : _vm._e(), _vm._v(" "), (v.type === 'ionicon') ? _c('ioniconPicker', {
      attrs: {
        "name": k
      },
      on: {
        "change": _vm.updateAttribute
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }) : _vm._e(), _vm._v(" "), (v.type === 'color') ? _c('colorPicker', {
      attrs: {
        "name": k
      },
      on: {
        "change": _vm.updateAttribute
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }) : _vm._e(), _vm._v(" "), (v.children) ? _c('subAttributes', {
      attrs: {
        "keyOfAttr": k,
        "attributes": v.children
      },
      on: {
        "update": _vm.subUpdate
      }
    }) : _vm._e()], 1) : _vm._e()
  }))
},staticRenderFns: []}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-tabs', {
    attrs: {
      "value": "tab1"
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "tab1",
      "title": "TAB1"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab2",
      "title": "TAB2"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab3",
      "title": "TAB3"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "form",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "hintText": _vm.name
    },
    on: {
      "input": _vm.change
    },
    model: {
      value: (_vm.iconName),
      callback: function($$v) {
        _vm.iconName = $$v
      },
      expression: "iconName"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    ref: "button",
    attrs: {
      "label": "图标"
    },
    on: {
      "click": _vm.openPopover
    }
  })], 1), _vm._v(" "), _c('mu-popover', {
    attrs: {
      "trigger": _vm.trigger,
      "open": _vm.open
    },
    on: {
      "close": _vm.closePopover
    }
  }, [_c('mu-menu', {
    ref: "content",
    staticClass: "list-content",
    on: {
      "change": _vm.changeMenu
    }
  }, [_c('mu-content-block', [_c('mu-text-field', {
    attrs: {
      "hintText": "搜索",
      "fullWidth": ""
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.ioniconList), function(icon, index) {
    return _c('mu-list-item', {
      key: index,
      attrs: {
        "title": icon,
        "value": icon
      }
    }, [_c('Icon', {
      attrs: {
        "type": icon,
        "size": 26
      },
      slot: "left"
    })], 1)
  })], 2)], 1), _vm._v(" "), (_vm.scroller) ? _c('mu-infinite-scroll', {
    attrs: {
      "scroller": _vm.scroller,
      "loading": _vm.loading
    },
    on: {
      "load": _vm.loadMoreMaterialIcon
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-circular-progress', {
    attrs: {
      "size": 40
    }
  })
},staticRenderFns: []}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("G")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("R")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_vm._v("D")])], 1)
},staticRenderFns: []}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "preview",
    on: {
      "dragover": _vm.dragOver,
      "drop": _vm.drop
    }
  }, [_c('mu-paper', {
    staticClass: "preview-head"
  }, [_c('div', {
    staticClass: "bar"
  }, [_c('mu-sub-header', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.showType))]), _vm._v(" "), _c('mu-icon-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "fullscreen",
      "tooltip": "全屏"
    },
    on: {
      "click": _vm.fullScreen
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "delete",
      "tooltip": "清空"
    },
    on: {
      "click": _vm.empty
    }
  }), _vm._v(" "), _c('mu-icon-menu', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "stay_current_portrait",
      "tooltip": "视图",
      "targetOrigin": {
        vertical: 'bottom',
        horizontal: 'left'
      }
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "title": "调整比例"
    },
    on: {
      "click": _vm.setWidth
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": _vm.previewMode === 'pc' ? '手机模式' : 'PC模式'
    },
    on: {
      "click": function($event) {
        _vm.previewMode = _vm.previewMode === 'pc' ? 'mobile' : 'pc'
      }
    }
  })], 1), _vm._v(" "), _c('mu-icon-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": ":iconfont icon-css",
      "tooltip": "编辑样式"
    },
    on: {
      "click": _vm.editStyle
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "code",
      "tooltip": "查看代码"
    },
    on: {
      "click": _vm.showCode
    }
  }), _vm._v(" "), (_vm.$store.state.backupComponents.length) ? _c('mu-icon-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "undo",
      "tooltip": "撤销"
    },
    on: {
      "click": _vm.undo
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mu-content-block', {
    class: {
      'content': true, 'active': _vm.showType !== '预览'
    }
  }, [_c('pre', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showType === 'CODE'),
      expression: "showType==='CODE'"
    }, {
      name: "highlightjs",
      rawName: "v-highlightjs",
      value: (_vm.getSource(_vm.components)),
      expression: "getSource(components)"
    }]
  }, [_c('code', {
    staticClass: "html"
  })]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showType === '编辑样式'),
      expression: "showType==='编辑样式'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.css),
      expression: "css"
    }],
    staticClass: "css-editor",
    attrs: {
      "placeholder": ".vue-layout{ ... }"
    },
    domProps: {
      "value": (_vm.css)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.css = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.previewMode === 'pc'),
      expression: "previewMode==='pc'"
    }],
    ref: "preview",
    staticClass: "preview-area",
    on: {
      "click": _vm.clickPreview,
      "contextmenu": _vm.rightClick,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46])) { return null; }
        _vm.del($event)
      }
    }
  }, _vm._l((_vm.components), function(item, index) {
    return (!item.parentId) ? _c('div', {
      attrs: {
        "id": item.info.id
      }
    }) : _vm._e()
  })), _vm._v(" "), (_vm.previewMode === 'mobile') ? _c('iframe', {
    staticClass: "preview-mobile",
    attrs: {
      "src": "./#/preview/mobile"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.components.length === 0) ? _c('mu-content-block', {
    staticClass: "preview-tip"
  }, [_vm._v("\n        试试拖拽组件进来\n    ")]) : _vm._e(), _vm._v(" "), (_vm.current.info) ? _c('mu-popover', {
    attrs: {
      "trigger": _vm.popover.trigger,
      "open": _vm.popover.open
    },
    on: {
      "close": function($event) {
        _vm.popover.open = false
      }
    }
  }, [_c('mu-menu', {
    on: {
      "change": _vm.selectedSlot
    }
  }, [_c('label', [_vm._v("\n                  嵌套到" + _vm._s(_vm.current.info.name) + ":\n            ")]), _vm._v(" "), _vm._l((_vm.current.slots), function(val, key, index) {
    return _c('mu-menu-item', {
      key: index,
      attrs: {
        "title": key,
        "value": key
      }
    })
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "contextmenu",
    style: (_vm.contextmenu.style)
  }), _vm._v(" "), (_vm.current.info) ? _c('mu-popover', {
    attrs: {
      "anchorOrigin": {
        'vertical': 'top',
        'horizontal': 'middle'
      },
      "targetOrigin": {
        'vertical': 'top',
        'horizontal': 'left'
      },
      "trigger": _vm.contextmenu.trigger,
      "open": _vm.contextmenu.open
    },
    on: {
      "close": function($event) {
        _vm.contextmenu.open = false
      }
    }
  }, [_c('mu-content-block', [_vm._v(_vm._s(this.current.info.name))]), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-menu', {
    staticClass: "contextmenu",
    attrs: {
      "autoWidth": ""
    },
    on: {
      "itemClick": function($event) {
        _vm.contextmenu.open = false
      }
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "title": "复制"
    },
    on: {
      "click": _vm.copyComponent
    }
  }), _vm._v(" "), (_vm.$store.state.copiedComponents.length) ? _c('mu-menu-item', {
    attrs: {
      "title": "粘贴"
    },
    on: {
      "click": _vm.pasteComponent
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "title": "删除"
    },
    on: {
      "click": _vm.del
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-float-button', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "icon": "add"
    }
  }), _vm._v(" 浮动按钮\n")], 1)
},staticRenderFns: []}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-chip', {
    attrs: {
      "showDelete": ""
    }
  }, [_c('mu-avatar', {
    attrs: {
      "size": 32,
      "icon": "face"
    }
  }), _vm._v(" icon avatar chip\n    ")], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-flat-button', {
    staticStyle: {
      "transform": "scale(1.2)"
    },
    attrs: {
      "label": "图标按钮",
      "icon": "insert_emoticon"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', _vm._l((_vm.components), function(c) {
    return _c('div', [_c('a', {
      on: {
        "click": function($event) {
          _vm.click(c.info.id)
        }
      }
    }, [_c('mu-icon', {
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "value": _vm.show ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
      },
      on: {
        "click": function($event) {
          _vm.show = !_vm.show
        }
      }
    }), _vm._v("\n            " + _vm._s(c.info.name))], 1), _vm._v(" "), _vm._l((c.slots), function(slot, key) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.show),
          expression: "show"
        }]
      }, [(Object.keys(c.slots).filter(function (slot) { return c.slots[slot].length; }).length) ? _c('componentTree', {
        attrs: {
          "components": _vm.slotToComponents(c.slots[key])
        }
      }) : _vm._e()], 1)
    })], 2)
  }))
},staticRenderFns: []}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "5",
      "tablet": "5",
      "desktop": "5"
    }
  }, [_vm._v("栅")]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "5",
      "tablet": "5",
      "desktop": "5"
    }
  }, [_vm._v("格")]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "5",
      "tablet": "5",
      "desktop": "5"
    }
  }, [_vm._v("布")]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "5",
      "tablet": "5",
      "desktop": "5"
    }
  }, [_vm._v("局")])], 1)
},staticRenderFns: []}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-avatar', {
    attrs: {
      "icon": "list"
    }
  }), _vm._v(" "), _c('label', [_vm._v("列表")])], 1)
},staticRenderFns: []}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-radio', {
    attrs: {
      "label": "单选框"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('mu-divider', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "bottom": "10px",
      "margin": "auto"
    }
  }), _vm._v("   分割线\n")], 1)
},staticRenderFns: []}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mt-swipe', {
    staticClass: "swipe"
  }, [_c('mt-swipe-item', [_vm._v("Swipe")]), _vm._v(" "), _c('mt-swipe-item', [_vm._v("Swipe")]), _vm._v(" "), _c('mt-swipe-item', [_vm._v("Swipe")])], 1)
},staticRenderFns: []}

/***/ })
],[221]);


// WEBPACK FOOTER //
// static/js/app.50876cf7409bafdb0938.js